import { EventEmitter, Directive, ElementRef, Output, HostListener, Input, Pipe, InjectionToken, Injectable, Inject, NgModule, ɵɵdefineInjectable, ɵɵinject, Component, APP_INITIALIZER, Optional, ViewChild, ChangeDetectorRef, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { Router, RouterModule, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EventTypes, PublicEventsService, OidcSecurityService, TokenValidationService, AbstractSecurityStorage, TokenHelperService, AuthModule, OidcConfigService } from 'angular-auth-oidc-client';
import { filter, map, catchError, take, switchMap, publishReplay, refCount, takeUntil, pluck, tap, finalize } from 'rxjs/operators';
import { BehaviorSubject, throwError, Subject, forkJoin, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from 'angular-auth-oidc-client';
import * as ɵngcc4 from '@angular/common/http';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from 'ngx-perfect-scrollbar';

function ForbiddenComponent_a_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r0.fromUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.fromUrl);
} }
function ForbiddenComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 8);
    ɵngcc0.ɵɵlistener("click", function ForbiddenComponent_ng_container_8_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.logout(); });
    ɵngcc0.ɵɵtext(2, "\u0432\u044B\u0439\u0442\u0438");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, ", \u0430 \u0437\u0430\u0442\u0435\u043C \u0432\u043E\u0439\u0442\u0438 \u0441\u043D\u043E\u0432\u0430 \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C. \u0418\u043B\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c0 = ".error[_ngcontent-%COMP%]{width:100%;min-height:100vh;background-color:#1a1a1a}.error__container[_ngcontent-%COMP%]{padding:74px 20px 34px;overflow:hidden}.error__number[_ngcontent-%COMP%]{display:block;font-size:160px;line-height:154px;font-weight:700;color:hsla(0,0%,100%,.05);text-align:left}.error__message[_ngcontent-%COMP%]{margin-top:25px;margin-bottom:0;width:500px;min-height:435px;font-size:20px;font-weight:400;line-height:30px;color:#fff}.error__link[_ngcontent-%COMP%]{font-weight:700;text-decoration:underline}@media (min-width:768px){.error__container[_ngcontent-%COMP%]{display:flex;padding-top:0;padding-right:0;padding-left:0;position:relative;min-width:768px;max-width:1304px;min-height:576px}.error__number[_ngcontent-%COMP%]{position:absolute;left:17px;top:52px;font-size:300px;line-height:288px;font-weight:700;color:hsla(0,0%,100%,.05)}}@media (min-width:768px) and (min-width:1024px){.error__number[_ngcontent-%COMP%]{font-size:480px;line-height:576px}}@media (min-width:768px){.error__message[_ngcontent-%COMP%]{margin-top:205px;margin-left:28px;width:597px;min-height:auto;z-index:1}}@media (min-width:768px) and (min-width:1024px){.error__message[_ngcontent-%COMP%]{margin-top:362px}}@media (min-width:1420px){.error__number[_ngcontent-%COMP%]{font-size:600px;line-height:576px}}@media (min-width:1920px){.error__container[_ngcontent-%COMP%]{max-width:1760px}.error__number[_ngcontent-%COMP%]{left:264px}.error__message[_ngcontent-%COMP%]{margin-top:358px;margin-left:6px}}";
function UnauthorizedComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 6);
    ɵngcc0.ɵɵlistener("click", function UnauthorizedComponent_ng_container_6_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.logout(); });
    ɵngcc0.ɵɵtext(2, "\u0432\u044B\u0439\u0442\u0438");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, ", \u0430 \u0437\u0430\u0442\u0435\u043C \u0432\u043E\u0439\u0442\u0438 \u0441\u043D\u043E\u0432\u0430 \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C. \u0418\u043B\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c1 = ["searchInput"];
function HeaderSearchComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵlistener("click", function HeaderSearchComponent_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); ctx_r2.clickOutside(); return ctx_r2.clear(); });
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 34);
} }
function HeaderComponent_ng_container_0_ul_12_li_1__svg_svg_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 49);
    ɵngcc0.ɵɵelement(1, "path", 50);
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_ul_12_li_1__svg_svg_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 49);
    ɵngcc0.ɵɵelement(1, "path", 51);
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_ul_12_li_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 52);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_ul_12_li_1_div_8_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(4); return ctx_r14.hideAllNotification(); });
    ɵngcc0.ɵɵtext(1, " \u0421\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0435 ");
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_ul_12_li_1_perfect_scrollbar_10_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 55);
    ɵngcc0.ɵɵelementStart(1, "app-notifications", 56);
    ɵngcc0.ɵɵlistener("hideNotification", function HeaderComponent_ng_container_0_ul_12_li_1_perfect_scrollbar_10_li_1_Template_app_notifications_hideNotification_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(5); return ctx_r18.hideNotification($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r17 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("notification", notification_r17);
} }
function HeaderComponent_ng_container_0_ul_12_li_1_perfect_scrollbar_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "perfect-scrollbar", 53);
    ɵngcc0.ɵɵlistener("psYReachEnd", function HeaderComponent_ng_container_0_ul_12_li_1_perfect_scrollbar_10_Template_perfect_scrollbar_psYReachEnd_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(4); return ctx_r20.onScrollDown(); });
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ul_12_li_1_perfect_scrollbar_10_li_1_Template, 2, 1, "li", 54);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("config", ctx_r13.config);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r13.notifications);
} }
function HeaderComponent_ng_container_0_ul_12_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 40);
    ɵngcc0.ɵɵelementStart(1, "a", 41);
    ɵngcc0.ɵɵtext(2, "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 42);
    ɵngcc0.ɵɵelementStart(4, "a", 43);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_ul_12_li_1_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return ctx_r22.toggleSubmenu(null); });
    ɵngcc0.ɵɵtemplate(5, HeaderComponent_ng_container_0_ul_12_li_1__svg_svg_5_Template, 2, 0, "svg", 44);
    ɵngcc0.ɵɵtemplate(6, HeaderComponent_ng_container_0_ul_12_li_1__svg_svg_6_Template, 2, 0, "svg", 44);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 45);
    ɵngcc0.ɵɵtemplate(8, HeaderComponent_ng_container_0_ul_12_li_1_div_8_Template, 2, 0, "div", 46);
    ɵngcc0.ɵɵelementStart(9, "ul", 47);
    ɵngcc0.ɵɵtemplate(10, HeaderComponent_ng_container_0_ul_12_li_1_perfect_scrollbar_10_Template, 2, 2, "perfect-scrollbar", 48);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("header__menu-item--open", ctx_r6.openedSubmenus.includes(null));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r6.openedSubmenus.includes(null));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.openedSubmenus.includes(null));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("header__submenu-list--open", ctx_r6.openedSubmenus.includes(null));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r6.notifications == null ? null : ctx_r6.notifications.length) > 5);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r6.notifications == null ? null : ctx_r6.notifications.length) > 0);
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_a_3__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 49);
    ɵngcc0.ɵɵelement(1, "path", 50);
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_a_3__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 49);
    ɵngcc0.ɵɵelement(1, "path", 51);
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 43);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const item_r24 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r31 = ɵngcc0.ɵɵnextContext(3); return ctx_r31.toggleSubmenu(item_r24.id); });
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_a_3__svg_svg_1_Template, 2, 0, "svg", 44);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_a_3__svg_svg_2_Template, 2, 0, "svg", 44);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r27 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r27.openedSubmenus.includes(item_r24.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r27.openedSubmenus.includes(item_r24.id));
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_ul_4_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 55);
    ɵngcc0.ɵɵelementStart(1, "a", 62);
    ɵngcc0.ɵɵlistener("mousedown", function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_ul_4_li_1_Template_a_mousedown_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r38); const child_r36 = restoredCtx.$implicit; const ctx_r37 = ɵngcc0.ɵɵnextContext(6); return ctx_r37.sendGAEvent(child_r36, $event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r36 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("target", child_r36.isNewTab ? "_blank" : "_self");
    ɵngcc0.ɵɵattribute("href", child_r36.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(child_r36.title);
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_ul_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 45);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_ul_4_li_1_Template, 3, 3, "li", 54);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r28 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("header__submenu-list--open", ctx_r28.openedSubmenus.includes(item_r24.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r24.children);
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 58);
    ɵngcc0.ɵɵelementStart(1, "a", 59);
    ɵngcc0.ɵɵlistener("mousedown", function HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_Template_a_mousedown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const item_r24 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r40 = ɵngcc0.ɵɵnextContext(3); return ctx_r40.sendGAEvent(item_r24, $event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_a_3_Template, 3, 2, "a", 60);
    ɵngcc0.ɵɵtemplate(4, HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_ul_4_Template, 2, 3, "ul", 61);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r26 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("header__menu-item--open", ctx_r26.openedSubmenus.includes(item_r24.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("target", item_r24.isNewTab ? "_blank" : "_self");
    ɵngcc0.ɵɵattribute("href", item_r24.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r24.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (item_r24.children == null ? null : item_r24.children.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (item_r24.children == null ? null : item_r24.children.length) > 0);
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ul_12_ng_container_2_li_1_Template, 5, 7, "li", 57);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r25 = ctx.index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r25 < ctx_r7.menuItemsLimit);
} }
function HeaderComponent_ng_container_0_ul_12_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 63);
    ɵngcc0.ɵɵelementStart(1, "a", 41);
    ɵngcc0.ɵɵtext(2, "\u0415\u0449\u0451");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("header__menu-item--hover", ctx_r8.isAdditionalOpen);
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_a_3__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 49);
    ɵngcc0.ɵɵelement(1, "path", 50);
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_a_3__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 49);
    ɵngcc0.ɵɵelement(1, "path", 51);
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r53 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 43);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r53); const item_r44 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r51 = ɵngcc0.ɵɵnextContext(3); return ctx_r51.toggleSubmenu(item_r44.id); });
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_a_3__svg_svg_1_Template, 2, 0, "svg", 44);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_a_3__svg_svg_2_Template, 2, 0, "svg", 44);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r44 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r47 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r47.openedSubmenus.includes(item_r44.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r47.openedSubmenus.includes(item_r44.id));
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r57 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 55);
    ɵngcc0.ɵɵelementStart(1, "a", 65);
    ɵngcc0.ɵɵlistener("mousedown", function HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_li_5_Template_a_mousedown_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r57); const child_r55 = restoredCtx.$implicit; const ctx_r56 = ɵngcc0.ɵɵnextContext(5); return ctx_r56.sendGAEvent(child_r55, $event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r55 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", child_r55.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(child_r55.title);
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r60 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 58);
    ɵngcc0.ɵɵelementStart(1, "a", 64);
    ɵngcc0.ɵɵlistener("mousedown", function HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_Template_a_mousedown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const item_r44 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r58 = ɵngcc0.ɵɵnextContext(3); return ctx_r58.sendGAEvent(item_r44, $event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_a_3_Template, 3, 2, "a", 60);
    ɵngcc0.ɵɵelementStart(4, "ul", 45);
    ɵngcc0.ɵɵtemplate(5, HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_li_5_Template, 3, 2, "li", 54);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r46 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("header__menu-item--open", ctx_r46.openedSubmenus.includes(item_r44.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", item_r44.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r44.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (item_r44.children == null ? null : item_r44.children.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("header__submenu-list--open", ctx_r46.openedSubmenus.includes(item_r44.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r44.children);
} }
function HeaderComponent_ng_container_0_ul_12_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ul_12_ng_container_5_li_1_Template, 6, 8, "li", 57);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r45 = ctx.index;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r45 >= ctx_r9.menuItemsLimit);
} }
function HeaderComponent_ng_container_0_ul_12_Template(rf, ctx) { if (rf & 1) {
    const _r63 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 35);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ul_12_li_1_Template, 11, 8, "li", 36);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_ng_container_0_ul_12_ng_container_2_Template, 2, 1, "ng-container", 37);
    ɵngcc0.ɵɵtemplate(3, HeaderComponent_ng_container_0_ul_12_li_3_Template, 3, 2, "li", 38);
    ɵngcc0.ɵɵelementStart(4, "div", 39);
    ɵngcc0.ɵɵlistener("mouseover", function HeaderComponent_ng_container_0_ul_12_Template_div_mouseover_4_listener() { ɵngcc0.ɵɵrestoreView(_r63); const ctx_r62 = ɵngcc0.ɵɵnextContext(2); return ctx_r62.isAdditionalOpen = true; })("mouseleave", function HeaderComponent_ng_container_0_ul_12_Template_div_mouseleave_4_listener() { ɵngcc0.ɵɵrestoreView(_r63); const ctx_r64 = ɵngcc0.ɵɵnextContext(2); return ctx_r64.isAdditionalOpen = false; });
    ɵngcc0.ɵɵtemplate(5, HeaderComponent_ng_container_0_ul_12_ng_container_5_Template, 2, 1, "ng-container", 37);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.notifications == null ? null : ctx_r2.notifications.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.navigationNodes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.navigationNodes == null ? null : ctx_r2.navigationNodes.length) > ctx_r2.menuItemsLimit + 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.navigationNodes);
} }
function HeaderComponent_ng_container_0_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r66 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 66);
    ɵngcc0.ɵɵelementStart(1, "div", 67);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_div_13_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r65 = ɵngcc0.ɵɵnextContext(2); return ctx_r65.toggleSearch(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 68);
    ɵngcc0.ɵɵelementStart(3, "g", 69);
    ɵngcc0.ɵɵelement(4, "path", 70);
    ɵngcc0.ɵɵelement(5, "path", 71);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("header__search--open", ctx_r3.isSearchOpen);
} }
function HeaderComponent_ng_container_0_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 80);
} }
function HeaderComponent_ng_container_0_div_14_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r72 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 81);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_div_14_div_5_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r72); const ctx_r71 = ɵngcc0.ɵɵnextContext(3); return ctx_r71.hideAllNotification(); });
    ɵngcc0.ɵɵtext(1, " \u0421\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0435 ");
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_div_14_div_6_app_notifications_2_Template(rf, ctx) { if (rf & 1) {
    const _r76 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "app-notifications", 56);
    ɵngcc0.ɵɵlistener("hideNotification", function HeaderComponent_ng_container_0_div_14_div_6_app_notifications_2_Template_app_notifications_hideNotification_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r76); const ctx_r75 = ɵngcc0.ɵɵnextContext(4); return ctx_r75.hideNotification($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r74 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("notification", notification_r74);
} }
function HeaderComponent_ng_container_0_div_14_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r78 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 82);
    ɵngcc0.ɵɵelementStart(1, "perfect-scrollbar", 83);
    ɵngcc0.ɵɵlistener("psYReachEnd", function HeaderComponent_ng_container_0_div_14_div_6_Template_perfect_scrollbar_psYReachEnd_1_listener() { ɵngcc0.ɵɵrestoreView(_r78); const ctx_r77 = ɵngcc0.ɵɵnextContext(3); return ctx_r77.onScrollDown(); });
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_ng_container_0_div_14_div_6_app_notifications_2_Template, 1, 1, "app-notifications", 84);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r69 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r69.config);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r69.notifications);
} }
function HeaderComponent_ng_container_0_div_14_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 76);
    ɵngcc0.ɵɵelementStart(1, "div", 85);
    ɵngcc0.ɵɵelementStart(2, "p");
    ɵngcc0.ɵɵtext(3, "\u041D\u043E\u0432\u044B\u0445 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043D\u0435\u0442");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_ng_container_0_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 72);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_container_0_div_14_div_1_Template, 1, 0, "div", 73);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 74);
    ɵngcc0.ɵɵelement(3, "use", 75);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(4, "div", 76);
    ɵngcc0.ɵɵtemplate(5, HeaderComponent_ng_container_0_div_14_div_5_Template, 2, 0, "div", 77);
    ɵngcc0.ɵɵtemplate(6, HeaderComponent_ng_container_0_div_14_div_6_Template, 3, 2, "div", 78);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HeaderComponent_ng_container_0_div_14_div_7_Template, 4, 0, "div", 79);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("header__notifications--search-hidden", ctx_r4.hideSearch);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r4.notifications == null ? null : ctx_r4.notifications.length) > 0);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r4.notifications == null ? null : ctx_r4.notifications.length) > 5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r4.notifications == null ? null : ctx_r4.notifications.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.notifications || (ctx_r4.notifications == null ? null : ctx_r4.notifications.length) === 0);
} }
function HeaderComponent_ng_container_0_app_header_search_40_Template(rf, ctx) { if (rf & 1) {
    const _r80 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(0, "app-header-search", 86);
    ɵngcc0.ɵɵlistener("isSearchOpenChange", function HeaderComponent_ng_container_0_app_header_search_40_Template_app_header_search_isSearchOpenChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r80); const ctx_r79 = ɵngcc0.ɵɵnextContext(2); return ctx_r79.isSearchOpen = $event; })("searchClose", function HeaderComponent_ng_container_0_app_header_search_40_Template_app_header_search_searchClose_0_listener() { ɵngcc0.ɵɵrestoreView(_r80); const ctx_r81 = ɵngcc0.ɵɵnextContext(2); return ctx_r81.isSearchOpen = false; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("isSearchOpen", ctx_r5.isSearchOpen);
} }
function HeaderComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r83 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "app-svg");
    ɵngcc0.ɵɵelementStart(2, "nav", 1);
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_Template_div_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r82 = ɵngcc0.ɵɵnextContext(); return ctx_r82.toggleMenu(); });
    ɵngcc0.ɵɵelement(4, "div", 3);
    ɵngcc0.ɵɵtemplate(5, HeaderComponent_ng_container_0_div_5_Template, 1, 0, "div", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 5);
    ɵngcc0.ɵɵelementStart(7, "div", 6);
    ɵngcc0.ɵɵelementStart(8, "a", 7);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_Template_a_click_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r84 = ɵngcc0.ɵɵnextContext(); return ctx_r84.onHeaderLogoClick($event); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(9, "svg", 8);
    ɵngcc0.ɵɵelement(10, "path", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(11, "div", 10);
    ɵngcc0.ɵɵtemplate(12, HeaderComponent_ng_container_0_ul_12_Template, 6, 4, "ul", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, HeaderComponent_ng_container_0_div_13_Template, 6, 2, "div", 12);
    ɵngcc0.ɵɵtemplate(14, HeaderComponent_ng_container_0_div_14_Template, 8, 6, "div", 13);
    ɵngcc0.ɵɵprojection(15);
    ɵngcc0.ɵɵelementStart(16, "div", 14);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_Template_div_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r85 = ɵngcc0.ɵɵnextContext(); return ctx_r85.changeIsOpenLK(); });
    ɵngcc0.ɵɵelementStart(17, "div", 15);
    ɵngcc0.ɵɵelementStart(18, "div", 16);
    ɵngcc0.ɵɵelementStart(19, "a", 17);
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "div", 18);
    ɵngcc0.ɵɵelement(22, "app-header-user-image", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 20);
    ɵngcc0.ɵɵelementStart(24, "ul", 21);
    ɵngcc0.ɵɵelementStart(25, "li", 22);
    ɵngcc0.ɵɵelementStart(26, "a", 23);
    ɵngcc0.ɵɵtext(27, "\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "li", 22);
    ɵngcc0.ɵɵelementStart(29, "a", 24);
    ɵngcc0.ɵɵtext(30, "\u0421\u043C\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u044F");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "li", 25);
    ɵngcc0.ɵɵelementStart(32, "a", 26);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_ng_container_0_Template_a_click_32_listener() { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r86 = ɵngcc0.ɵɵnextContext(); return ctx_r86.logout(); });
    ɵngcc0.ɵɵtext(33, " \u0412\u044B\u0445\u043E\u0434 ");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(34, "svg", 27);
    ɵngcc0.ɵɵelementStart(35, "g", 28);
    ɵngcc0.ɵɵelementStart(36, "g", 29);
    ɵngcc0.ɵɵelementStart(37, "g", 30);
    ɵngcc0.ɵɵelement(38, "path", 31);
    ɵngcc0.ɵɵelement(39, "path", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(40, HeaderComponent_ng_container_0_app_header_search_40_Template, 1, 1, "app-header-search", 33);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("header--open", ctx_r0.isMenuOpen);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("header__menu-bars--open", ctx_r0.isMenuOpen);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.notifications == null ? null : ctx_r0.notifications.length) > 0 && !ctx_r0.isMenuOpen);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.navigationNodes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.hideSearch);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.hideNotifications);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("header__lk--open", ctx_r0.isLkOpen);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("href", ctx_r0.userUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.userName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("userIdentity", ctx_r0.userIdentity)("cssClass", "nav-user-img")("big", true);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("href", ctx_r0.userUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("href", ctx_r0.changePasswordUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(11);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.hideSearch);
} }
const _c2 = [[["", "before-user-avatar", ""]]];
const _c3 = ["[before-user-avatar]"];
function NotificationsComponent_div_1__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 11);
    ɵngcc0.ɵɵelement(1, "use", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_1_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r7.notification.pictureUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function NotificationsComponent_div_1__svg_svg_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 14);
    ɵngcc0.ɵɵlistener("click", function NotificationsComponent_div_1__svg_svg_11_Template__svg_svg_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.hide(ctx_r9.notification.id); });
    ɵngcc0.ɵɵelement(1, "use", 15);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "a", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, NotificationsComponent_div_1__svg_svg_3_Template, 2, 0, "svg", 5);
    ɵngcc0.ɵɵtemplate(4, NotificationsComponent_div_1_img_4_Template, 1, 1, "img", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, NotificationsComponent_div_1__svg_svg_11_Template, 2, 0, "svg", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r0.notification.value, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.notification.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(10, 6, ctx_r0.notification.created + "Z", "short", "timezone", "ru-RU"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notification.fixed !== true);
} }
function NotificationsComponent_div_2__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 11);
    ɵngcc0.ɵɵelement(1, "use", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_2_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r12.notification.pictureUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function NotificationsComponent_div_2__svg_svg_11_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 14);
    ɵngcc0.ɵɵlistener("click", function NotificationsComponent_div_2__svg_svg_11_Template__svg_svg_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.hide(ctx_r14.notification.id); });
    ɵngcc0.ɵɵelement(1, "use", 15);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "a", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, NotificationsComponent_div_2__svg_svg_3_Template, 2, 0, "svg", 5);
    ɵngcc0.ɵɵtemplate(4, NotificationsComponent_div_2_img_4_Template, 1, 1, "img", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, NotificationsComponent_div_2__svg_svg_11_Template, 2, 0, "svg", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r1.notification.value, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.notification.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(10, 6, ctx_r1.notification.created + "Z", "short", "timezone", "ru-RU"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.notification.fixed !== true);
} }
function NotificationsComponent_div_3__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 11);
    ɵngcc0.ɵɵelement(1, "use", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_3_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r17.notification.pictureUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function NotificationsComponent_div_3__svg_svg_11_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 14);
    ɵngcc0.ɵɵlistener("click", function NotificationsComponent_div_3__svg_svg_11_Template__svg_svg_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.hide(ctx_r19.notification.id); });
    ɵngcc0.ɵɵelement(1, "use", 15);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, NotificationsComponent_div_3__svg_svg_3_Template, 2, 0, "svg", 5);
    ɵngcc0.ɵɵtemplate(4, NotificationsComponent_div_3_img_4_Template, 1, 1, "img", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, NotificationsComponent_div_3__svg_svg_11_Template, 2, 0, "svg", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.notification.value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(10, 5, ctx_r2.notification.created + "Z", "short", "timezone", "ru-RU"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.notification.fixed !== true);
} }
function NotificationsComponent_div_4__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 11);
    ɵngcc0.ɵɵelement(1, "use", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_4_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r22.notification.pictureUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function NotificationsComponent_div_4__svg_svg_11_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 14);
    ɵngcc0.ɵɵlistener("click", function NotificationsComponent_div_4__svg_svg_11_Template__svg_svg_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.hide(ctx_r24.notification.id); });
    ɵngcc0.ɵɵelement(1, "use", 15);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, NotificationsComponent_div_4__svg_svg_3_Template, 2, 0, "svg", 5);
    ɵngcc0.ɵɵtemplate(4, NotificationsComponent_div_4_img_4_Template, 1, 1, "img", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, NotificationsComponent_div_4__svg_svg_11_Template, 2, 0, "svg", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.notification.value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(10, 5, ctx_r3.notification.created + "Z", "short", "timezone", "ru-RU"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.notification.fixed !== true);
} }
function NotificationsComponent_div_5__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 11);
    ɵngcc0.ɵɵelement(1, "use", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_5_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r27.notification.pictureUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function NotificationsComponent_div_5__svg_svg_11_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 14);
    ɵngcc0.ɵɵlistener("click", function NotificationsComponent_div_5__svg_svg_11_Template__svg_svg_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ctx_r29.hide(ctx_r29.notification.id); });
    ɵngcc0.ɵɵelement(1, "use", 15);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, NotificationsComponent_div_5__svg_svg_3_Template, 2, 0, "svg", 5);
    ɵngcc0.ɵɵtemplate(4, NotificationsComponent_div_5_img_4_Template, 1, 1, "img", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, NotificationsComponent_div_5__svg_svg_11_Template, 2, 0, "svg", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.notification.pictureUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.notification.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(10, 5, ctx_r4.notification.created + "Z", "short", "timezone", "ru-RU"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.notification.fixed !== true);
} }
function NotificationsComponent_div_6__svg_svg_12_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 14);
    ɵngcc0.ɵɵlistener("click", function NotificationsComponent_div_6__svg_svg_12_Template__svg_svg_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.hide(ctx_r32.notification.id); });
    ɵngcc0.ɵɵelement(1, "use", 15);
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationsComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(3, "svg", 11);
    ɵngcc0.ɵɵelement(4, "use", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, NotificationsComponent_div_6__svg_svg_12_Template, 2, 0, "svg", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.notification.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(10, 4, ctx_r5.notification.created + "Z", "short", "timezone", "ru-RU"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r5.notification.value, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.notification.fixed !== true);
} }
function SearchResultComponent_div_0_div_1_a_5_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 18);
    ɵngcc0.ɵɵpipe(1, "highlight");
} if (rf & 2) {
    const e_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 1, e_r7.position, ctx_r9.query), ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_1_a_5_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, ", ");
    ɵngcc0.ɵɵelementEnd();
} }
function SearchResultComponent_div_0_div_1_a_5_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 18);
    ɵngcc0.ɵɵpipe(1, "highlight");
} if (rf & 2) {
    const e_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 1, e_r7.unitName, ctx_r11.query), ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_1_a_5_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
    ɵngcc0.ɵɵpipe(1, "highlight");
} if (rf & 2) {
    const e_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind3(1, 1, e_r7.workPhone, ctx_r12.query, true), ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_1_a_5_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, ", ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function SearchResultComponent_div_0_div_1_a_5_span_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
} if (rf & 2) {
    const e_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", e_r7.internalPhone, ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_1_a_5_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, ", ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function SearchResultComponent_div_0_div_1_a_5_span_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
    ɵngcc0.ɵɵpipe(1, "highlight");
} if (rf & 2) {
    const e_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind3(1, 1, e_r7.mobilePhone, ctx_r16.query, true), ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_1_a_5_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, ", ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function SearchResultComponent_div_0_div_1_a_5_span_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
} if (rf & 2) {
    const e_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", e_r7.email, ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_1_a_5_ng_container_18_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "img", 22);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const vacation_r27 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(vacation_r27.text);
} }
function SearchResultComponent_div_0_div_1_a_5_ng_container_18_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "img", 23);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const vacation_r27 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(vacation_r27.text);
} }
function SearchResultComponent_div_0_div_1_a_5_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SearchResultComponent_div_0_div_1_a_5_ng_container_18_div_1_Template, 4, 1, "div", 20);
    ɵngcc0.ɵɵtemplate(2, SearchResultComponent_div_0_div_1_a_5_ng_container_18_div_2_Template, 4, 1, "div", 20);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const vacation_r27 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", vacation_r27.started);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !vacation_r27.started);
} }
function SearchResultComponent_div_0_div_1_a_5_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelement(1, "img", 25);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3, "\u0414\u0435\u043D\u044C \u0420\u043E\u0436\u0434\u0435\u043D\u0438\u044F");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SearchResultComponent_div_0_div_1_a_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelement(3, "app-common-user-image", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 12);
    ɵngcc0.ɵɵelement(5, "div", 13);
    ɵngcc0.ɵɵpipe(6, "highlight");
    ɵngcc0.ɵɵtemplate(7, SearchResultComponent_div_0_div_1_a_5_span_7_Template, 2, 4, "span", 14);
    ɵngcc0.ɵɵtemplate(8, SearchResultComponent_div_0_div_1_a_5_span_8_Template, 2, 0, "span", 3);
    ɵngcc0.ɵɵtemplate(9, SearchResultComponent_div_0_div_1_a_5_span_9_Template, 2, 4, "span", 14);
    ɵngcc0.ɵɵelementStart(10, "div", 15);
    ɵngcc0.ɵɵtemplate(11, SearchResultComponent_div_0_div_1_a_5_span_11_Template, 2, 5, "span", 16);
    ɵngcc0.ɵɵtemplate(12, SearchResultComponent_div_0_div_1_a_5_ng_container_12_Template, 2, 0, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(13, SearchResultComponent_div_0_div_1_a_5_span_13_Template, 1, 1, "span", 16);
    ɵngcc0.ɵɵtemplate(14, SearchResultComponent_div_0_div_1_a_5_ng_container_14_Template, 2, 0, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(15, SearchResultComponent_div_0_div_1_a_5_span_15_Template, 2, 5, "span", 16);
    ɵngcc0.ɵɵtemplate(16, SearchResultComponent_div_0_div_1_a_5_ng_container_16_Template, 2, 0, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(17, SearchResultComponent_div_0_div_1_a_5_span_17_Template, 1, 1, "span", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(18, SearchResultComponent_div_0_div_1_a_5_ng_container_18_Template, 3, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(19, SearchResultComponent_div_0_div_1_a_5_div_19_Template, 4, 0, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r6.employeeService.getEmployeeUrl(e_r7), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("employee", e_r7)("cssClass", "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(6, 16, e_r7.name, ctx_r6.query), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.position);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.position && e_r7.unitName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.unitName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.workPhone);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.workPhone && e_r7.internalPhone && e_r7.internalPhone != e_r7.workPhone);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.internalPhone && e_r7.internalPhone != e_r7.workPhone);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.mobilePhone && (e_r7.workPhone || e_r7.internalPhone && e_r7.internalPhone != e_r7.workPhone));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.mobilePhone);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.email && (e_r7.internalPhone || e_r7.workPhone || e_r7.mobilePhone));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.vacations[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", e_r7.birthdayToday);
} }
function SearchResultComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h3", 4);
    ɵngcc0.ɵɵelementStart(2, "a", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵtemplate(5, SearchResultComponent_div_0_div_1_a_5_Template, 20, 19, "a", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("order", ctx_r1.categoryOrder["employee"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r1.getResultsSectionLink("employees"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0438 ", ctx_r1.getCountText(ctx_r1.searchResults.employees), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.searchResults.employees.items);
} }
function SearchResultComponent_div_0_div_2_a_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵelement(3, "div", 13);
    ɵngcc0.ɵɵpipe(4, "highlight");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const u_r33 = ctx.$implicit;
    const ctx_r32 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r32.unitService.getUnitUrl(u_r33), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(4, 2, u_r33.title, ctx_r32.query), ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h3", 4);
    ɵngcc0.ɵɵelementStart(2, "a", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 26);
    ɵngcc0.ɵɵtemplate(5, SearchResultComponent_div_0_div_2_a_5_Template, 5, 5, "a", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("order", ctx_r2.categoryOrder["unit"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r2.getResultsSectionLink("units"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u041F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F ", ctx_r2.getCountText(ctx_r2.searchResults.units), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.searchResults.units.items);
} }
function SearchResultComponent_div_0_div_3_a_5_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 32);
    ɵngcc0.ɵɵpipe(1, "highlight");
} if (rf & 2) {
    const n_r35 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r36 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 1, n_r35.announce, ctx_r36.query), ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_3_a_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 28);
    ɵngcc0.ɵɵelementStart(2, "div", 29);
    ɵngcc0.ɵɵelement(3, "div", 30);
    ɵngcc0.ɵɵpipe(4, "highlight");
    ɵngcc0.ɵɵtemplate(5, SearchResultComponent_div_0_div_3_a_5_div_5_Template, 2, 4, "div", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const n_r35 = ctx.$implicit;
    const ctx_r34 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r34.getNewsUrl(n_r35), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(4, 3, n_r35.title, ctx_r34.query), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", n_r35.announce);
} }
function SearchResultComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h3", 4);
    ɵngcc0.ɵɵelementStart(2, "a", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 27);
    ɵngcc0.ɵɵtemplate(5, SearchResultComponent_div_0_div_3_a_5_Template, 6, 6, "a", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("order", ctx_r3.categoryOrder["news"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r3.getResultsSectionLink("news"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u041D\u043E\u0432\u043E\u0441\u0442\u0438 ", ctx_r3.getCountText(ctx_r3.searchResults.news), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.searchResults.news.items);
} }
function SearchResultComponent_div_0_div_4_a_5_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 40);
    ɵngcc0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const p_r39 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 1, p_r39.body), ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_4_a_5_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 41);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2, "\u0422\u0435\u0433\u0438: ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 19);
    ɵngcc0.ɵɵpipe(4, "safeHtml");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r39 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(4, 1, p_r39.tags), ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_4_a_5_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2, "\u041F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u043E: ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r39 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", p_r39.spaceTitle, ɵngcc0.ɵɵsanitizeHtml);
} }
function SearchResultComponent_div_0_div_4_a_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 34);
    ɵngcc0.ɵɵelementStart(2, "div", 35);
    ɵngcc0.ɵɵelement(3, "div", 36);
    ɵngcc0.ɵɵpipe(4, "safeHtml");
    ɵngcc0.ɵɵtemplate(5, SearchResultComponent_div_0_div_4_a_5_div_5_Template, 2, 3, "div", 37);
    ɵngcc0.ɵɵtemplate(6, SearchResultComponent_div_0_div_4_a_5_div_6_Template, 5, 3, "div", 38);
    ɵngcc0.ɵɵtemplate(7, SearchResultComponent_div_0_div_4_a_5_div_7_Template, 4, 1, "div", 39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r39 = ctx.$implicit;
    const ctx_r38 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r38.getPageUrl(p_r39), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(4, 5, p_r39.title), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", p_r39.body);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", p_r39.tags);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", p_r39.spaceTitle);
} }
function SearchResultComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h3", 4);
    ɵngcc0.ɵɵelementStart(2, "a", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 33);
    ɵngcc0.ɵɵtemplate(5, SearchResultComponent_div_0_div_4_a_5_Template, 8, 7, "a", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("order", ctx_r4.categoryOrder["pages"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r4.getResultsSectionLink("pages"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u0420\u0430\u0437\u0434\u0435\u043B\u044B \u0431\u0430\u0437\u044B \u0437\u043D\u0430\u043D\u0438\u0439 ", ctx_r4.getCountText(ctx_r4.searchResults.pages), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.searchResults.pages.items);
} }
function SearchResultComponent_div_0_ng_container_5_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "\u041E\u0448\u0438\u0431\u043A\u0430: ");
    ɵngcc0.ɵɵelementEnd();
} }
function SearchResultComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 43);
    ɵngcc0.ɵɵtemplate(2, SearchResultComponent_div_0_ng_container_5_span_2_Template, 2, 0, "span", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.searchResults == null ? null : ctx_r5.searchResults.error);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.searchResults == null ? null : ctx_r5.searchResults.message, " ");
} }
function SearchResultComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("keydown", function SearchResultComponent_div_0_Template_div_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r48); const ctx_r47 = ɵngcc0.ɵɵnextContext(); return ctx_r47.onKeyDown($event); });
    ɵngcc0.ɵɵtemplate(1, SearchResultComponent_div_0_div_1_Template, 6, 5, "div", 2);
    ɵngcc0.ɵɵtemplate(2, SearchResultComponent_div_0_div_2_Template, 6, 5, "div", 2);
    ɵngcc0.ɵɵtemplate(3, SearchResultComponent_div_0_div_3_Template, 6, 5, "div", 2);
    ɵngcc0.ɵɵtemplate(4, SearchResultComponent_div_0_div_4_Template, 6, 5, "div", 2);
    ɵngcc0.ɵɵtemplate(5, SearchResultComponent_div_0_ng_container_5_Template, 4, 2, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.searchResults.employees.items == null ? null : ctx_r0.searchResults.employees.items.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.searchResults == null ? null : ctx_r0.searchResults.units == null ? null : ctx_r0.searchResults.units.items == null ? null : ctx_r0.searchResults.units.items.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.searchResults == null ? null : ctx_r0.searchResults.news == null ? null : ctx_r0.searchResults.news.items == null ? null : ctx_r0.searchResults.news.items.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.searchResults == null ? null : ctx_r0.searchResults.pages == null ? null : ctx_r0.searchResults.pages.items == null ? null : ctx_r0.searchResults.pages.items.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.searchResults == null ? null : ctx_r0.searchResults.message);
} }
class ClickOutsideDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.clickOutside = new EventEmitter();
    }
    onClick(event, targetElement) {
        if (!targetElement) {
            return;
        }
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(event);
        }
    }
}
ClickOutsideDirective.ɵfac = function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ClickOutsideDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ClickOutsideDirective, selectors: [["", "appClickOutside", ""]], hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event, $event.target); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, outputs: { clickOutside: "clickOutside" } });
ClickOutsideDirective.ctorParameters = () => [
    { type: ElementRef }
];
ClickOutsideDirective.propDecorators = {
    clickOutside: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['document:click', ['$event', '$event.target'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClickOutsideDirective, [{
        type: Directive,
        args: [{
                selector: '[appClickOutside]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event', '$event.target']]
        }] }); })();

class AutoFocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.focus = true;
    }
    set autofocus(condition) {
        this.focus = condition !== false;
    }
    ngOnInit() {
        if (this.focus) {
            // Otherwise Angular throws error: Expression has changed after it was checked.
            this.timeout = window.setTimeout(() => {
                // For SSR (server side rendering) this is not safe. Use: https://github.com/angular/angular/issues/15008#issuecomment-285141070);
                this.elementRef.nativeElement.focus();
                this.timeout = null;
            }, 0);
        }
    }
    ngOnDestroy() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
}
AutoFocusDirective.ɵfac = function AutoFocusDirective_Factory(t) { return new (t || AutoFocusDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AutoFocusDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AutoFocusDirective, selectors: [["", "appAutoFocus", ""]], inputs: { autofocus: "autofocus" } });
AutoFocusDirective.ctorParameters = () => [
    { type: ElementRef }
];
AutoFocusDirective.propDecorators = {
    autofocus: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutoFocusDirective, [{
        type: Directive,
        args: [{
                selector: '[appAutoFocus]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { autofocus: [{
            type: Input
        }] }); })();

class HighlightPipe {
    transform(text, search, isPhone) {
        if (search && text) {
            let pattern = search;
            let patternFixed = pattern.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
            if (isPhone) {
                pattern = search.replace(/[\|(\)|\-]/g, '');
                pattern = pattern.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
                patternFixed = '\\s*';
                const numberPattern = '(\\s*-\\s*D|\\s*D|\\(\\s*D|\\s*D\\)|\\)\\s*D\)\\s*';
                const regexTemplateNumber = new RegExp('D', 'g');
                if (pattern.startsWith('\\+7')) {
                    patternFixed = '[+7|8]\\s*';
                    pattern = pattern.replace('\\+7', '');
                }
                else if (pattern.startsWith('8')) {
                    patternFixed = '[+7|8]\\s*';
                    pattern = pattern.replace('8', '');
                }
                for (const patternPart of pattern) {
                    const sym = +patternPart;
                    if (sym || sym === 0) {
                        patternFixed += numberPattern.replace(regexTemplateNumber, patternPart);
                    }
                    else {
                        patternFixed += patternPart;
                    }
                }
            }
            text = HighlightPipe.getText(text, patternFixed);
            const regexNumber = new RegExp('\\d+(-\\d)*?', 'gm');
            return text.replace(regexNumber, (match) => {
                if (search.indexOf(match) !== -1) {
                    return `<span class="search-highlight">${match}</span>`;
                }
                else {
                    return match;
                }
            });
        }
        else {
            return text;
        }
    }
    static getText(text, search) {
        search = search.split(' ').filter((t) => t.length > 0).join('|');
        const regex = new RegExp(search.replace('ё', '{ё_ё}').replace('е', '[ё|е]').replace('{ё_ё}', '[ё|е]'), 'gi');
        return text.replace(regex, (match) => `<span class="search-highlight">${match}</span>`);
    }
}
HighlightPipe.ɵfac = function HighlightPipe_Factory(t) { return new (t || HighlightPipe)(); };
HighlightPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "highlight", type: HighlightPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HighlightPipe, [{
        type: Pipe,
        args: [{
                name: 'highlight'
            }]
    }], null, null); })();

/**
 * Оставляет теги в HTML
 *
 * @export
 * @class SafeHtmlPipe
 * @implements {PipeTransform}
 */
class SafeHtmlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer, 16)); };
SafeHtmlPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
SafeHtmlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{
                name: 'safeHtml'
            }]
    }], function () { return [{ type: ɵngcc1.DomSanitizer }]; }, null); })();

const PRODUCTION_SERVICES_LIST = {
    homeUrl: 'https://home.pik.ru',
    homeApi: 'https://home-api.pik.ru',
    marketApi: 'https://market-api.pik.ru',
    mdsUrl: 'https://mds.pik.ru',
    mdsApi: 'https://mds-api.pik.ru',
    photoApi: 'https://photo-api.pik.ru',
    serviceDeskUrl: 'https://service.pik.ru',
    serviceDeskApi: 'https://service-api.pik.ru',
    bopUrl: 'https://bop.pik.ru',
    bopApi: 'https://bop-api.pik.ru',
    eksUrl: 'https://approve.pik.ru',
    eksApi: 'https://approve-api.pik.ru',
    learnUrl: 'https://learn.pik.ru',
    learnApi: 'https://learn-api.pik.ru',
    infoApi: 'https://info-api.pik.ru',
    infoUrl: 'https://info.pik.ru',
    navigationApi: 'https://navigation-api.pik.ru',
    stsUrl: 'https://auth.pik.ru'
};
const TESTING_SERVICES_LIST = {
    homeUrl: 'https://testhome.pik.ru',
    homeApi: 'https://testhome-api.pik.ru',
    marketApi: 'https://testmarket-api.pik.ru',
    mdsUrl: 'https://testmds.pik.ru',
    mdsApi: 'https://testmds-api.pik.ru',
    photoApi: 'https://api.test.photo.pik-digital.ru',
    serviceDeskUrl: 'https://testservice.pik.ru',
    serviceDeskApi: 'https://testservice-api.pik.ru',
    bopUrl: 'https://testbop.pik.ru',
    bopApi: 'https://testbop-api.pik.ru',
    eksUrl: 'https://test.approve.pik-digital.ru',
    eksApi: 'https://api.test.approve.pik-digital.ru',
    learnUrl: 'https://test.learn.pik-digital.ru',
    learnApi: 'https://api.test.learn.pik-digital.ru',
    infoUrl: 'https://test.info.pik-digital.ru',
    infoApi: 'https://api.test.info.pik-digital.ru',
    navigationApi: 'https://api.test.navigation.pik-digital.ru',
    stsUrl: 'https://test.auth.pik-digital.ru'
};

class PikConfig {
}
const PIK_CONFIG = new InjectionToken('PikConfig');

var PikEnvironment;
(function (PikEnvironment) {
    PikEnvironment["test"] = "test";
    PikEnvironment["prod"] = "prod";
})(PikEnvironment || (PikEnvironment = {}));

class PikLocatorService {
    constructor(config) {
        switch (config.environment) {
            case PikEnvironment.prod:
                this.urls = PRODUCTION_SERVICES_LIST;
                break;
            case PikEnvironment.test:
            default:
                this.urls = TESTING_SERVICES_LIST;
                break;
        }
        this.overrideUrlsByConfig(config);
    }
    overrideUrlsByConfig(config) {
        if (config.services) {
            for (const key in this.urls) {
                if (!this.urls.hasOwnProperty(key) || !config.services.hasOwnProperty(key)) {
                    continue;
                }
                this.urls[key] = config.services[key];
            }
        }
    }
}
PikLocatorService.ɵfac = function PikLocatorService_Factory(t) { return new (t || PikLocatorService)(ɵngcc0.ɵɵinject(PIK_CONFIG)); };
PikLocatorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PikLocatorService, factory: PikLocatorService.ɵfac });
PikLocatorService.ctorParameters = () => [
    { type: PikConfig, decorators: [{ type: Inject, args: [PIK_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikLocatorService, [{
        type: Injectable
    }], function () { return [{ type: PikConfig, decorators: [{
                type: Inject,
                args: [PIK_CONFIG]
            }] }]; }, null); })();

class PikCommonModule {
    static forRoot(config) {
        return {
            ngModule: PikCommonModule,
            providers: [
                {
                    provide: PIK_CONFIG,
                    useValue: config,
                }
            ]
        };
    }
    static forChild() {
        return {
            ngModule: PikCommonModule,
            providers: []
        };
    }
}
PikCommonModule.ɵfac = function PikCommonModule_Factory(t) { return new (t || PikCommonModule)(); };
PikCommonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikCommonModule });
PikCommonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        PikLocatorService
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikCommonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AutoFocusDirective,
                    ClickOutsideDirective,
                    HighlightPipe,
                    SafeHtmlPipe,
                ],
                exports: [
                    AutoFocusDirective,
                    ClickOutsideDirective,
                    HighlightPipe,
                    SafeHtmlPipe,
                ],
                providers: [
                    PikLocatorService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikCommonModule, { declarations: function () { return [AutoFocusDirective, ClickOutsideDirective, HighlightPipe, SafeHtmlPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AutoFocusDirective, ClickOutsideDirective, HighlightPipe, SafeHtmlPipe]; } }); })();

const PIK_AUTH_CONFIG = new InjectionToken('PikAuthConfig');

class WebStorageService {
    constructor() {
        // todo: Нужно сделать fallback в куки
        this.isStorageIsAvailable();
    }
    read(key, defaultValue = null) {
        if (!this.isStorageIsAvailable()) {
            return defaultValue;
        }
        const nativeStorage = this.getNativeStorage();
        const json = nativeStorage.getItem(key);
        if (json === 'undefined' || json === 'null') {
            return defaultValue;
        }
        const data = JSON.parse(json);
        if (!data) {
            return defaultValue;
        }
        return data;
    }
    write(key, value) {
        if (!this.isStorageIsAvailable()) {
            return;
        }
        this.getNativeStorage().setItem(key, JSON.stringify(value));
    }
    remove(key) {
        if (!this.isStorageIsAvailable()) {
            return;
        }
        this.getNativeStorage().removeItem(key);
    }
    clear() {
        if (!this.isStorageIsAvailable()) {
            return;
        }
        this.getNativeStorage().clear();
    }
    isStorageIsAvailable() {
        const nativeStorage = this.getNativeStorage();
        try {
            nativeStorage.setItem('WebStorageService', 'WebStorageService');
            nativeStorage.removeItem('WebStorageService');
            return true;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
}

class SessionStorageService extends WebStorageService {
    constructor() {
        super();
    }
    getNativeStorage() {
        return window.sessionStorage;
    }
}
SessionStorageService.ɵfac = function SessionStorageService_Factory(t) { return new (t || SessionStorageService)(); };
SessionStorageService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SessionStorageService, factory: SessionStorageService.ɵfac });
SessionStorageService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionStorageService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PikAuthRedirectService {
    constructor(storage, router, events) {
        this.storage = storage;
        this.router = router;
        this.events = events;
    }
    subscribe() {
        this.events
            .registerForEvents()
            .pipe(filter((notification) => notification.type === EventTypes.NewAuthorizationResult))
            .subscribe(() => this.redirectIfNeeded());
    }
    redirectIfNeeded() {
        const route = this.storage.read(PikAuthRedirectService.STORAGE_KEY);
        const queryParams = this.storage.read(PikAuthRedirectService.QUERY_PARAMS);
        if (route) {
            console.debug(`[PikAuthRedirectService.redirectIfNeeded] Redirect to "${route}"`);
            this.reset();
            return this.router.navigate([route], { replaceUrl: true, queryParams: queryParams }).then((result) => {
                if (!result) {
                    return this.router.navigate(['/'], { replaceUrl: true });
                }
                return true;
            });
        }
        return Promise.resolve(false);
    }
    setAuthRedirectRoute(url, queryParams = null) {
        console.debug(`[PikAuthRedirectService.setAuthRedirectRoute] The new redirect url is "${url}"`);
        this.storage.write(PikAuthRedirectService.STORAGE_KEY, url);
        this.storage.write(PikAuthRedirectService.QUERY_PARAMS, queryParams);
    }
    reset() {
        this.storage.remove(PikAuthRedirectService.STORAGE_KEY);
        this.storage.remove(PikAuthRedirectService.QUERY_PARAMS);
    }
}
PikAuthRedirectService.ɵfac = function PikAuthRedirectService_Factory(t) { return new (t || PikAuthRedirectService)(ɵngcc0.ɵɵinject(SessionStorageService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc3.PublicEventsService)); };
PikAuthRedirectService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PikAuthRedirectService, factory: PikAuthRedirectService.ɵfac });
PikAuthRedirectService.STORAGE_KEY = 'PikAuthRedirectRoute';
PikAuthRedirectService.QUERY_PARAMS = 'PikAuthRedirectQueryParams';
PikAuthRedirectService.ctorParameters = () => [
    { type: SessionStorageService },
    { type: Router },
    { type: PublicEventsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAuthRedirectService, [{
        type: Injectable
    }], function () { return [{ type: SessionStorageService }, { type: ɵngcc2.Router }, { type: ɵngcc3.PublicEventsService }]; }, null); })();

/**
 * API навигации
 */
class PikHeaderService {
    constructor() {
        this.isVisibleSubject = new BehaviorSubject(false);
        this.isVisible$ = this.isVisibleSubject.asObservable();
    }
    show() {
        this.isVisibleSubject.next(true);
    }
    hide() {
        this.isVisibleSubject.next(false);
    }
}
PikHeaderService.ɵfac = function PikHeaderService_Factory(t) { return new (t || PikHeaderService)(); };
PikHeaderService.ɵprov = ɵɵdefineInjectable({ factory: function PikHeaderService_Factory() { return new PikHeaderService(); }, token: PikHeaderService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikHeaderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class PikAuthService {
    constructor(config, oidcSecurityService, router, eventService, storage, redirectService, tokenValidationService, oidcSecurityStorage, tokenHelperService, headerService) {
        this.config = config;
        this.oidcSecurityService = oidcSecurityService;
        this.router = router;
        this.eventService = eventService;
        this.storage = storage;
        this.redirectService = redirectService;
        this.tokenValidationService = tokenValidationService;
        this.oidcSecurityStorage = oidcSecurityStorage;
        this.tokenHelperService = tokenHelperService;
        this.headerService = headerService;
        this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$;
        this.userData$ = this.oidcSecurityService.userData$;
        this.configuration = this.oidcSecurityService.configuration.configuration;
    }
    /**
     * Выполнить вход
     */
    login(redirectUrl = null, queryParams = null) {
        this.redirectService.setAuthRedirectRoute(redirectUrl || this.router.url, queryParams);
        this.oidcSecurityService.authorize();
    }
    /**
     * Выполнить вход
     */
    loginAsExternal(redirectUrl = null) {
        this.redirectService.setAuthRedirectRoute(redirectUrl || this.router.url);
        this.oidcSecurityService.authorize({
            customParams: {
                login_hint: 'external',
            },
        });
    }
    /**
     * Выполнить выход
     */
    logout() {
        this.redirectService.reset();
        this.oidcSecurityService.logoff();
    }
    /**
     * Получить access токен текущего пользователя
     */
    getToken() {
        return this.oidcSecurityService.getToken();
    }
    /**
     * Получить ID токен текущего пользователя
     */
    getIdToken() {
        return this.oidcSecurityService.getIdToken();
    }
    /**
     * Получить значение для заголовка Authorization с токеном текущего пользователя 'Bearer ...'
     */
    getAuthorizationHeaderValue() {
        return `Bearer ${this.oidcSecurityService.getToken()}`;
    }
    /**
     * Принудительное обновление сессии
     */
    forceRefreshSession() {
        return this.oidcSecurityService.forceRefreshSession();
    }
    /**
     * Является ли пользователь внешним?
     */
    isExternalUser() {
        const token = this.oidcSecurityService.getPayloadFromIdToken(false);
        return token && token.idp === 'External';
    }
    /**
     * Разрешена ли авторизация для внешних пользователей?
     */
    isExternalUsersAllowed() {
        return this.config.allowExternal;
    }
    isTokenExpired(renewTimeBeforeTokenExpiresInSeconds = null) {
        const accessTokenExpiresIn = this.getTokenExpiresAt();
        const accessTokenHasNotExpired = this.tokenValidationService.validateAccessTokenNotExpired(accessTokenExpiresIn, renewTimeBeforeTokenExpiresInSeconds || this.configuration.renewTimeBeforeTokenExpiresInSeconds);
        return !accessTokenHasNotExpired;
    }
    getTokenExpiresAt() {
        const prefix = this.configuration.clientId || '';
        const timestamp = this.oidcSecurityStorage.read(`${prefix}_access_token_expires_at`);
        return new Date(timestamp);
    }
    isIdTokenExpired(renewTimeBeforeTokenExpiresInSeconds = null) {
        const decodedIdToken = this.tokenHelperService.getPayloadFromToken(this.getIdToken(), false);
        const idTokenHasNotExpired = this.tokenValidationService.validateIdTokenExpNotExpired(decodedIdToken, renewTimeBeforeTokenExpiresInSeconds || this.configuration.renewTimeBeforeTokenExpiresInSeconds);
        return !idTokenHasNotExpired;
    }
    getIdTokenExpiresAt() {
        const decodedIdToken = this.tokenHelperService.getPayloadFromToken(this.getIdToken(), false);
        const tokenExpirationDate = this.tokenHelperService.getTokenExpirationDate(decodedIdToken);
        return new Date(tokenExpirationDate);
    }
    authCallbackIfRequired() {
        this.headerService.hide();
        this.oidcSecurityService.checkAuth().subscribe((auth) => {
            console.debug('[PikAuthService] Authentication was ' + (auth ? 'succeeded' : 'failed'));
            if (auth && (!this.isExternalUser() || (this.config.allowExternal && this.config.showHeaderForExternal))) {
                this.headerService.show();
            }
        });
    }
    // ------------------------ DEPRECATIONS ------------------------ //
    /**
     * @deprecated
     * @see isAuthenticated$
     */
    getIsAuthorized() {
        return this.isAuthenticated$;
    }
    /**
     * @deprecated
     * @see isAuthenticated$
     */
    isAuthorized() {
        return this.isAuthenticated$;
    }
    /**
     * @deprecated
     * @see forceRefreshSession
     */
    refreshSession() {
        return this.forceRefreshSession();
    }
    /**
     * @deprecated
     * @see userData$
     */
    getUserData() {
        return this.userData$;
    }
    /**
     * @deprecated Пользуйтесь гвардами, этот метод не должен бы быть публичным, и не должен был быть объявлен в этом сервисе
     */
    checkExternalUsers() {
        // если пользователь внешний, но для внешних пользователей не разрешён доступ, то нужно переводить на 403
        if (!this.config.allowExternal) {
            if (this.isExternalUser()) {
                this.router.navigate([this.configuration.forbiddenRoute], {
                    skipLocationChange: true,
                    queryParams: { from_url: encodeURIComponent(location.href) }
                });
                return;
            }
        }
    }
}
PikAuthService.ɵfac = function PikAuthService_Factory(t) { return new (t || PikAuthService)(ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG), ɵngcc0.ɵɵinject(ɵngcc3.OidcSecurityService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc3.PublicEventsService), ɵngcc0.ɵɵinject(SessionStorageService), ɵngcc0.ɵɵinject(PikAuthRedirectService), ɵngcc0.ɵɵinject(ɵngcc3.TokenValidationService), ɵngcc0.ɵɵinject(ɵngcc3.AbstractSecurityStorage), ɵngcc0.ɵɵinject(ɵngcc3.TokenHelperService), ɵngcc0.ɵɵinject(PikHeaderService)); };
PikAuthService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PikAuthService, factory: PikAuthService.ɵfac });
PikAuthService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] },
    { type: OidcSecurityService },
    { type: Router },
    { type: PublicEventsService },
    { type: SessionStorageService },
    { type: PikAuthRedirectService },
    { type: TokenValidationService },
    { type: AbstractSecurityStorage },
    { type: TokenHelperService },
    { type: PikHeaderService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAuthService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }, { type: ɵngcc3.OidcSecurityService }, { type: ɵngcc2.Router }, { type: ɵngcc3.PublicEventsService }, { type: SessionStorageService }, { type: PikAuthRedirectService }, { type: ɵngcc3.TokenValidationService }, { type: ɵngcc3.AbstractSecurityStorage }, { type: ɵngcc3.TokenHelperService }, { type: PikHeaderService }]; }, null); })();

class PikGuard {
    constructor(auth, router) {
        this.auth = auth;
        this.router = router;
    }
    forbidden() {
        this.router
            .navigate([this.auth.configuration.forbiddenRoute], {
            skipLocationChange: true,
            queryParams: {
                from_url: encodeURIComponent(location.href)
            }
        })
            .then(() => {
            console.debug('[PikGuard] Forbidden');
        });
    }
    check(checker) {
        return this.auth.isAuthenticated$.pipe(map(checker));
    }
}

class PikAutoLoginGuard extends PikGuard {
    constructor(auth, router) {
        super(auth, router);
    }
    canActivate(route, state) {
        return this.check((isAuthorized) => {
            if (!isAuthorized) {
                this.auth.login(state.url);
                return false;
            }
            if (this.auth.isExternalUser()) {
                return this.checkForExternalUser();
            }
            return true;
        });
    }
    checkForExternalUser() {
        if (!this.auth.isExternalUsersAllowed()) {
            this.forbidden();
            return false;
        }
        return true;
    }
}
PikAutoLoginGuard.ɵfac = function PikAutoLoginGuard_Factory(t) { return new (t || PikAutoLoginGuard)(ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
PikAutoLoginGuard.ɵprov = ɵɵdefineInjectable({ factory: function PikAutoLoginGuard_Factory() { return new PikAutoLoginGuard(ɵɵinject(PikAuthService), ɵɵinject(Router)); }, token: PikAutoLoginGuard, providedIn: "root" });
PikAutoLoginGuard.ctorParameters = () => [
    { type: PikAuthService },
    { type: Router }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAutoLoginGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: PikAuthService }, { type: ɵngcc2.Router }]; }, null); })();

/**
 * @deprecated
 * @see PikAutoLoginGuard
 */
class PikAuthGuard extends PikAutoLoginGuard {
}
PikAuthGuard.ɵfac = /*@__PURE__*/ function () { let ɵPikAuthGuard_BaseFactory; return function PikAuthGuard_Factory(t) { return (ɵPikAuthGuard_BaseFactory || (ɵPikAuthGuard_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PikAuthGuard)))(t || PikAuthGuard); }; }();
PikAuthGuard.ɵprov = ɵɵdefineInjectable({ factory: function PikAuthGuard_Factory() { return new PikAuthGuard(ɵɵinject(PikAuthService), ɵɵinject(Router)); }, token: PikAuthGuard, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAuthGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class AuthCallbackComponent {
    constructor(auth, header) {
        this.auth = auth;
        this.header = header;
        this.header.hide();
    }
}
AuthCallbackComponent.ɵfac = function AuthCallbackComponent_Factory(t) { return new (t || AuthCallbackComponent)(ɵngcc0.ɵɵdirectiveInject(PikAuthService), ɵngcc0.ɵɵdirectiveInject(PikHeaderService)); };
AuthCallbackComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AuthCallbackComponent, selectors: [["app-auth-callback"]], decls: 8, vars: 0, consts: [["href", "javascript:void(0);", 1, "error__link", 3, "click"]], template: function AuthCallbackComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h3");
        ɵngcc0.ɵɵtext(1, "\u0412\u0445\u043E\u0434 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D. \u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438...");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelementStart(3, "p");
        ɵngcc0.ɵɵtext(4, " \u0415\u0441\u043B\u0438 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u0445\u043E\u0434, \u0442\u043E \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 ");
        ɵngcc0.ɵɵelementStart(5, "a", 0);
        ɵngcc0.ɵɵlistener("click", function AuthCallbackComponent_Template_a_click_5_listener() { return ctx.auth.logout(); });
        ɵngcc0.ɵɵtext(6, "\u0432\u044B\u0439\u0442\u0438");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, ", \u0430 \u0437\u0430\u0442\u0435\u043C \u0432\u043E\u0439\u0442\u0438 \u0441\u043D\u043E\u0432\u0430. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
AuthCallbackComponent.ctorParameters = () => [
    { type: PikAuthService },
    { type: PikHeaderService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthCallbackComponent, [{
        type: Component,
        args: [{
                selector: 'app-auth-callback',
                template: "<h3>\u0412\u0445\u043E\u0434 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D. \u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438...</h3>\n<div>\n  <p>\n    \u0415\u0441\u043B\u0438 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u0445\u043E\u0434, \u0442\u043E \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435\n    <a class=\"error__link\" href=\"javascript:void(0);\" (click)=\"auth.logout()\">\u0432\u044B\u0439\u0442\u0438</a>, \u0430 \u0437\u0430\u0442\u0435\u043C \u0432\u043E\u0439\u0442\u0438 \u0441\u043D\u043E\u0432\u0430.\n  </p>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: PikAuthService }, { type: PikHeaderService }]; }, null); })();

const createAuthWellKnownEndpoints = (locator) => ({
    issuer: locator.urls.stsUrl,
    jwksUri: locator.urls.stsUrl + '/.well-known/openid-configuration/jwks',
    authorizationEndpoint: locator.urls.stsUrl + '/connect/authorize',
    tokenEndpoint: locator.urls.stsUrl + '/connect/token',
    userinfoEndpoint: locator.urls.stsUrl + '/connect/userinfo',
    endSessionEndpoint: locator.urls.stsUrl + '/connect/endsession',
    checkSessionIframe: locator.urls.stsUrl + '/connect/checksession',
    revocationEndpoint: locator.urls.stsUrl + '/connect/revocation',
    introspectionEndpoint: locator.urls.stsUrl + '/connect/introspect',
});
const createOpenIdConfiguration = (locator, config) => {
    const frontUrl = config.frontUrl ? config.frontUrl : (window.location.protocol + '//' + window.location.host);
    const openIdConfiguration = {
        stsServer: locator.urls.stsUrl,
        redirectUrl: frontUrl + '/auth-callback',
        silentRenewUrl: frontUrl + '/silent-renew.html',
        postLogoutRedirectUri: frontUrl + '/401',
        responseType: 'id_token token',
        silentRenew: true,
        postLoginRoute: '/',
        forbiddenRoute: '/403',
        unauthorizedRoute: '/401',
        triggerAuthorizationResultEvent: true,
        maxIdTokenIatOffsetAllowedInSeconds: 1200,
        renewUserInfoAfterTokenRenew: true,
    };
    const shouldSkip = [
        'stsServer',
        'authWellknownEndpoint',
        'triggerAuthorizationResultEvent',
    ];
    for (const key of Object.keys(config)) {
        if (shouldSkip.includes(key)) {
            continue;
        }
        openIdConfiguration[key] = config[key];
    }
    return openIdConfiguration;
};
const pikAuthConfigFactory = (oidcConfigService, locator, config) => () => oidcConfigService.withConfig(createOpenIdConfiguration(locator, config), createAuthWellKnownEndpoints(locator));

class PikAnonymousGuard extends PikGuard {
    constructor(auth, router) {
        super(auth, router);
    }
    canActivate(route, state) {
        return this.check((isAuthorized) => {
            if (isAuthorized) {
                this.forbidden();
                return false;
            }
            return true;
        });
    }
}
PikAnonymousGuard.ɵfac = function PikAnonymousGuard_Factory(t) { return new (t || PikAnonymousGuard)(ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
PikAnonymousGuard.ɵprov = ɵɵdefineInjectable({ factory: function PikAnonymousGuard_Factory() { return new PikAnonymousGuard(ɵɵinject(PikAuthService), ɵɵinject(Router)); }, token: PikAnonymousGuard, providedIn: "root" });
PikAnonymousGuard.ctorParameters = () => [
    { type: PikAuthService },
    { type: Router }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAnonymousGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: PikAuthService }, { type: ɵngcc2.Router }]; }, null); })();

class LocalStorageService extends WebStorageService {
    constructor() {
        super();
    }
    getNativeStorage() {
        return window.localStorage;
    }
}
LocalStorageService.ɵfac = function LocalStorageService_Factory(t) { return new (t || LocalStorageService)(); };
LocalStorageService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LocalStorageService, factory: LocalStorageService.ɵfac });
LocalStorageService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalStorageService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PikStorageModule {
}
PikStorageModule.ɵfac = function PikStorageModule_Factory(t) { return new (t || PikStorageModule)(); };
PikStorageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikStorageModule });
PikStorageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        LocalStorageService,
        SessionStorageService,
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikStorageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [],
                providers: [
                    LocalStorageService,
                    SessionStorageService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikStorageModule, { imports: function () { return [CommonModule]; } }); })();

class PikAuthenticatedGuard extends PikGuard {
    constructor(auth, router) {
        super(auth, router);
    }
    canActivate(route, state) {
        return this.check((isAuthorized) => {
            if (!isAuthorized) {
                this.forbidden();
                return false;
            }
            if (this.auth.isExternalUser() && !this.auth.isExternalUsersAllowed()) {
                this.forbidden();
                return false;
            }
            return true;
        });
    }
}
PikAuthenticatedGuard.ɵfac = function PikAuthenticatedGuard_Factory(t) { return new (t || PikAuthenticatedGuard)(ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
PikAuthenticatedGuard.ɵprov = ɵɵdefineInjectable({ factory: function PikAuthenticatedGuard_Factory() { return new PikAuthenticatedGuard(ɵɵinject(PikAuthService), ɵɵinject(Router)); }, token: PikAuthenticatedGuard, providedIn: "root" });
PikAuthenticatedGuard.ctorParameters = () => [
    { type: PikAuthService },
    { type: Router }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAuthenticatedGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: PikAuthService }, { type: ɵngcc2.Router }]; }, null); })();

const pikAuthRoutes = [
    { path: 'auth-callback', component: AuthCallbackComponent },
];
class PikAuthRoutingModule {
}
PikAuthRoutingModule.ɵfac = function PikAuthRoutingModule_Factory(t) { return new (t || PikAuthRoutingModule)(); };
PikAuthRoutingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikAuthRoutingModule });
PikAuthRoutingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[RouterModule.forChild(pikAuthRoutes)], RouterModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAuthRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(pikAuthRoutes)],
                exports: [RouterModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikAuthRoutingModule, { imports: function () { return [ɵngcc2.RouterModule]; }, exports: function () { return [RouterModule]; } }); })();

class PikSecurityStorageService {
    constructor(storage) {
        this.storage = storage;
    }
    read(key) {
        return this.storage.read(key, null);
    }
    remove(key) {
        this.storage.remove(key);
    }
    write(key, value) {
        this.storage.write(key, value);
    }
}
PikSecurityStorageService.ɵfac = function PikSecurityStorageService_Factory(t) { return new (t || PikSecurityStorageService)(ɵngcc0.ɵɵinject(LocalStorageService)); };
PikSecurityStorageService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PikSecurityStorageService, factory: PikSecurityStorageService.ɵfac });
PikSecurityStorageService.ctorParameters = () => [
    { type: LocalStorageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikSecurityStorageService, [{
        type: Injectable
    }], function () { return [{ type: LocalStorageService }]; }, null); })();

const ɵ0 = pikAuthConfigFactory;
class PikAuthModule {
    constructor(authRedirectService) {
        authRedirectService.subscribe();
    }
    static forRoot(config) {
        return {
            ngModule: PikAuthModule,
            providers: [
                {
                    provide: PIK_AUTH_CONFIG,
                    useValue: config,
                },
            ]
        };
    }
    static forChild() {
        return {
            ngModule: PikAuthModule,
            providers: []
        };
    }
}
PikAuthModule.ɵfac = function PikAuthModule_Factory(t) { return new (t || PikAuthModule)(ɵngcc0.ɵɵinject(PikAuthRedirectService)); };
PikAuthModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikAuthModule });
PikAuthModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        OidcConfigService,
        PikAuthService,
        PikAuthenticatedGuard,
        PikAuthRedirectService,
        PikAnonymousGuard,
        PikAutoLoginGuard,
        PikSecurityStorageService,
        PikAuthGuard,
        {
            provide: APP_INITIALIZER,
            useFactory: ɵ0,
            deps: [OidcConfigService, PikLocatorService, PIK_AUTH_CONFIG],
            multi: true
        },
    ], imports: [[
            CommonModule,
            AuthModule.forRoot({
                storage: PikSecurityStorageService
            }),
            PikCommonModule.forChild(),
            PikAuthRoutingModule,
            PikStorageModule,
        ]] });
PikAuthModule.ctorParameters = () => [
    { type: PikAuthRedirectService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAuthModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AuthModule.forRoot({
                        storage: PikSecurityStorageService
                    }),
                    PikCommonModule.forChild(),
                    PikAuthRoutingModule,
                    PikStorageModule,
                ],
                declarations: [
                    AuthCallbackComponent
                ],
                providers: [
                    OidcConfigService,
                    PikAuthService,
                    PikAuthenticatedGuard,
                    PikAuthRedirectService,
                    PikAnonymousGuard,
                    PikAutoLoginGuard,
                    PikSecurityStorageService,
                    PikAuthGuard,
                    {
                        provide: APP_INITIALIZER,
                        useFactory: ɵ0,
                        deps: [OidcConfigService, PikLocatorService, PIK_AUTH_CONFIG],
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: PikAuthRedirectService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikAuthModule, { declarations: function () { return [AuthCallbackComponent]; }, imports: function () { return [CommonModule, ɵngcc3.AuthModule, PikCommonModule, PikAuthRoutingModule, PikStorageModule]; } }); })();

class PikAuthInterceptor {
    constructor(auth) {
        this.auth = auth;
        this.refreshTokenInProgress = false;
        /**
         * Переменная для отслеживания процесса обновления токена
         *
         * @private
         * @type {BehaviorSubject<boolean>}
         * @memberof PikAuthInterceptor
         */
        this.tokenRefreshed = new BehaviorSubject(null);
    }
    intercept(request, next) {
        return next.handle(this.addAuthenticationToken(request))
            .pipe(catchError(error => {
            // отслеживаем только 401 ошибку, остальные пробрасываем дальше
            if (error.status !== 401) {
                console.debug('[PikAuthInterceptor] Not an 401 error');
                return throwError(error);
            }
            if (this.auth.isTokenExpired()) {
                console.debug('[PikAuthInterceptor] Token wax expired');
                return throwError(error);
            }
            if (this.refreshTokenInProgress) {
                console.debug('[PikAuthInterceptor] Refreshing of token is in progress');
                // если токен был обновлён - отправляем запрос снова
                return this.tokenRefreshed.pipe(filter(res => res !== null), take(1), switchMap(() => {
                    console.debug('[PikAuthInterceptor] Send original http request cause other refresh request complete');
                    return next.handle(this.addAuthenticationToken(request));
                }));
            }
            console.debug('[PikAuthInterceptor] Force Refresh Token');
            // токен начали обновлять
            this.refreshTokenInProgress = true;
            // отслеживаем обновление токена
            this.tokenRefreshed.next(null);
            // выполняем обновление сессии
            return this.auth.forceRefreshSession().pipe(take(1), switchMap((token) => {
                console.debug('[PikAuthInterceptor] New token has been received');
                // отмечаем, что токен больше не обновляем
                this.refreshTokenInProgress = false;
                // указываем, что токен обновился
                this.tokenRefreshed.next(true);
                // выполняем исходный запрос
                console.debug('[PikAuthInterceptor] Send original http request');
                return next.handle(this.addAuthenticationToken(request));
            }), catchError(err => {
                console.debug('[PikAuthInterceptor] Error during force refresh token');
                // отмечаем, что токен больше не обновляем
                this.refreshTokenInProgress = false;
                // пробрасываем ошибку выше по стеку
                throw err;
            }));
        }));
    }
    addAuthenticationToken(request) {
        const accessToken = this.auth.getToken();
        if (!accessToken) {
            return request;
        }
        return request.clone({
            setHeaders: {
                Authorization: this.auth.getAuthorizationHeaderValue()
            }
        });
    }
}
PikAuthInterceptor.ɵfac = function PikAuthInterceptor_Factory(t) { return new (t || PikAuthInterceptor)(ɵngcc0.ɵɵinject(PikAuthService)); };
PikAuthInterceptor.ɵprov = ɵɵdefineInjectable({ factory: function PikAuthInterceptor_Factory() { return new PikAuthInterceptor(ɵɵinject(PikAuthService)); }, token: PikAuthInterceptor, providedIn: "root" });
PikAuthInterceptor.ctorParameters = () => [
    { type: PikAuthService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAuthInterceptor, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: PikAuthService }]; }, null); })();

/**
 * Helpers
 */
class Helpers {
    /**
     * @deprecated не должно являться частью этой библиотеки
     * @param obj
     */
    static clone(obj) {
        let copy;
        // Handle the 3 simple types, and null or undefined
        if (null == obj || 'object' !== typeof obj) {
            return obj;
        }
        ;
        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }
        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.clone(obj[i]);
            }
            return copy;
        }
        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    copy[attr] = this.clone(obj[attr]);
                }
            }
            return copy;
        }
        throw new Error('Unable to copy obj! Its type isn\'t supported.');
    }
    // eslint-disable-next-line @typescript-eslint/member-ordering
    static getDate(val) {
        if (val) {
            if (val.indexOf('.') !== -1) {
                const date = val.split('.');
                if (date.length >= 3) {
                    try {
                        return new Date(+date[2], +date[1] - 1, +date[0]);
                    }
                    catch (e) {
                        console.log(`error on convert data ${val}. ${e}`);
                    }
                }
            }
            else {
                try {
                    return new Date(val);
                }
                catch (e) {
                    console.log(`error on convert data ${val}. ${e}`);
                }
            }
        }
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/member-ordering
    static getDate2(val) {
        if (val) {
            const date = val.split('-');
            if (date.length >= 3) {
                try {
                    return new Date(+date[0], +date[1] - 1, +date[2]);
                }
                catch (e) {
                    console.log(`error on convert data ${val}. ${e}`);
                }
            }
        }
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/member-ordering
    static concatUrls(first, second, check = true) {
        if (!first) {
            return second;
        }
        if (!second) {
            return first;
        }
        if (check) {
            if (second.startsWith('http://') || second.startsWith('https://')) {
                return second;
            }
        }
        if (first.endsWith('/') && !second.startsWith('/')
            || !first.endsWith('/') && second.startsWith('/')) {
            return first + second;
        }
        else {
            return `${first}/${second}`;
        }
    }
}
Helpers.months = [
    'январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
];
Helpers.accumonths = [
    'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'
];

class BaseService {
    constructor(http, auth, authSettings = null) {
        this.http = http;
        this.auth = auth;
        this.authSettings = authSettings;
    }
    get(operationName, callbackExtractData = null, withCredentials = true) {
        const options = {};
        if (withCredentials) {
            options.withCredentials = withCredentials;
        }
        return this.http.get(this.getUrl(operationName), options).pipe(map(callbackExtractData ? callbackExtractData : res => res));
    }
    getBlob(operationName, callbackExtractData = null, withCredentials = true) {
        const options = {};
        if (withCredentials) {
            options.withCredentials = withCredentials;
            options.responseType = 'blob';
        }
        return this.http.get(this.getUrl(operationName), options).pipe(map(callbackExtractData ? callbackExtractData : res => res));
    }
    post(operationName, data, headers = null, callbackExtractData = null, responseType = 'json', withCredentials = false) {
        let options;
        if (responseType === 'text') {
            options = { responseType: 'text', withCredentials };
        }
        else {
            options = { withCredentials };
        }
        return this.http.post(this.getUrl(operationName), data, options)
            .pipe(map(callbackExtractData ? callbackExtractData : res => res));
    }
    getUrl(operationName) {
        let url = Helpers.concatUrls(this.serviceUrl, operationName);
        if (operationName && (operationName.startsWith('http://') || operationName.startsWith('https://'))) {
            url = operationName;
        }
        return url;
    }
}
BaseService.ɵfac = function BaseService_Factory(t) { return new (t || BaseService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG)); };
BaseService.ɵprov = ɵɵdefineInjectable({ factory: function BaseService_Factory() { return new BaseService(ɵɵinject(HttpClient), ɵɵinject(PikAuthService), ɵɵinject(PIK_AUTH_CONFIG)); }, token: BaseService, providedIn: "root" });
BaseService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikAuthService },
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikAuthService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }]; }, null); })();

/**
 * Метаданные ответа (только для массива объектов)
 *
 * @export
 * @class Meta
 */
class Meta {
}

class ForbiddenComponent {
    constructor(route, auth = null, header = null) {
        this.route = route;
        this.auth = auth;
        this.header = header;
        if (this.header) {
            this.header.hide();
        }
        this.route.queryParams.pipe(take(1)).subscribe(params => {
            const fromUrl = params.from_url;
            this.fromUrl = fromUrl ? decodeURIComponent(fromUrl) : '';
        });
    }
    logout() {
        if (this.auth) {
            this.logout();
        }
    }
}
ForbiddenComponent.ɵfac = function ForbiddenComponent_Factory(t) { return new (t || ForbiddenComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(PikAuthService, 8), ɵngcc0.ɵɵdirectiveInject(PikHeaderService, 8)); };
ForbiddenComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ForbiddenComponent, selectors: [["app-forbidden"]], decls: 11, vars: 2, consts: [[1, "error"], [1, "container", "error__container"], [1, "error__number"], [1, "error__message"], [3, "href", 4, "ngIf"], [4, "ngIf"], ["href", "/", 1, "error__link"], [3, "href"], ["href", "#", 1, "error__link", 3, "click"]], template: function ForbiddenComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3, "403");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "p", 3);
        ɵngcc0.ɵɵtext(5, " \u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u043D\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B ");
        ɵngcc0.ɵɵtemplate(6, ForbiddenComponent_a_6_Template, 2, 2, "a", 4);
        ɵngcc0.ɵɵtext(7, ". \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C ");
        ɵngcc0.ɵɵtemplate(8, ForbiddenComponent_ng_container_8_Template, 4, 0, "ng-container", 5);
        ɵngcc0.ɵɵelementStart(9, "a", 6);
        ɵngcc0.ɵɵtext(10, "\u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fromUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.auth);
    } }, directives: [ɵngcc5.NgIf], styles: [_c0] });
ForbiddenComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: PikAuthService, decorators: [{ type: Optional }] },
    { type: PikHeaderService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ForbiddenComponent, [{
        type: Component,
        args: [{
                selector: 'app-forbidden',
                template: "<div class=\"error\">\n  <div class=\"container error__container\">\n    <span class=\"error__number\">403</span>\n    <p class=\"error__message\">\n      \u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u043D\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B <a [href]=\"fromUrl\" *ngIf=\"fromUrl\">{{fromUrl}}</a>.\n      \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C\n      <ng-container *ngIf=\"auth\">\n        <a class=\"error__link\" href=\"#\" (click)=\"logout()\">\u0432\u044B\u0439\u0442\u0438</a>, \u0430 \u0437\u0430\u0442\u0435\u043C \u0432\u043E\u0439\u0442\u0438 \u0441\u043D\u043E\u0432\u0430 \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C. \u0418\u043B\u0438 \u043C\u043E\u0436\u0435\u0442\u0435\n      </ng-container>\n      <a class=\"error__link\" href=\"/\">\u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443</a>\n    </p>\n  </div>\n</div>\n",
                styles: [".error{width:100%;min-height:100vh;background-color:#1a1a1a}.error__container{padding:74px 20px 34px;overflow:hidden}.error__number{display:block;font-size:160px;line-height:154px;font-weight:700;color:hsla(0,0%,100%,.05);text-align:left}.error__message{margin-top:25px;margin-bottom:0;width:500px;min-height:435px;font-size:20px;font-weight:400;line-height:30px;color:#fff}.error__link{font-weight:700;text-decoration:underline}@media (min-width:768px){.error__container{display:flex;padding-top:0;padding-right:0;padding-left:0;position:relative;min-width:768px;max-width:1304px;min-height:576px}.error__number{position:absolute;left:17px;top:52px;font-size:300px;line-height:288px;font-weight:700;color:hsla(0,0%,100%,.05)}}@media (min-width:768px) and (min-width:1024px){.error__number{font-size:480px;line-height:576px}}@media (min-width:768px){.error__message{margin-top:205px;margin-left:28px;width:597px;min-height:auto;z-index:1}}@media (min-width:768px) and (min-width:1024px){.error__message{margin-top:362px}}@media (min-width:1420px){.error__number{font-size:600px;line-height:576px}}@media (min-width:1920px){.error__container{max-width:1760px}.error__number{left:264px}.error__message{margin-top:358px;margin-left:6px}}"]
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: PikAuthService, decorators: [{
                type: Optional
            }] }, { type: PikHeaderService, decorators: [{
                type: Optional
            }] }]; }, null); })();

class NotFoundComponent {
    constructor(header = null) {
        this.header = header;
        if (this.header) {
            this.header.hide();
        }
    }
}
NotFoundComponent.ɵfac = function NotFoundComponent_Factory(t) { return new (t || NotFoundComponent)(ɵngcc0.ɵɵdirectiveInject(PikHeaderService, 8)); };
NotFoundComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotFoundComponent, selectors: [["app-not-found"]], decls: 8, vars: 0, consts: [[1, "error"], [1, "container", "error__container"], [1, "error__number"], [1, "error__message"], ["href", "/", 1, "error__link"]], template: function NotFoundComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3, "404");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "p", 3);
        ɵngcc0.ɵɵtext(5, " \u0414\u0430\u043D\u043D\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C ");
        ɵngcc0.ɵɵelementStart(6, "a", 4);
        ɵngcc0.ɵɵtext(7, "\u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [_c0] });
NotFoundComponent.ctorParameters = () => [
    { type: PikHeaderService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotFoundComponent, [{
        type: Component,
        args: [{
                selector: 'app-not-found',
                template: "<div class=\"error\">\n  <div class=\"container error__container\">\n    <span class=\"error__number\">404</span>\n    <p class=\"error__message\">\n      \u0414\u0430\u043D\u043D\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C <a class=\"error__link\" href=\"/\">\u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443</a>\n    </p>\n  </div>\n</div>\n",
                styles: [".error{width:100%;min-height:100vh;background-color:#1a1a1a}.error__container{padding:74px 20px 34px;overflow:hidden}.error__number{display:block;font-size:160px;line-height:154px;font-weight:700;color:hsla(0,0%,100%,.05);text-align:left}.error__message{margin-top:25px;margin-bottom:0;width:500px;min-height:435px;font-size:20px;font-weight:400;line-height:30px;color:#fff}.error__link{font-weight:700;text-decoration:underline}@media (min-width:768px){.error__container{display:flex;padding-top:0;padding-right:0;padding-left:0;position:relative;min-width:768px;max-width:1304px;min-height:576px}.error__number{position:absolute;left:17px;top:52px;font-size:300px;line-height:288px;font-weight:700;color:hsla(0,0%,100%,.05)}}@media (min-width:768px) and (min-width:1024px){.error__number{font-size:480px;line-height:576px}}@media (min-width:768px){.error__message{margin-top:205px;margin-left:28px;width:597px;min-height:auto;z-index:1}}@media (min-width:768px) and (min-width:1024px){.error__message{margin-top:362px}}@media (min-width:1420px){.error__number{font-size:600px;line-height:576px}}@media (min-width:1920px){.error__container{max-width:1760px}.error__number{left:264px}.error__message{margin-top:358px;margin-left:6px}}"]
            }]
    }], function () { return [{ type: PikHeaderService, decorators: [{
                type: Optional
            }] }]; }, null); })();

class UnauthorizedComponent {
    constructor(auth = null, header = null) {
        this.auth = auth;
        this.header = header;
        if (this.header) {
            this.header.hide();
        }
    }
    logout() {
        if (this.auth) {
            this.auth.logout();
        }
    }
}
UnauthorizedComponent.ɵfac = function UnauthorizedComponent_Factory(t) { return new (t || UnauthorizedComponent)(ɵngcc0.ɵɵdirectiveInject(PikAuthService, 8), ɵngcc0.ɵɵdirectiveInject(PikHeaderService, 8)); };
UnauthorizedComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UnauthorizedComponent, selectors: [["app-unauthorized"]], decls: 10, vars: 1, consts: [[1, "error"], [1, "container", "error__container"], [1, "error__number"], [1, "error__message"], [4, "ngIf"], ["href", "/", 1, "error__link"], ["href", "#", 1, "error__link", 3, "click"]], template: function UnauthorizedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3, "401");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "p", 3);
        ɵngcc0.ɵɵtext(5, " \u041D\u0435 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u0432\u043A\u043B\u0430\u0434\u043A\u0443 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0438 \u0432\u043E\u0439\u0442\u0438 \u0441\u043D\u043E\u0432\u0430. \u0422\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C ");
        ɵngcc0.ɵɵtemplate(6, UnauthorizedComponent_ng_container_6_Template, 4, 0, "ng-container", 4);
        ɵngcc0.ɵɵelementStart(7, "a", 5);
        ɵngcc0.ɵɵtext(8, "\u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, ". \u0415\u0441\u043B\u0438 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043F\u043E\u043C\u043E\u0433\u043B\u043E - \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.header);
    } }, directives: [ɵngcc5.NgIf], styles: [_c0] });
UnauthorizedComponent.ctorParameters = () => [
    { type: PikAuthService, decorators: [{ type: Optional }] },
    { type: PikHeaderService, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UnauthorizedComponent, [{
        type: Component,
        args: [{
                selector: 'app-unauthorized',
                template: "<div class=\"error\">\n  <div class=\"container error__container\">\n    <span class=\"error__number\">401</span>\n    <p class=\"error__message\">\n      \u041D\u0435 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D.\n      \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u0432\u043A\u043B\u0430\u0434\u043A\u0443 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0438 \u0432\u043E\u0439\u0442\u0438 \u0441\u043D\u043E\u0432\u0430.\n      \u0422\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C\n      <ng-container *ngIf=\"header\">\n        <a class=\"error__link\" href=\"#\" (click)=\"logout()\">\u0432\u044B\u0439\u0442\u0438</a>, \u0430\n        \u0437\u0430\u0442\u0435\u043C \u0432\u043E\u0439\u0442\u0438 \u0441\u043D\u043E\u0432\u0430 \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C.\n        \u0418\u043B\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C\n      </ng-container> <a class=\"error__link\" href=\"/\">\u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443</a>.\n      \u0415\u0441\u043B\u0438 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043F\u043E\u043C\u043E\u0433\u043B\u043E - \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.\n    </p>\n  </div>\n</div>\n",
                styles: [".error{width:100%;min-height:100vh;background-color:#1a1a1a}.error__container{padding:74px 20px 34px;overflow:hidden}.error__number{display:block;font-size:160px;line-height:154px;font-weight:700;color:hsla(0,0%,100%,.05);text-align:left}.error__message{margin-top:25px;margin-bottom:0;width:500px;min-height:435px;font-size:20px;font-weight:400;line-height:30px;color:#fff}.error__link{font-weight:700;text-decoration:underline}@media (min-width:768px){.error__container{display:flex;padding-top:0;padding-right:0;padding-left:0;position:relative;min-width:768px;max-width:1304px;min-height:576px}.error__number{position:absolute;left:17px;top:52px;font-size:300px;line-height:288px;font-weight:700;color:hsla(0,0%,100%,.05)}}@media (min-width:768px) and (min-width:1024px){.error__number{font-size:480px;line-height:576px}}@media (min-width:768px){.error__message{margin-top:205px;margin-left:28px;width:597px;min-height:auto;z-index:1}}@media (min-width:768px) and (min-width:1024px){.error__message{margin-top:362px}}@media (min-width:1420px){.error__number{font-size:600px;line-height:576px}}@media (min-width:1920px){.error__container{max-width:1760px}.error__number{left:264px}.error__message{margin-top:358px;margin-left:6px}}"]
            }]
    }], function () { return [{ type: PikAuthService, decorators: [{
                type: Optional
            }] }, { type: PikHeaderService, decorators: [{
                type: Optional
            }] }]; }, null); })();

const pikErrorPagesRoutes = [
    {
        path: '401',
        component: UnauthorizedComponent,
    },
    {
        path: '403',
        component: ForbiddenComponent,
    },
    {
        path: '404',
        component: NotFoundComponent,
    },
];
class PikErrorPagesRoutingModule {
}
PikErrorPagesRoutingModule.ɵfac = function PikErrorPagesRoutingModule_Factory(t) { return new (t || PikErrorPagesRoutingModule)(); };
PikErrorPagesRoutingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikErrorPagesRoutingModule });
PikErrorPagesRoutingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[RouterModule.forChild(pikErrorPagesRoutes)], RouterModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikErrorPagesRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(pikErrorPagesRoutes)],
                exports: [RouterModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikErrorPagesRoutingModule, { imports: function () { return [ɵngcc2.RouterModule]; }, exports: function () { return [RouterModule]; } }); })();

class PikErrorPagesModule {
}
PikErrorPagesModule.ɵfac = function PikErrorPagesModule_Factory(t) { return new (t || PikErrorPagesModule)(); };
PikErrorPagesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikErrorPagesModule });
PikErrorPagesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PikErrorPagesRoutingModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikErrorPagesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PikErrorPagesRoutingModule,
                ],
                declarations: [
                    ForbiddenComponent,
                    NotFoundComponent,
                    UnauthorizedComponent,
                ],
                exports: [
                    ForbiddenComponent,
                    NotFoundComponent,
                    UnauthorizedComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikErrorPagesModule, { declarations: function () { return [ForbiddenComponent, NotFoundComponent, UnauthorizedComponent]; }, imports: function () { return [CommonModule, PikErrorPagesRoutingModule]; }, exports: function () { return [ForbiddenComponent, NotFoundComponent, UnauthorizedComponent]; } }); })();

class EmployeeService extends BaseService {
    constructor(http, auth, locator, authSettings, datePipe) {
        super(http, auth, authSettings);
        this.http = http;
        this.auth = auth;
        this.locator = locator;
        this.authSettings = authSettings;
        this.datePipe = datePipe;
        this.photoUpdated = new BehaviorSubject(null);
        this.serviceUrl = Helpers.concatUrls(this.locator.urls.homeApi, '/api/v1.0/employee');
    }
    GetImageUrl(employee, renditionId) {
        if (employee && employee.individualGuid1C) {
            const rendition = renditionId ? `?renditionId=${renditionId}` : '';
            return Helpers.concatUrls(this.locator.urls.photoApi, `/api/v1.0/UserPhoto/${employee.individualGuid1C}${rendition}`);
        }
        return '';
    }
    /**
     * Получение сотрудника по ИД
     */
    getEmployee(id) {
        return this.get(`${id}?t=${new Date().getTime()}`, (employee) => {
            if (employee) {
                return this.checkEmployee(employee);
            }
            return null;
        }, true);
    }
    /**
     * Получение текущего пользователя
     */
    getCurrent() {
        return this.currentUser
            ? this.currentUser
            : this.currentUser = this.get(`current`).pipe(publishReplay(1, 300000), refCount());
    }
    /**
     * Получение логина текущего пользователя
     */
    getCurrentLogin() {
        return this.get(`current`, res => {
            if (res) {
                try {
                    return res.login;
                }
                catch (e) {
                    console.log(e);
                }
            }
            return null;
        }, true);
    }
    getByLogin(login) {
        const loginString = login ? `?login=${encodeURIComponent(login)}` : '';
        return this.get(`byLogin${loginString}`, res => {
            // TODO: удалить после обновы шапки на других сервисах
            if (typeof res.data !== 'object') {
                return res;
            }
            return res.data;
        });
    }
    getEmployees(unitId, start, limit) {
        const startString = start ? 'start=' + start : '&';
        const limitString = 'limit=' + (limit ? limit : 300);
        return this.get(`all/${unitId}?${startString}${limitString}&t=${new Date().getTime()}`, (res) => {
            const employees = res;
            employees.forEach(employee => {
                this.checkEmployee(employee);
            });
            return employees;
        }, true);
    }
    getEmployeeSettings() {
        return this.get(`settings`);
    }
    userIsPhotoAdmin() {
        return this.get(`userIsPhotoAdmin?t=${new Date().getTime()}`, null, true);
    }
    getEmployeePhoto(employee, small) {
        if (employee) {
            if (!employee.photo) {
                employee.photo = this.GetImageUrl(employee, null);
            }
            return this.GetImageUrl(employee, small ? 1 : 2);
        }
        return '';
    }
    /**
     * Получение фотографии сотрудника по id
     */
    getEmployeePhotoById(id) {
        return this.getBlob(`${this.serviceUrl}/${id}/photo?RenditionID=5`);
    }
    checkEmployee(employee) {
        if (employee.birthday) {
            this.isBirthdayToday(employee, employee.birthday);
        }
        // eslint-disable-next-line eqeqeq
        if (employee.birthday && employee.birthday.indexOf('Date(') != -1) {
            // eslint-disable-next-line radix
            employee.birthday = new Date(parseInt(employee.birthday.substr(6)));
        }
        // eslint-disable-next-line eqeqeq
        if (employee.birthday instanceof Date && employee.birthday.getYear() == 99) {
            employee.birthday = null;
        }
        if (employee.vacations) {
            this.getEmployeeVacation(employee);
        }
        employee.photo = this.GetImageUrl(employee, null);
        return employee;
    }
    getEmployeeVacation(employee) {
        employee.vacations.forEach((vacation) => {
            if (vacation.startDate && vacation.endDate) {
                const date = this.getDateWithoutHours(new Date());
                const startDate = this.getDateWithoutHours(vacation.startDate);
                const endDate = this.getDateWithoutHours(vacation.endDate);
                if (startDate <= date) {
                    vacation.text = `В отпуске по ${this.datePipe.transform(vacation.endDate, 'd MMMM')} `;
                    vacation.started = true;
                }
                else if (startDate > date) {
                    if (startDate.getTime() === endDate.getTime()) {
                        vacation.text = `Идёт в отпуск ${this.datePipe.transform(startDate, 'd MMMM')} на один день`;
                    }
                    else {
                        vacation.text = 'Идёт в отпуск'
                            + ` с ${this.datePipe.transform(startDate, 'd MMMM')}`
                            + ` по ${this.datePipe.transform(endDate, 'd MMMM')}`;
                    }
                }
            }
        });
        return employee.vacations;
    }
    /**
     * Вернуть дату, округленную до дней
     */
    getDateWithoutHours(dateString) {
        const tempDate = new Date(dateString);
        return new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate());
    }
    getEmployeeUrl(employee) {
        if (employee) {
            return Helpers.concatUrls(this.locator.urls.homeUrl, `/employees/${employee.id}`);
        }
        return 'javascript:void(0);';
    }
    isBirthdayToday(employee, birthday) {
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        date.setFullYear(2000, date.getMonth(), date.getDate());
        const b = Helpers.getDate2(birthday);
        b.setHours(0, 0, 0, 0);
        employee.birthdayToday = date.toDateString() === b.toDateString();
        return employee.birthdayToday;
    }
    getIndividualPhoto(userIdentity, small) {
        if (userIdentity) {
            if (!userIdentity.photo) {
                userIdentity.photo = this.GetIndividualImageUrl(userIdentity, null);
            }
            return this.GetIndividualImageUrl(userIdentity, small ? 1 : 2);
        }
        return '';
    }
    GetIndividualImageUrl(userIdentity, renditionId) {
        if (userIdentity && userIdentity.individualGuid1C) {
            const rendition = renditionId ? `?renditionId=${renditionId}` : '';
            return Helpers.concatUrls(this.locator.urls.photoApi, `/api/v1.0/UserPhoto/${userIdentity.individualGuid1C}${rendition}`);
        }
        return '';
    }
}
EmployeeService.ɵfac = function EmployeeService_Factory(t) { return new (t || EmployeeService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PikLocatorService), ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG), ɵngcc0.ɵɵinject(ɵngcc5.DatePipe)); };
EmployeeService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EmployeeService, factory: EmployeeService.ɵfac });
EmployeeService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikAuthService },
    { type: PikLocatorService },
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] },
    { type: DatePipe }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EmployeeService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikAuthService }, { type: PikLocatorService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }, { type: ɵngcc5.DatePipe }]; }, null); })();

class PortalService extends BaseService {
    constructor(http, auth, locator, authSettings) {
        super(http, auth, authSettings);
        this.http = http;
        this.auth = auth;
        this.locator = locator;
        this.authSettings = authSettings;
        this.serviceUrl = Helpers.concatUrls(this.locator.urls.homeApi, '/api/v1.0/portal');
    }
    getUserName() {
        return this.get('userName', null, true);
    }
}
PortalService.ɵfac = function PortalService_Factory(t) { return new (t || PortalService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PikLocatorService), ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG)); };
PortalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PortalService, factory: PortalService.ɵfac });
PortalService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikAuthService },
    { type: PikLocatorService },
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PortalService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikAuthService }, { type: PikLocatorService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }]; }, null); })();

/**
 * API навигации
 */
class NavigationService extends BaseService {
    constructor(http, locator, auth, authSettings) {
        super(http, auth, authSettings);
        this.http = http;
        this.locator = locator;
        this.auth = auth;
        this.authSettings = authSettings;
        this.serviceUrl = this.locator.urls.navigationApi + '/api/v1.0/';
    }
    /**
     * Получить навигацию для верхнего меню
     *
     * @param string url
     * @returns Promise<NavigationNode>
     * @memberof NavigationService
     */
    getNavigation(url) {
        return this.get(`navigation?url=${encodeURIComponent(this.checkUrl(url))}`, null, true);
    }
    getCurrent() {
        return this.get(`userIdentity/current`, null, true);
    }
    checkUrl(url) {
        if (url && url.indexOf('access_token') !== -1) {
            return '';
        }
        return url;
    }
}
NavigationService.ɵfac = function NavigationService_Factory(t) { return new (t || NavigationService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikLocatorService), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG)); };
NavigationService.ɵprov = ɵɵdefineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(ɵɵinject(HttpClient), ɵɵinject(PikLocatorService), ɵɵinject(PikAuthService), ɵɵinject(PIK_AUTH_CONFIG)); }, token: NavigationService, providedIn: "root" });
NavigationService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikLocatorService },
    { type: PikAuthService },
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikLocatorService }, { type: PikAuthService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }]; }, null); })();

/**
 * Класс для работы виджета поиска
 *
 * @export
 * @class SearchService
 * @extends {BaseService}
 */
class SearchService extends BaseService {
    constructor(http, auth, locator, authSettings, employeeService) {
        super(http, auth, authSettings);
        this.http = http;
        this.auth = auth;
        this.locator = locator;
        this.authSettings = authSettings;
        this.employeeService = employeeService;
        this.serviceUrl = Helpers.concatUrls(this.locator.urls.homeApi, '/api/v1.0/search');
    }
    /**
     * Поиск по Employee и Unit
     *
     * @param text
     * @param start
     * @param limit
     * @returns
     * @memberof SearchService
     */
    search(text, start, limit) {
        return this.get(`search?text=${text}&start=${start}&limit=${limit}`, null, true);
    }
    /**
     * Поиск по Employee
     *
     * @param text
     * @param start
     * @param limit
     * @returns
     * @memberof SearchService
     */
    searchEmployee(text, start, limit) {
        return this.get(`searchEmployee?text=${text}&start=${start}&limit=${limit}`, (res) => {
            const employees = res.items;
            employees.forEach(employee => {
                this.employeeService.checkEmployee(employee);
            });
            return res;
        }, true);
    }
    /**
     * Поиск по Unit
     *
     * @param text
     * @param start
     * @param limit
     * @returns
     * @memberof SearchService
     */
    searchUnit(text, start, limit) {
        return this.get(`searchUnit?text=${text}&start=${start}&limit=${limit}`, null, true);
    }
    /**
     * Поиск по новостям
     *
     * @param offset
     * @param limit
     * @param text
     * @returns
     * @memberof SearchService
     */
    searchNews(offset, limit, text) {
        return this.get(`news?offset=${offset}&limit=${limit}&text=${text}`);
    }
}
SearchService.ɵfac = function SearchService_Factory(t) { return new (t || SearchService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PikLocatorService), ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG), ɵngcc0.ɵɵinject(EmployeeService)); };
SearchService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SearchService, factory: SearchService.ɵfac });
SearchService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikAuthService },
    { type: PikLocatorService },
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] },
    { type: EmployeeService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikAuthService }, { type: PikLocatorService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }, { type: EmployeeService }]; }, null); })();

/**
 * Результат поиска по каждой категории
 *
 * @export
 * @class SearchResult
 * @template T
 */
class SearchResult {
    constructor() {
        this.items = new Array();
    }
}

/**
 * Агрегированный результат поиска по всем категориям
 */
class SearchResults {
    constructor() {
        this.employees = new SearchResult();
        this.units = new SearchResult();
        this.news = new SearchResult();
        this.pages = new SearchResult();
    }
}

/**
 * Базовый класс поиска
 */
class BaseSearchComponent {
    /**
     * Перевод в другую раскладку
     *
     * @returns
     * @memberof HeaderSearchComponent
     */
    checkQuery(query) {
        if (query && query.length > 1) {
            if (query[query.length - 1] !== '*') {
                query += '*';
            }
            const eng = '`qwertyuiop[]asdfghjkl;\'zxcvbnm,.~{}:\"<>';
            const ru = 'ёйцукенгшщзхъфывапролджэячсмитьбюЁХЪЖЭБЮ';
            let newRes = '';
            for (let i = 0; i < query.length; i++) {
                const index = eng.indexOf(query[i].toLowerCase());
                if (index !== -1) {
                    newRes += ru[index];
                }
                else {
                    newRes += query[i];
                }
            }
            if (query !== newRes) {
                query = query + ' OR ' + newRes;
            }
            this.query = newRes.replace('*', '');
        }
        return query;
    }
}

/**
 * Сервис базы знаний
 */
class WikiService extends BaseService {
    constructor(http, auth, locator) {
        super(http, auth);
        this.http = http;
        this.auth = auth;
        this.locator = locator;
        this.serviceUrl = Helpers.concatUrls(this.locator.urls.infoApi, '/api/v1.0/Page');
    }
    searchPage(offset, limit, text) {
        return this.get(`search?offset=${offset}&limit=${limit}&text=${text}`);
    }
}
WikiService.ɵfac = function WikiService_Factory(t) { return new (t || WikiService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PikLocatorService)); };
WikiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: WikiService, factory: WikiService.ɵfac });
WikiService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikAuthService },
    { type: PikLocatorService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WikiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikAuthService }, { type: PikLocatorService }]; }, null); })();

class BaseSearchInputComponent extends BaseSearchComponent {
    constructor(searchService, wikiService, employeeService) {
        super();
        this.searchService = searchService;
        this.wikiService = wikiService;
        this.employeeService = employeeService;
        this.destroyed$ = new Subject();
        this.searchFinished$ = new Subject();
        this.loaded = false;
        this.start = 0;
        this.limit = 5;
    }
    /**
     * Отправить запрос на поиск
     *
     * @private
     * @memberof HeaderSearchComponent
     */
    runSearch(text) {
        forkJoin(this.searchService.search(encodeURIComponent(text.trim()), this.start, this.limit), this.searchService.searchNews(this.start, this.limit, encodeURIComponent(text.trim())), this.wikiService.searchPage(this.start, this.limit, encodeURIComponent(text.trim())))
            .pipe(take(1), takeUntil(this.destroyed$))
            .subscribe(result => {
            if (result) {
                // Cотрудники и подразделения
                this.searchResults = result[0];
                const vacationsMap = new Map();
                this.searchResults.employees.items.forEach((item) => {
                    if (item.vacations && item.vacations.length) {
                        let vacations = vacationsMap.get(item.individualGuid1C);
                        if (!vacations) {
                            vacations = [];
                        }
                        item.vacations.forEach(vacation => {
                            vacations.push(vacation);
                        });
                        vacationsMap.set(item.individualGuid1C, vacations);
                    }
                });
                this.searchResults.employees.items.forEach(e => {
                    e.vacations = vacationsMap.get(e.individualGuid1C) || [];
                    this.employeeService.checkEmployee(e);
                });
                // Новости
                this.searchResults.news = new SearchResult();
                this.searchResults.news.count = result[1].meta.totalCount;
                if (this.searchResults.news.count > 0) {
                    this.searchResults.news.items = result[1].data;
                }
                this.searchResults.count += this.searchResults.news.count;
                // Страницы
                this.searchResults.pages = new SearchResult();
                this.searchResults.pages.count = result[2].meta.totalCount;
                if (this.searchResults.pages.count > 0) {
                    this.searchResults.pages.items = result[2].data;
                }
                this.searchResults.count += this.searchResults.pages.count;
            }
            if (this.searchResults.count === 0) {
                this.searchResults.message = 'Совпадения не найдены';
            }
            else {
                this.searchResults.error = this.searchResults.message = '';
            }
            this.loaded = true;
            this.searchFinished$.next();
        }, error => {
            console.log(error);
            this.searchResults.error = this.searchResults.message = 'Произошла ошибка при поиске данных';
            this.loaded = true;
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
BaseSearchInputComponent.ɵfac = function BaseSearchInputComponent_Factory(t) { return new (t || BaseSearchInputComponent)(ɵngcc0.ɵɵdirectiveInject(SearchService), ɵngcc0.ɵɵdirectiveInject(WikiService), ɵngcc0.ɵɵdirectiveInject(EmployeeService)); };
BaseSearchInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BaseSearchInputComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function BaseSearchInputComponent_Template(rf, ctx) { }, encapsulation: 2 });
BaseSearchInputComponent.ctorParameters = () => [
    { type: SearchService },
    { type: WikiService },
    { type: EmployeeService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseSearchInputComponent, [{
        type: Component,
        args: [{
                template: ''
            }]
    }], function () { return [{ type: SearchService }, { type: WikiService }, { type: EmployeeService }]; }, null); })();

class HeaderSearchComponent extends BaseSearchInputComponent {
    constructor(searchService, wikiService, employeeService, locator) {
        super(searchService, wikiService, employeeService);
        this.searchService = searchService;
        this.wikiService = wikiService;
        this.employeeService = employeeService;
        this.locator = locator;
        this.searchClose = new EventEmitter();
        this.searchControl = new FormControl();
        this.selectedItemIndex = 0;
    }
    set setKeyword(keyword) {
        this.keyword = keyword;
        this.searchControl.setValue(this.keyword ? this.keyword : '');
    }
    /**
     * Переключить фокус на строку поиска
     *
     * @memberof HeaderSearchComponent
     */
    focus() {
        const that = this;
        setTimeout(() => {
            that.searchInput.nativeElement.focus();
        }, 40);
    }
    /**
     * Срабатывает при начале поиска
     *
     * @param e
     * @returns
     * @memberof HeaderSearchComponent
     */
    onSearchKey(e) {
        clearTimeout(this.timeoutId);
        if (e.keyCode === 27) {
            this.clickOutside();
            return false;
        }
        if (e.keyCode === 13 && this.focusedItem && this.focusedItem.length) {
            console.log('selected item clicked');
            this.focusedItem.find('a')[0].click();
            return false;
        }
        if (e.keyCode === 40 || e.keyCode === 38 && this.loaded) {
            if (this.focusedItem && this.focusedItem.length) {
                if (e.keyCode === 40) {
                    const next = this.focusedItem.next('li');
                    if (next) {
                        this.focusedItem.removeClass('active');
                        this.focusedItem = next.addClass('active');
                    }
                }
                else {
                    const prev = this.focusedItem.prev('li');
                    if (prev) {
                        this.focusedItem.removeClass('active');
                        this.focusedItem = prev.addClass('active');
                    }
                }
            }
            return false;
        }
        this.loaded = false;
        this.keyword = this.searchControl.value;
        if (this.searchControl.value && this.searchControl.value.length > 1) {
            if (e.keyCode === 13) {
                this.onClick();
                return;
            }
            this.timeoutId = setTimeout(() => {
                this.runSearch(this.searchControl.value);
            }, 500);
        }
        else {
            this.searchResults = new SearchResults();
        }
    }
    onClick() {
        window.location.href = Helpers.concatUrls(this.locator.urls.homeUrl, `/search?k=${this.searchControl.value}`);
    }
    onResItemKeyDown(e) {
        if (e.keyCode === 40) {
            console.log('focused');
        }
    }
    onResItemFocus(e) {
        this.focusedItem = e.target;
        console.log('on afterFocus');
    }
    clear() {
        this.searchResults = new SearchResults();
        this.searchControl.reset();
    }
    /**
     * Действие при клике вне поисковой области
     *
     * @param clear очищать ли результат
     * @memberof HeaderSearchComponent
     */
    clickOutside(clear = false) {
        this.searchClose.emit();
        this.isSearchOpen = false;
        if (clear) {
            this.searchResults = new SearchResults();
        }
    }
    onInputKeyDown(event) {
        if (document.querySelectorAll('.search-pik-header-result__item').length) {
            if (event.keyCode === 40) {
                this.selectedItemIndex = 0;
                const workItems = document.querySelectorAll('.search-pik-header-result__item');
                workItems[this.selectedItemIndex].focus();
            }
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
HeaderSearchComponent.ɵfac = function HeaderSearchComponent_Factory(t) { return new (t || HeaderSearchComponent)(ɵngcc0.ɵɵdirectiveInject(SearchService), ɵngcc0.ɵɵdirectiveInject(WikiService), ɵngcc0.ɵɵdirectiveInject(EmployeeService), ɵngcc0.ɵɵdirectiveInject(PikLocatorService)); };
HeaderSearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderSearchComponent, selectors: [["app-header-search"]], viewQuery: function HeaderSearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
    } }, inputs: { setKeyword: "setKeyword", isSearchOpen: "isSearchOpen" }, outputs: { searchClose: "searchClose" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 10, consts: [["class", "search-pik-header-base-overlay", 3, "click", 4, "ngIf"], [1, "search-pik-header-base"], [1, "search-pik-header-base__input-wrapper"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 28 28", 1, "search-pik-header-base__icon"], ["fill", "none", "fill-rule", "evenodd"], ["d", "M-1604-31H316v90h-1920z"], ["fill", "#EF4E23", "stroke", "#EF4E23", "stroke-width", "2", "d", "M25.869 26.2l-6.993-7.293a9.896 9.896 0 0 0 2.889-6.995C21.765 6.446 17.332 2 11.882 2 6.433 2 2 6.446 2 11.912c0 5.466 4.433 9.912 9.882 9.912a9.819 9.819 0 0 0 6.299-2.28l7.01 7.311a.466.466 0 0 0 .665.013.473.473 0 0 0 .013-.667zm-13.987-5.32c-4.93 0-8.94-4.023-8.94-8.968s4.01-8.968 8.94-8.968 8.942 4.023 8.942 8.968-4.012 8.968-8.942 8.968z"], ["type", "search", "placeholder", "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0441\u0430\u0439\u0442\u0443", 1, "search-pik-header-base__input", 3, "formControl", "keyup", "keydown"], ["searchInput", ""], [1, "search-pik-header-base__close"], ["width", "24", "height", "24", 3, "click"], [0, "xlink", "href", "#cross-icon"], [3, "searchResults", "limit", "setKeyword", "selectedItemIndex", "selectedItemIndexChange"], [1, "search-pik-header-base-overlay", 3, "click"]], template: function HeaderSearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HeaderSearchComponent_div_0_Template, 1, 0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(3, "svg", 3);
        ɵngcc0.ɵɵelementStart(4, "g", 4);
        ɵngcc0.ɵɵelement(5, "path", 5);
        ɵngcc0.ɵɵelement(6, "path", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(7, "input", 7, 8);
        ɵngcc0.ɵɵlistener("keyup", function HeaderSearchComponent_Template_input_keyup_7_listener($event) { return ctx.onSearchKey($event); })("keydown", function HeaderSearchComponent_Template_input_keydown_7_listener($event) { return ctx.onInputKeyDown($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 9);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(10, "svg", 10);
        ɵngcc0.ɵɵlistener("click", function HeaderSearchComponent_Template__svg_svg_click_10_listener() { return ctx.clear(); });
        ɵngcc0.ɵɵelement(11, "use", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(12, "app-search-pik-header-result", 12);
        ɵngcc0.ɵɵlistener("selectedItemIndexChange", function HeaderSearchComponent_Template_app_search_pik_header_result_selectedItemIndexChange_12_listener($event) { return ctx.selectedItemIndex = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSearchOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("search-pik-header-base--open", ctx.isSearchOpen);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("formControl", ctx.searchControl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("search-pik-header-base__close--visible", (ctx.searchControl.value == null ? null : ctx.searchControl.value.length) > 0);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("searchResults", ctx.searchResults)("limit", ctx.limit)("setKeyword", ctx.keyword)("selectedItemIndex", ctx.selectedItemIndex);
    } }, directives: function () { return [ɵngcc5.NgIf, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.FormControlDirective, SearchResultComponent]; }, styles: [".search-pik-header-base[_ngcontent-%COMP%]{position:absolute;top:20%;left:0;right:0;z-index:115;display:block;width:100%;max-width:1024px;margin:auto;font-family:ProbaPro,sans-serif;font-weight:400;line-height:1.4;color:#212121;background:#fff;border-radius:8px;box-shadow:0 2px 9px 0 rgba(0,0,0,.32);visibility:hidden;opacity:0;transition:all .2s}.search-pik-header-base   [_nghost-%COMP%]{-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;box-sizing:border-box}.search-pik-header-base[_ngcontent-%COMP%]   *[_ngcontent-%COMP%], .search-pik-header-base[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:after, .search-pik-header-base[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:before{box-sizing:inherit}.search-pik-header-base[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{transition:all .2s}.search-pik-header-base[_ngcontent-%COMP%]   input[type=search][_ngcontent-%COMP%]::-webkit-search-cancel-button{display:none}.search-pik-header-base[_ngcontent-%COMP%]   input[type=search][_ngcontent-%COMP%]::-ms-clear{display:none}.search-pik-header-base[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{-webkit-appearance:none}.search-pik-header-base-overlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;z-index:100;display:block;width:100%;height:100%;background-color:#8c9aac;opacity:.4;transition:all .2s}.search-pik-header-base--open[_ngcontent-%COMP%]{visibility:visible;opacity:1}.search-pik-header-base__input-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;height:4rem;padding:1.25rem 1.5rem}.search-pik-header-base__icon[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem;margin-right:1rem}input.search-pik-header-base__input[_ngcontent-%COMP%]{width:100%;padding:0;margin:0;font-size:1.5rem;font-family:ProbaPro,sans-serif;font-weight:300}input.search-pik-header-base__input[_ngcontent-%COMP%], input.search-pik-header-base__input[_ngcontent-%COMP%]:active, input.search-pik-header-base__input[_ngcontent-%COMP%]:focus, input.search-pik-header-base__input[_ngcontent-%COMP%]:hover{border:none;outline:none;box-shadow:none}.search-pik-header-base__close[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem;visibility:hidden;cursor:pointer}.search-pik-header-base__close--visible[_ngcontent-%COMP%]{visibility:visible}input.search-pik-header-base__input[_ngcontent-%COMP%]::-webkit-input-placeholder{font-size:1.5rem;line-height:normal;font-family:ProbaPro,sans-serif}input.search-pik-header-base__input[_ngcontent-%COMP%]:-ms-input-placeholder{font-size:1.5rem;line-height:normal;font-family:ProbaPro,sans-serif}input.search-pik-header-base__input[_ngcontent-%COMP%]::-moz-placeholder{font-size:1.5rem;line-height:normal;font-family:ProbaPro,sans-serif}@media (max-width:1024px){.search-pik-header-base[_ngcontent-%COMP%]{top:4.125rem;max-height:calc(100vh - 4.125rem);border-radius:0;box-shadow:none}.search-pik-header-base__input-wrapper[_ngcontent-%COMP%]{height:2.875rem}input.search-pik-header-base__input[_ngcontent-%COMP%]{font-size:1rem}.search-pik-header-base__icon[_ngcontent-%COMP%]{display:none}.search-pik-header-base__close[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem}input.search-pik-header-base__input[_ngcontent-%COMP%]::-webkit-input-placeholder{font-size:1rem}}"] });
HeaderSearchComponent.ctorParameters = () => [
    { type: SearchService },
    { type: WikiService },
    { type: EmployeeService },
    { type: PikLocatorService }
];
HeaderSearchComponent.propDecorators = {
    searchInput: [{ type: ViewChild, args: ['searchInput',] }],
    setKeyword: [{ type: Input }],
    isSearchOpen: [{ type: Input }],
    searchClose: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderSearchComponent, [{
        type: Component,
        args: [{
                selector: 'app-header-search',
                template: "<!-- Search starts here -->\n<div *ngIf=\"isSearchOpen\" class=\"search-pik-header-base-overlay\" (click)=\"clickOutside();clear();\"></div>\n<div class=\"search-pik-header-base\" [class.search-pik-header-base--open]=\"isSearchOpen\">\n  <div class=\"search-pik-header-base__input-wrapper\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" class=\"search-pik-header-base__icon\">\n      <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M-1604-31H316v90h-1920z\" />\n        <path fill=\"#EF4E23\" stroke=\"#EF4E23\" stroke-width=\"2\" d=\"M25.869 26.2l-6.993-7.293a9.896 9.896 0 0 0 2.889-6.995C21.765 6.446 17.332 2 11.882 2 6.433 2 2 6.446 2 11.912c0 5.466 4.433 9.912 9.882 9.912a9.819 9.819 0 0 0 6.299-2.28l7.01 7.311a.466.466 0 0 0 .665.013.473.473 0 0 0 .013-.667zm-13.987-5.32c-4.93 0-8.94-4.023-8.94-8.968s4.01-8.968 8.94-8.968 8.942 4.023 8.942 8.968-4.012 8.968-8.942 8.968z\" />\n      </g>\n    </svg>\n\n    <input #searchInput type=\"search\" class=\"search-pik-header-base__input\" placeholder=\"\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0441\u0430\u0439\u0442\u0443\" [formControl]=\"searchControl\"\n      (keyup)=\"onSearchKey($event)\" (keydown)=\"onInputKeyDown($event)\">\n\n    <div class=\"search-pik-header-base__close\" [class.search-pik-header-base__close--visible]=\"searchControl.value?.length > 0\">\n      <svg width=\"24\" height=\"24\" (click)=\"clear()\">\n        <use xlink:href=\"#cross-icon\"></use>\n      </svg>\n    </div>\n\n  </div>\n  <app-search-pik-header-result [searchResults]=\"searchResults\" [limit]=\"limit\" [setKeyword]=\"keyword\"\n    [(selectedItemIndex)]=\"selectedItemIndex\"></app-search-pik-header-result>\n</div>\n",
                styles: [".search-pik-header-base{position:absolute;top:20%;left:0;right:0;z-index:115;display:block;width:100%;max-width:1024px;margin:auto;font-family:ProbaPro,sans-serif;font-weight:400;line-height:1.4;color:#212121;background:#fff;border-radius:8px;box-shadow:0 2px 9px 0 rgba(0,0,0,.32);visibility:hidden;opacity:0;transition:all .2s}.search-pik-header-base :host{-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;box-sizing:border-box}.search-pik-header-base *,.search-pik-header-base :after,.search-pik-header-base :before{box-sizing:inherit}.search-pik-header-base a{transition:all .2s}.search-pik-header-base input[type=search]::-webkit-search-cancel-button{display:none}.search-pik-header-base input[type=search]::-ms-clear{display:none}.search-pik-header-base input{-webkit-appearance:none}.search-pik-header-base-overlay{position:fixed;top:0;left:0;z-index:100;display:block;width:100%;height:100%;background-color:#8c9aac;opacity:.4;transition:all .2s}.search-pik-header-base--open{visibility:visible;opacity:1}.search-pik-header-base__input-wrapper{display:flex;align-items:center;height:4rem;padding:1.25rem 1.5rem}.search-pik-header-base__icon{width:1.75rem;height:1.75rem;margin-right:1rem}input.search-pik-header-base__input{width:100%;padding:0;margin:0;font-size:1.5rem;font-family:ProbaPro,sans-serif;font-weight:300}input.search-pik-header-base__input,input.search-pik-header-base__input:active,input.search-pik-header-base__input:focus,input.search-pik-header-base__input:hover{border:none;outline:none;box-shadow:none}.search-pik-header-base__close{width:1.5rem;height:1.5rem;visibility:hidden;cursor:pointer}.search-pik-header-base__close--visible{visibility:visible}input.search-pik-header-base__input::-webkit-input-placeholder{font-size:1.5rem;line-height:normal;font-family:ProbaPro,sans-serif}input.search-pik-header-base__input:-ms-input-placeholder{font-size:1.5rem;line-height:normal;font-family:ProbaPro,sans-serif}input.search-pik-header-base__input::-moz-placeholder{font-size:1.5rem;line-height:normal;font-family:ProbaPro,sans-serif}@media (max-width:1024px){.search-pik-header-base{top:4.125rem;max-height:calc(100vh - 4.125rem);border-radius:0;box-shadow:none}.search-pik-header-base__input-wrapper{height:2.875rem}input.search-pik-header-base__input{font-size:1rem}.search-pik-header-base__icon{display:none}.search-pik-header-base__close{width:1.5rem;height:1.5rem}input.search-pik-header-base__input::-webkit-input-placeholder{font-size:1rem}}"]
            }]
    }], function () { return [{ type: SearchService }, { type: WikiService }, { type: EmployeeService }, { type: PikLocatorService }]; }, { searchClose: [{
            type: Output
        }], setKeyword: [{
            type: Input
        }], isSearchOpen: [{
            type: Input
        }], searchInput: [{
            type: ViewChild,
            args: ['searchInput']
        }] }); })();

/**
 * Сервис уведомлений
 *
 */
class NotificationService extends BaseService {
    constructor(http, auth, locator, authSettings) {
        super(http, auth, authSettings);
        this.http = http;
        this.auth = auth;
        this.locator = locator;
        this.authSettings = authSettings;
        this.serviceUrl = this.locator.urls.navigationApi + '/api/v1.0/Alert';
    }
    /**
     * Получить уведомления для текущего пользователя
     */
    getNotificationsByUser(login, offset = 0, limit = 10) {
        return this.get(`byUser?login=${login}&offset=${offset}&limit=${limit}`);
    }
    /**
     * Отметить прочтённым
     */
    markAsViewed(id) {
        return this.post(`${id}/viewed`, {});
    }
    /**
     * Отметить Все оповещения прочтённым
     */
    markAllAsViewed() {
        return this.post(`/viewed/all`, {});
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PikLocatorService), ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG)); };
NotificationService.ɵprov = ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(ɵɵinject(HttpClient), ɵɵinject(PikAuthService), ɵɵinject(PikLocatorService), ɵɵinject(PIK_AUTH_CONFIG)); }, token: NotificationService, providedIn: "root" });
NotificationService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikAuthService },
    { type: PikLocatorService },
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikAuthService }, { type: PikLocatorService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }]; }, null); })();

class MarketService extends BaseService {
    constructor(http, auth, locator, authSettings) {
        super(http, auth, authSettings);
        this.http = http;
        this.auth = auth;
        this.locator = locator;
        this.authSettings = authSettings;
        this.serviceUrl = Helpers.concatUrls(this.locator.urls.marketApi, '/api/v1.0/User');
    }
    /**
     * @deprecated На сколько мне известно пикойны уже давно умерли
     */
    getEmployeePicoins(login) {
        if (!login) {
            return of(null);
        }
        return this.get(`picoin?login=${login}`);
    }
}
MarketService.ɵfac = function MarketService_Factory(t) { return new (t || MarketService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PikLocatorService), ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG)); };
MarketService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MarketService, factory: MarketService.ɵfac });
MarketService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikAuthService },
    { type: PikLocatorService },
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikAuthService }, { type: PikLocatorService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }]; }, null); })();

class GAConfig {
}
const GA_CONFIG = new InjectionToken('GAConfig');

class GoogleAnalyticsService {
    constructor(auth, employeeService, gaConfig) {
        this.auth = auth;
        this.employeeService = employeeService;
        this.gaConfig = gaConfig;
        this.GAInitiated$ = new BehaviorSubject(false);
    }
    initialize() {
        if (this.gaConfig.ga && !this.GAInitiated$.value) {
            this.auth.isAuthenticated$
                .pipe(switchMap(isAuthenticated => {
                return isAuthenticated
                    ? this.employeeService.getCurrentLogin().pipe(catchError(_ => of(null)))
                    : of(null);
            }))
                .subscribe(res => {
                this.initGA(res);
            });
        }
        else if (!this.gaConfig.ga) {
            console.warn('Не указан ИД Google Analytics');
        }
    }
    send(action, options) {
        try {
            if (this.GAInitiated$.value) {
                gtag('event', action, options);
            }
        }
        catch (e) {
            console.error('Не удалось отправить событие Google Analytics');
            console.error(e);
        }
    }
    initGA(login) {
        if (login) {
            gtag('js', new Date());
            try {
                gtag('config', this.gaConfig.ga, {
                    optimize_id: this.gaConfig.optimize,
                    user_id: login,
                });
                this.GAInitiated$.next(true);
            }
            catch (exception) {
                console.warn('Не удалось инициализировать Google Analytics');
            }
        }
    }
}
GoogleAnalyticsService.ɵfac = function GoogleAnalyticsService_Factory(t) { return new (t || GoogleAnalyticsService)(ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(EmployeeService), ɵngcc0.ɵɵinject(GA_CONFIG)); };
GoogleAnalyticsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GoogleAnalyticsService, factory: GoogleAnalyticsService.ɵfac });
GoogleAnalyticsService.ctorParameters = () => [
    { type: PikAuthService },
    { type: EmployeeService },
    { type: GAConfig, decorators: [{ type: Inject, args: [GA_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GoogleAnalyticsService, [{
        type: Injectable
    }], function () { return [{ type: PikAuthService }, { type: EmployeeService }, { type: GAConfig, decorators: [{
                type: Inject,
                args: [GA_CONFIG]
            }] }]; }, null); })();

/**
 * Шапка
 *
 * @export
 * @class HeaderComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
class HeaderComponent {
    constructor(headerService, employeeService, marketService, portalService, navigationService, notificationService, locator, auth, cd, gaService) {
        this.headerService = headerService;
        this.employeeService = employeeService;
        this.marketService = marketService;
        this.portalService = portalService;
        this.navigationService = navigationService;
        this.notificationService = notificationService;
        this.locator = locator;
        this.auth = auth;
        this.cd = cd;
        this.gaService = gaService;
        this.config = {
            suppressScrollX: true,
            wheelPropagation: true,
            swipeEasing: true
        };
        this.offset = 0;
        this.limit = 10;
        this.notifications = [];
        this.openedSubmenus = [];
        this.menuItemsLimit = 0;
        this.hideSearch = false;
        this.hideNotifications = false;
        this.onLogoClick = new EventEmitter();
        this.destroyed$ = new Subject();
    }
    ngOnInit() {
        this.headerService.isVisible$
            .pipe(takeUntil(this.destroyed$))
            .subscribe((visible) => {
            try {
                if (visible && !this.showHeader) {
                    this.getNavigation();
                    this.getUserLogin();
                }
            }
            finally {
                this.showHeader = visible;
            }
        });
    }
    /**
     * Получение навигации
     *
     * @private
     * @memberof HeaderComponent
     */
    getNavigation() {
        if (this.auth.isExternalUser()) {
            return;
        }
        this.navigationService.getNavigation(window.location.href)
            .pipe(take(1)).subscribe(res => {
            if (res && res.data) {
                this.rootNode = res.data;
                if (this.rootNode) {
                    this.navigationNodes = this.rootNode.children;
                    // resize
                    this.onResize(null);
                }
            }
            else {
                this.rootNode = null;
            }
        });
    }
    /**
     * Получение логина пользователя
     *
     * @private
     * @memberof HeaderComponent
     */
    getUserLogin() {
        if (this.auth.isExternalUser()) {
            this.auth.userData$.subscribe((data) => {
                this.userName = data.name;
            });
            return;
        }
        this.navigationService.getCurrent().pipe(take(1), pluck('data')).subscribe(userIdentity => {
            if (!this.userIdentity || userIdentity && userIdentity.id !== this.userIdentity.id) {
                this.userIdentity = userIdentity;
                this.userUrl = `${this.locator.urls.homeUrl}/about`;
                if (this.userIdentity) {
                    this.changePasswordUrl = `${this.locator.urls.stsUrl}/Account/ChangePassword?login=${this.userIdentity.login}`;
                    this.getNotifications(this.userIdentity.login);
                    let name = this.userIdentity.surname;
                    if (this.userIdentity.name) {
                        name += ' ' + this.userIdentity.name[0] + '.';
                    }
                    if (this.userIdentity.middleName) {
                        name += ' ' + this.userIdentity.middleName[0] + '.';
                    }
                    this.userName = name;
                }
                else {
                    this.getUserName();
                }
            }
        }, error => {
            this.getUserName();
        });
    }
    /**
     * Получение имени пользователя, если он не нашёл его как сотрудника
     *
     * @private
     * @memberof HeaderComponent
     */
    getUserName() {
        const userNameSub = this.portalService.getUserName()
            .pipe(take(1), takeUntil(this.destroyed$))
            .subscribe(resName => {
            this.userName = resName;
            userNameSub.unsubscribe();
        }, error => {
            this.error = error;
        });
    }
    /**
     * Получение уведомлений для пользователя
     */
    getNotifications(login, offset, limit) {
        this.alertsLoading = true;
        this.notificationService.getNotificationsByUser(login, offset, limit)
            .pipe(tap((res) => {
            this.requestedNotificationsCount = res.data.length;
        }), finalize(() => this.alertsLoading = false), takeUntil(this.destroyed$))
            .subscribe(res => {
            res.data.map(notification => {
                if (!this.notifications.find(x => x.id === notification.id)) {
                    this.notifications.push(notification);
                }
            });
            this.cd.detectChanges();
        });
    }
    /**
     * Скрыть/отобразить меню
     *
     * @memberof HeaderComponent
     */
    toggleMenu() {
        this.isSearchOpen = false;
        this.isMenuOpen = !this.isMenuOpen;
    }
    /**
     * Скрыть/отобразить строку поиска
     *
     * @memberof HeaderComponent
     */
    toggleSearch() {
        this.isMenuOpen = false;
        this.isSearchOpen = !this.isSearchOpen;
        this.search.focus();
    }
    /**
     * Скрыть/отобразить подменю
     *
     * @param id
     * @memberof HeaderComponent
     */
    toggleSubmenu(id) {
        if (this.openedSubmenus.includes(id)) {
            const index = this.openedSubmenus.indexOf(id);
            this.openedSubmenus.splice(index, 1);
        }
        else if (!this.openedSubmenus.includes(id)) {
            this.openedSubmenus.push(id);
        }
    }
    onResize(event) {
        if (this.showHeader) {
            const headerMenu = document.getElementById('header-menu');
            if (headerMenu) {
                const menuWidth = headerMenu.offsetWidth;
                this.menuItemsLimit = Math.ceil((menuWidth - 70) / 160); // Добавить запас в px для ceil // Math.floor
                if (this.navigationNodes && this.navigationNodes.length === this.menuItemsLimit + 1) {
                    this.menuItemsLimit = this.menuItemsLimit + 1;
                }
            }
        }
    }
    hideNotification(id) {
        this.notificationService.markAsViewed(id).subscribe((res) => {
            if (res.data === true) {
                const index = this.notifications.findIndex(item => item.id === id);
                this.notifications.splice(index, 1);
                this.cd.detectChanges();
            }
            else {
                console.log('Не удалось пометить уведомление как "прочитанное"');
            }
        }, (err) => {
            console.log('Не удалось пометить уведомление как "прочитанное"');
        });
    }
    /**
     * Скрыть все уведомления пользователя
     */
    hideAllNotification() {
        this.notificationService.markAllAsViewed().subscribe((res) => {
            if (res) {
                this.notifications = [];
            }
            else {
                console.log('Не удалось пометить уведомления как "прочитанные"');
            }
        });
    }
    /**
     * Подгрузка данных по скроллу
     */
    onScrollDown() {
        if (this.requestedNotificationsCount > 0
            && this.notifications
            && this.notifications.length >= 5
            && !this.alertsLoading
            && this.userIdentity) {
            this.offset += this.limit;
            this.getNotifications(this.userIdentity.login, this.offset, this.limit);
        }
    }
    /**
     * Выйти
     */
    logout() {
        this.auth.logout();
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.unsubscribe();
    }
    changeIsOpenLK() {
        this.isLkOpen = !this.isLkOpen;
    }
    onHeaderLogoClick($event) {
        this.onLogoClick.emit($event);
        if (this.onLogoClick.observers.length === 0) {
            $event.preventDefault();
            document.location.href = this.locator.urls.homeUrl;
        }
    }
    sendGAEvent(item, event) {
        if (event && event.button < 2) {
            this.gaService.send(item.title, { event_category: 'Переход' });
        }
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(PikHeaderService), ɵngcc0.ɵɵdirectiveInject(EmployeeService), ɵngcc0.ɵɵdirectiveInject(MarketService), ɵngcc0.ɵɵdirectiveInject(PortalService), ɵngcc0.ɵɵdirectiveInject(NavigationService), ɵngcc0.ɵɵdirectiveInject(NotificationService), ɵngcc0.ɵɵdirectiveInject(PikLocatorService), ɵngcc0.ɵɵdirectiveInject(PikAuthService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(GoogleAnalyticsService)); };
HeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["app-header"]], viewQuery: function HeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(HeaderSearchComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.search = _t.first);
    } }, hostBindings: function HeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function HeaderComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { hideSearch: "hideSearch", hideNotifications: "hideNotifications" }, outputs: { onLogoClick: "onLogoClick" }, ngContentSelectors: _c3, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "header"], [1, "header__menu-toggle", 3, "click"], [1, "header__menu-bars"], ["class", "header__menu-toggle-indicator", 4, "ngIf"], [1, "header__logo"], [1, "header__logo-wrapper"], [3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 52 52", "fill", "none", 1, "header__logo-image"], ["d", "M0.962891 32.7404V17.333H15.9209V32.7404H11.6041V21.154H5.27962V32.7404H0.962891ZM28.6703 23.8247L21.7635 32.7404H17.9286V17.333H22.2454V26.2488L29.1521 17.333H32.987V32.7404H28.6703V23.8247ZM39.3115 26.5364V32.7404H34.9948V17.333H39.3115V23.7219L44.4715 17.333H49.5111L43.3672 24.8107L51.037 32.7404H45.2345L39.3115 26.5364Z", "fill", "#FC4C02"], ["id", "header-menu", 1, "header__menu"], ["class", "header__menu-list", 4, "ngIf"], ["class", "header__search", 3, "header__search--open", 4, "ngIf"], ["class", "header__notifications header__notifications--active", 3, "header__notifications--search-hidden", 4, "ngIf"], [1, "header__lk", 3, "click"], [1, "header__user"], [1, "header__user-info"], [1, "header__user-name"], [1, "header__user-photo"], [3, "userIdentity", "cssClass", "big"], [1, "header__gamification"], [1, "header__gamification-list"], [1, "header__gamification-item"], [1, "header__gamification-link"], ["target", "_blank", 1, "header__gamification-link", 3, "href"], [1, "header__gamification-item", "header__gamification-item--exit"], ["href", "javascript:;", 1, "header__gamification-link", 3, "click"], ["width", "23px", "height", "16px", "viewBox", "0 0 23 28", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 1, "header__gamification-exit-icon"], ["transform", "translate(-1869.000000, -32.000000)", "fill-rule", "nonzero", "fill", "#757575"], ["id", "Exit", "transform", "translate(1864.000000, 30.000000)"], ["id", "Group", "transform", "translate(5.333333, 2.666667)"], ["d", "M17.3902261,18.2492195 C17.1898468,18.2492195 16.9890591,18.1727206 16.8360029,18.0196645 C16.5303574,17.7137856 16.5303574,17.2175638 16.8360029,16.9116849 L19.6441138,14.1039825 L8.46220277,14.1039825 C8.0296426,14.1039825 7.67865791,13.7532312 7.67865791,13.3204376 C7.67865791,12.8876441 8.0296426,12.5368928 8.46220277,12.5368928 L19.5976076,12.5368928 L16.8315098,9.7246973 C16.529132,9.41700948 16.5319912,8.92259664 16.8384537,8.61876003 C17.1440992,8.31515682 17.6387454,8.31556528 17.944391,8.6212108 L22.0898614,12.7665062 C22.2367907,12.9134354 22.3192414,13.1127644 22.3192414,13.320496 C22.3192414,13.5282276 22.2367907,13.7275565 22.0898614,13.8744858 L17.944391,18.0197812 C17.7913348,18.1726623 17.590547,18.2492195 17.3902261,18.2492195 Z", "id", "Shape"], ["d", "M16.0140627,26.6407586 L0.787045952,26.6407586 C0.354485777,26.6407586 0.00350109409,26.2900073 0.00350109409,25.8572137 L0.00350109409,0.783544858 C0.00350109409,0.350751276 0.354485777,0 0.787045952,0 L16.0140627,0 C16.4466229,0 16.7976076,0.350751276 16.7976076,0.783544858 L16.7976076,2.87183078 C16.7976076,3.30462436 16.4466229,3.65537564 16.0140627,3.65537564 C15.5815026,3.65537564 15.2305179,3.30462436 15.2305179,2.87183078 L15.2305179,1.56708972 L1.57059081,1.56708972 L1.57059081,25.0736689 L15.2305179,25.0736689 L15.2305179,23.7689278 C15.2305179,23.3361342 15.5815026,22.9853829 16.0140627,22.9853829 C16.4466229,22.9853829 16.7976076,23.3361342 16.7976076,23.7689278 L16.7976076,25.8572137 C16.7976659,26.2900073 16.4466813,26.6407586 16.0140627,26.6407586 Z", "id", "Shape"], [3, "isSearchOpen", "isSearchOpenChange", "searchClose", 4, "ngIf"], [1, "header__menu-toggle-indicator"], [1, "header__menu-list"], ["class", "header__menu-item header__menu-item--show-mobile", 3, "header__menu-item--open", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["class", "header__menu-item header__menu-item--more", 3, "header__menu-item--hover", 4, "ngIf"], [1, "header__menu-list", "header__menu-list--additional", 3, "mouseover", "mouseleave"], [1, "header__menu-item", "header__menu-item--show-mobile"], [1, "header__menu-link"], [1, "header__menu-item-indicator"], [1, "header__menu-link-icon", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24", 4, "ngIf"], [1, "header__submenu-list"], ["class", "header__submenu-list--hide", 3, "click", 4, "ngIf"], [1, "header__submenu-notifications"], ["class", "header__submenu-ps", 3, "config", "psYReachEnd", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24"], ["fill", "#A1A1A1", "fill-rule", "evenodd", "stroke", "#A1A1A1", "stroke-width", ".6", "d", "M18.481 11.222H12.52V5.52a.518.518 0 1 0-1.038 0v5.703H5.52a.518.518 0 1 0 0 1.037h5.962v6.222a.518.518 0 1 0 1.038 0V12.26h5.962a.518.518 0 1 0 0-1.037z"], ["fill", "#4183F2", "fill-rule", "evenodd", "stroke", "#4183F2", "d", "M12.519 11.222h-7a.518.518 0 1 0 0 1.037H18.48a.518.518 0 1 0 0-1.037H12.52z"], [1, "header__submenu-list--hide", 3, "click"], [1, "header__submenu-ps", 3, "config", "psYReachEnd"], ["class", "header__submenu-item", 4, "ngFor", "ngForOf"], [1, "header__submenu-item"], [3, "notification", "hideNotification"], ["class", "header__menu-item", 3, "header__menu-item--open", 4, "ngIf"], [1, "header__menu-item"], [1, "header__menu-link", 3, "target", "mousedown"], ["class", "header__menu-link-icon", 3, "click", 4, "ngIf"], ["class", "header__submenu-list", 3, "header__submenu-list--open", 4, "ngIf"], [1, "header__submenu-link", 3, "target", "mousedown"], [1, "header__menu-item", "header__menu-item--more"], [1, "header__menu-link", 3, "mousedown"], [1, "header__submenu-link", 3, "mousedown"], [1, "header__search"], [1, "header__search-toggle", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "28", "height", "28", "viewBox", "0 0 28 28", 1, "header__search-icon"], ["fill", "none", "fill-rule", "evenodd"], ["fill", "#FFF", "d", "M-1604-31H316v90h-1920z"], ["fill", "#EF4E23", "stroke", "#EF4E23", "stroke-width", "2", "d", "M25.869 26.2l-6.993-7.293a9.896 9.896 0 0 0 2.889-6.995C21.765 6.446 17.332 2 11.882 2 6.433 2 2 6.446 2 11.912c0 5.466 4.433 9.912 9.882 9.912a9.819 9.819 0 0 0 6.299-2.28l7.01 7.311a.466.466 0 0 0 .665.013.473.473 0 0 0 .013-.667zm-13.987-5.32c-4.93 0-8.94-4.023-8.94-8.968s4.01-8.968 8.94-8.968 8.942 4.023 8.942 8.968-4.012 8.968-8.942 8.968z"], [1, "header__notifications", "header__notifications--active"], ["class", "header__notification-indicator", 4, "ngIf"], ["width", "28", "height", "28", 1, "header__user-picoins-icon"], [0, "xlink", "href", "#notification"], [1, "header__notifications-dropdown"], ["class", "header__notifications-list--hide", 3, "click", 4, "ngIf"], ["style", "margin: 5px;", 4, "ngIf"], ["class", "header__notifications-dropdown", 4, "ngIf"], [1, "header__notification-indicator"], [1, "header__notifications-list--hide", 3, "click"], [2, "margin", "5px"], [1, "header__notifications-list", 3, "config", "psYReachEnd"], [3, "notification", "hideNotification", 4, "ngFor", "ngForOf"], [1, "header__notifications-empty"], [3, "isSearchOpen", "isSearchOpenChange", "searchClose"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵtemplate(0, HeaderComponent_ng_container_0_Template, 41, 18, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showHeader);
    } }, directives: function () { return [ɵngcc5.NgIf, SvgComponent, HeaderUserImageComponent, ɵngcc5.NgForOf, ɵngcc7.PerfectScrollbarComponent, NotificationsComponent, HeaderSearchComponent]; }, styles: ["@charset \"UTF-8\";*[_ngcontent-%COMP%], [_ngcontent-%COMP%]:after, [_ngcontent-%COMP%]:before{box-sizing:inherit}a[_ngcontent-%COMP%]{transition:all .2s}.header[_ngcontent-%COMP%]{display:flex;flex-flow:row nowrap;align-items:center;height:5.625rem;font-family:ProbaPro;font-weight:400;line-height:1.4;color:#212121;background:#fff;border-bottom:1px solid #d8d8d8}.header__menu-toggle[_ngcontent-%COMP%]{display:none}.header__logo[_ngcontent-%COMP%]{display:flex;flex:0 0 auto;align-items:center;height:5.625rem;margin:0 2rem}.header__logo-wrapper[_ngcontent-%COMP%]{position:relative;width:3rem;height:3rem}.header__logo-tape[_ngcontent-%COMP%]{position:absolute;width:300px;height:65px;left:28px;bottom:-2px}.header__logo-hat[_ngcontent-%COMP%]{position:absolute;top:-17px;width:40px;height:30px;left:11px}.header__menu-item-indicator[_ngcontent-%COMP%], .header__menu-toggle-indicator[_ngcontent-%COMP%]{display:none}.header__menu[_ngcontent-%COMP%]{position:relative;top:0;flex:1 1;flex-flow:row wrap;align-items:center;height:100%}.header__menu[_ngcontent-%COMP%], .header__menu-list[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;width:100%}.header__menu-list[_ngcontent-%COMP%]{flex-flow:row nowrap;padding:0;margin:0;list-style:none;transition:all .2s}.header__menu-item[_ngcontent-%COMP%]{position:relative;flex:0 0 auto;margin:0;white-space:nowrap;transition:all .2s}@media (min-width:1025px){.header__menu-item[_ngcontent-%COMP%]:last-child{position:static}}.header__menu-item--hover[_ngcontent-%COMP%]   .header__menu-link[_ngcontent-%COMP%], .header__menu-item[_ngcontent-%COMP%]:active   .header__menu-link[_ngcontent-%COMP%], .header__menu-item[_ngcontent-%COMP%]:hover   .header__menu-link[_ngcontent-%COMP%]{color:#4285f4;box-shadow:inset 0 -2px 0 0 #4285f4}@media (min-width:1025px){.header__menu-item[_ngcontent-%COMP%]:hover   .header__submenu-list[_ngcontent-%COMP%]{display:block;opacity:1}}@media (max-width:1025px){.header__menu-item--more[_ngcontent-%COMP%]{display:none}}.header__menu-link[_ngcontent-%COMP%]{display:block;height:5.625rem;padding:0 1.5rem;line-height:5.625rem;text-decoration:none;color:inherit;transition:box-shadow .2s,color .2s}.header__menu-link-icon[_ngcontent-%COMP%]{display:none}.header__submenu-list[_ngcontent-%COMP%]{position:absolute;top:100%;z-index:20;display:none;width:15.5rem;padding:1.25rem 0;margin:0;list-style:none;background:#fff;border-bottom-left-radius:4px;border-bottom-right-radius:4px;box-shadow:0 6px 10px 0 rgba(0,0,0,.16);opacity:0;transition:all .2s}.header__submenu-link[_ngcontent-%COMP%]{position:relative;display:block;padding:.625rem 1.5rem;font-size:1rem;line-height:1.4;color:inherit;text-decoration:none;white-space:pre-line}.header__submenu-link[_ngcontent-%COMP%]:active, .header__submenu-link[_ngcontent-%COMP%]:hover{color:#4285f4}.header__search[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;flex:0 0 auto;width:5.625rem;height:5.625rem;margin-left:auto;border-left:1px solid #d8d8d8;border-right:1px solid #d8d8d8}.header__search-toggle[_ngcontent-%COMP%]{position:relative;width:100%;height:100%;cursor:pointer}.header__search-icon[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.header__notifications[_ngcontent-%COMP%]{position:relative;display:flex;justify-content:center;align-items:center;flex:0 0 auto;width:5.625rem;height:5.625rem;margin-left:auto;border-right:1px solid #d8d8d8;transition:all .2s}.header__notifications--search-hidden[_ngcontent-%COMP%]{border-left:1px solid #d8d8d8}.header__notifications--active[_ngcontent-%COMP%]:active, .header__notifications--active[_ngcontent-%COMP%]:hover{box-shadow:inset 0 -2px 0 0 #4285f4}.header__notifications--active[_ngcontent-%COMP%]:active   .header__notifications-dropdown[_ngcontent-%COMP%], .header__notifications--active[_ngcontent-%COMP%]:hover   .header__notifications-dropdown[_ngcontent-%COMP%]{height:auto;opacity:1}.header__notification-indicator[_ngcontent-%COMP%]{position:absolute;top:calc(50% - .75rem);right:calc(50% - .75rem);width:.5rem;height:.5rem;background:#ef4e23;border-radius:10rem;box-shadow:0 0 4px 0 #ef4e23}.header__notifications-dropdown[_ngcontent-%COMP%]{position:absolute;top:calc(100%);right:0;z-index:20;width:19.5rem;height:0;background:#fff;border-radius:4px;overflow:hidden;box-shadow:0 6px 10px 0 rgba(0,0,0,.16);opacity:0;transition:opacity .25s ease-out}.header__notifications-list[_ngcontent-%COMP%]{position:relative;max-height:350px;overflow-y:auto}.header__notifications-list--hide[_ngcontent-%COMP%]{border-radius:4px 4px 0 0;padding:15.5px 0;text-align:center;font-size:15px;background-color:#f5f5f5;cursor:pointer}.header__notifications-empty[_ngcontent-%COMP%]{padding:1rem .5rem;color:#757575;text-align:center}.header__notifications-empty[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:0;margin:0}.header__notifications-show-all[_ngcontent-%COMP%]{padding:.5rem;text-align:center;border-top:1px solid #d8d8d8}.header__notifications-show-all[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#212121;text-decoration:none;transition:all .25s}.header__notifications-show-all[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:active, .header__notifications-show-all[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus, .header__notifications-show-all[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#4285f4}.header__lk[_ngcontent-%COMP%]{position:relative;flex:0 0 auto;z-index:25;display:flex;flex-flow:column nowrap;width:15.875rem;padding-right:2rem;transition:all .2s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.header__lk[_ngcontent-%COMP%]:active, .header__lk[_ngcontent-%COMP%]:hover{box-shadow:inset 0 -2px 0 0 #4285f4}.header__lk[_ngcontent-%COMP%]:active   .header__gamification[_ngcontent-%COMP%], .header__lk[_ngcontent-%COMP%]:hover   .header__gamification[_ngcontent-%COMP%]{height:auto;opacity:1}.header__user[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;flex-flow:row nowrap;align-items:center;height:5.625rem;padding-left:1.5rem;font-size:1rem}.header__user-info[_ngcontent-%COMP%]{display:flex;flex-flow:column nowrap}.header__user-name[_ngcontent-%COMP%]{margin-bottom:.1875rem;color:#757575;text-decoration:none;line-height:1;white-space:normal;word-wrap:break-word;overflow:hidden}.header__user-picoins[_ngcontent-%COMP%]{display:inline-flex;justify-content:flex-end;align-items:center;color:#a1a1a1;text-decoration:none;line-height:1}.header__user-picoins-icon[_ngcontent-%COMP%]{margin-left:.0625rem}.header__user-photo[_ngcontent-%COMP%]{flex:0 0 auto;width:3rem;height:3rem;margin:0 0 0 1rem;border:1px solid #d8d8d8;border-radius:100px;overflow:hidden}.header__gamification[_ngcontent-%COMP%]{position:absolute;top:calc(100%);z-index:20;justify-content:flex-start;flex:1 0 auto;width:100%;height:0;background:#fff;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-radius:4px;overflow:hidden;opacity:0;box-shadow:0 6px 10px 0 rgba(0,0,0,.16);transition:opacity .2s ease-out}.header__gamification-list[_ngcontent-%COMP%]{width:100%;padding:.5rem 0 0;margin:0;list-style:none}.header__gamification-item[_ngcontent-%COMP%]{padding:0 .75rem 0 1.25rem}.header__gamification-item--exit[_ngcontent-%COMP%]{margin-top:.5rem;border-top:1px solid #d8d8d8}.header__gamification-item--exit[_ngcontent-%COMP%]   .header__gamification-link[_ngcontent-%COMP%]{display:block;padding:.75rem}.header__gamification-item--coins[_ngcontent-%COMP%]{display:none}.header__gamification-coins[_ngcontent-%COMP%]{display:inline-block;padding:.25rem .75rem;margin:1rem 0;border:1px solid #d8d8d8;border-radius:100px}.header__gamification-link[_ngcontent-%COMP%]{display:inline-block;padding:.5rem .75rem;color:inherit;text-decoration:none;transition:color .2s}.header__gamification-link[_ngcontent-%COMP%]:hover{color:#4285f4}.header__gamification-link[_ngcontent-%COMP%]:hover   .header__gamification-exit-icon[_ngcontent-%COMP%]   g[_ngcontent-%COMP%]{fill:#4285f4}.header__gamification-exit-icon[_ngcontent-%COMP%]{position:relative;top:3px;float:right}@media (max-width:1025px){.header[_ngcontent-%COMP%]{top:0;z-index:120;flex-flow:row wrap;justify-content:space-between;align-content:flex-start;align-items:flex-start;width:100%;height:4.125rem;border:none;overflow:hidden;position:relative}.header--open[_ngcontent-%COMP%]{height:100vh;position:fixed;-webkit-overflow-scrolling:touch}.header--open[_ngcontent-%COMP%]   .header__lk[_ngcontent-%COMP%]{display:block}.header--open[_ngcontent-%COMP%]   .header__menu-item[_ngcontent-%COMP%]:last-child{margin-bottom:4rem}.header__menu-toggle[_ngcontent-%COMP%]{position:relative;display:block;flex:0 0 auto;order:1;width:4.125rem;height:4.125rem;border-bottom:1px solid #d8d8d8;cursor:pointer}.header__menu-bars[_ngcontent-%COMP%]{top:0;right:0;bottom:0;left:0;margin:auto;height:3px}.header__menu-bars[_ngcontent-%COMP%], .header__menu-bars[_ngcontent-%COMP%]:after, .header__menu-bars[_ngcontent-%COMP%]:before{position:absolute;width:1.5rem;border-bottom:3px solid #212121;transition:all .2s}.header__menu-bars[_ngcontent-%COMP%]:after, .header__menu-bars[_ngcontent-%COMP%]:before{content:\"\";display:block}.header__menu-bars[_ngcontent-%COMP%]:before{top:-7px}.header__menu-bars[_ngcontent-%COMP%]:after{top:7px}.header__menu-bars--open[_ngcontent-%COMP%]{border-color:transparent}.header__menu-bars--open[_ngcontent-%COMP%]:before{top:0;transform:rotate(-45deg)}.header__menu-bars--open[_ngcontent-%COMP%]:after{top:0;transform:rotate(45deg)}.header__menu-toggle-indicator[_ngcontent-%COMP%]{top:1rem;right:1rem}.header__menu-item-indicator[_ngcontent-%COMP%], .header__menu-toggle-indicator[_ngcontent-%COMP%]{position:absolute;display:block;width:.75rem;height:.75rem;border-radius:1rem;background-color:#ef4e23;box-shadow:0 0 4px 0 #ef4e23}.header__menu-item-indicator[_ngcontent-%COMP%]{top:1.375rem;right:3.75rem}.header__logo[_ngcontent-%COMP%]{order:2;flex:1 0 auto;justify-content:center;width:4.125rem;height:4.125rem;margin:0;border-bottom:1px solid #d8d8d8}.header__logo-wrapper[_ngcontent-%COMP%]{width:4rem;height:4rem}.header__menu[_ngcontent-%COMP%]{order:4;flex:1 0 100%;display:block;height:calc(100vh - 4.125rem - 4rem);padding-top:1rem;overflow-y:scroll}.header__menu-list[_ngcontent-%COMP%]{display:block}.header__menu-item[_ngcontent-%COMP%]:active   .header__menu-link[_ngcontent-%COMP%], .header__menu-item[_ngcontent-%COMP%]:hover   .header__menu-link[_ngcontent-%COMP%]{color:inherit;box-shadow:none}.header__menu-item--open[_ngcontent-%COMP%]:not(:first-child), .header__menu-item--open[_ngcontent-%COMP%]:not(:last-child){box-shadow:0 1px 1px 0 #d8d8d8,0 -1px 1px 0 #d8d8d8}.header__menu-item--open[_ngcontent-%COMP%]:first-child{box-shadow:0 1px 1px 0 #d8d8d8}.header__menu-item--open[_ngcontent-%COMP%]:last-child{box-shadow:0 -1px 1px 0 #d8d8d8}.header__menu-item--open[_ngcontent-%COMP%]   .header__menu-link[_ngcontent-%COMP%]{font-weight:500;color:inherit;box-shadow:none}.header__menu-link[_ngcontent-%COMP%]{height:auto;padding:1rem;font-size:1.25rem;line-height:1}.header__menu-link-icon[_ngcontent-%COMP%]{position:absolute;top:0;right:0;display:block;width:auto;height:100%;padding:1rem;line-height:1;cursor:pointer}.header__submenu-list[_ngcontent-%COMP%]{position:relative;width:100%;padding:0;border-radius:0;box-shadow:none}.header__submenu-list--open[_ngcontent-%COMP%]{display:block;opacity:1}.header__submenu-list--hide[_ngcontent-%COMP%]{height:55px;text-align:center;font-size:16px;padding-top:15px;background-color:#f5f5f5;cursor:pointer}.header__submenu-notifications[_ngcontent-%COMP%]{margin:5px;padding:0;list-style-type:none}.header__submenu-ps[_ngcontent-%COMP%]{position:relative;max-height:350px}.header__submenu-link[_ngcontent-%COMP%]{padding:.875rem 1rem}.header__search[_ngcontent-%COMP%]{order:3;flex:0 0 auto;width:4.125rem;height:4.125rem;margin:0;border:none;border-bottom:1px solid #d8d8d8}.header__search--open[_ngcontent-%COMP%]   .header__search-icon[_ngcontent-%COMP%]{display:none}.header__search--open[_ngcontent-%COMP%]   .header__search-toggle[_ngcontent-%COMP%]:after{content:\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\";display:block;line-height:4.125rem;color:#ef4e23}.header__lk[_ngcontent-%COMP%], .header__notifications[_ngcontent-%COMP%]{display:none}.header__lk[_ngcontent-%COMP%]{position:fixed;bottom:0;width:100%;height:4rem;padding:.5rem 1rem;background-color:#fff}.header__lk[_ngcontent-%COMP%], .header__lk[_ngcontent-%COMP%]:active, .header__lk[_ngcontent-%COMP%]:focus, .header__lk[_ngcontent-%COMP%]:hover{box-shadow:0 0 2px 0 rgba(0,0,0,.24)}.header__lk[_ngcontent-%COMP%]:before{position:absolute;top:.375rem;left:0;right:0;content:\"\";display:block;width:2rem;height:.125rem;margin:auto;background:#d8d8d8}.header__lk--open[_ngcontent-%COMP%]{height:20rem;box-shadow:0 0 2px 0 rgba(0,0,0,.24)}.header__user[_ngcontent-%COMP%]{flex:0 0 auto;justify-content:flex-start;height:auto;margin-bottom:1.5rem;padding:0}.header__user-info[_ngcontent-%COMP%], .header__user-name[_ngcontent-%COMP%]{order:2}.header__user-picoins[_ngcontent-%COMP%]{display:none}.header__user-photo[_ngcontent-%COMP%]{order:1;margin:0 1rem 0 0}.header__gamification[_ngcontent-%COMP%]{position:relative;top:0;display:block;flex:0 0 auto;height:auto;overflow:visible;background:transparent;opacity:1;box-shadow:none}.header__gamification-coins[_ngcontent-%COMP%]{padding:.25rem .75rem;margin:1rem 0;border:1px solid #d8d8d8;border-radius:100px}.header__gamification-item[_ngcontent-%COMP%]{padding:0}.header__gamification-item--coins[_ngcontent-%COMP%]{position:absolute;top:-5rem;right:0;display:block}.header__gamification-item--exit[_ngcontent-%COMP%]{margin:0;border:none}.header__gamification-item--exit[_ngcontent-%COMP%]   .header__gamification-link[_ngcontent-%COMP%], .header__gamification-link[_ngcontent-%COMP%]{display:block;padding:.8125rem 0}}@media (min-width:1025px){.header__menu-item--more[_ngcontent-%COMP%]:hover + .header__menu-list--additional[_ngcontent-%COMP%], .header__menu-list--additional[_ngcontent-%COMP%]:hover{display:flex;opacity:1;cursor:default}.header__menu-item--show-mobile[_ngcontent-%COMP%]{display:none}.header__menu-list--additional[_ngcontent-%COMP%]{position:absolute;top:5.625rem;right:0;z-index:20;display:none;flex-flow:row wrap;width:auto;max-width:1025px;max-height:calc(90vh - 5.625rem);padding:0 .5rem 1rem;background:#fff;box-shadow:0 6px 10px 0 rgba(0,0,0,.16);opacity:0}.header__menu-list--additional[_ngcontent-%COMP%]   .header__menu-item[_ngcontent-%COMP%]{flex:0 0 25%;min-width:10rem;padding:1rem 0 0;margin:0}.header__menu-list--additional[_ngcontent-%COMP%]   .header__menu-item[_ngcontent-%COMP%]:active   .header__menu-link[_ngcontent-%COMP%], .header__menu-list--additional[_ngcontent-%COMP%]   .header__menu-item[_ngcontent-%COMP%]:focus   .header__menu-link[_ngcontent-%COMP%], .header__menu-list--additional[_ngcontent-%COMP%]   .header__menu-item[_ngcontent-%COMP%]:hover   .header__menu-link[_ngcontent-%COMP%]{box-shadow:none}.header__menu-list--additional[_ngcontent-%COMP%]   .header__menu-link[_ngcontent-%COMP%]{font-weight:500;font-size:1.125rem;height:auto;padding:1rem 1rem .75rem;margin:0;line-height:1}.header__menu-list--additional[_ngcontent-%COMP%]   .header__submenu-list[_ngcontent-%COMP%]{position:static;display:block;width:100%;padding:0;border-radius:0;box-shadow:none;opacity:1}.header__menu-list--additional[_ngcontent-%COMP%]   .header__submenu-link[_ngcontent-%COMP%]{padding:.5rem 1rem}}@media print{.header[_ngcontent-%COMP%]{display:none}}"] });
HeaderComponent.ctorParameters = () => [
    { type: PikHeaderService },
    { type: EmployeeService },
    { type: MarketService },
    { type: PortalService },
    { type: NavigationService },
    { type: NotificationService },
    { type: PikLocatorService },
    { type: PikAuthService },
    { type: ChangeDetectorRef },
    { type: GoogleAnalyticsService }
];
HeaderComponent.propDecorators = {
    search: [{ type: ViewChild, args: [HeaderSearchComponent,] }],
    hideSearch: [{ type: Input }],
    hideNotifications: [{ type: Input }],
    onLogoClick: [{ type: Output }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-header',
                template: "<ng-container *ngIf=\"showHeader\">\n\n  <!-- SVG sprite -->\n  <app-svg></app-svg>\n\n  <!-- PIK header starts here -->\n  <nav class=\"header\" [class.header--open]=\"isMenuOpen\">\n    <div class=\"header__menu-toggle\" (click)=\"toggleMenu()\">\n      <div class=\"header__menu-bars\" [class.header__menu-bars--open]=\"isMenuOpen\"></div>\n      <div *ngIf=\"notifications?.length > 0 && !isMenuOpen\" class=\"header__menu-toggle-indicator\"></div>\n    </div>\n    <div class=\"header__logo\">\n      <div class=\"header__logo-wrapper\">\n        <a (click)=\"onHeaderLogoClick($event)\">\n          <!-- \u041B\u043E\u0433\u043E\u0442\u0438\u043F \u043F\u0438\u043A -->\n          <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\" fill=\"none\" class=\"header__logo-image\">\n            <path\n              d=\"M0.962891 32.7404V17.333H15.9209V32.7404H11.6041V21.154H5.27962V32.7404H0.962891ZM28.6703 23.8247L21.7635 32.7404H17.9286V17.333H22.2454V26.2488L29.1521 17.333H32.987V32.7404H28.6703V23.8247ZM39.3115 26.5364V32.7404H34.9948V17.333H39.3115V23.7219L44.4715 17.333H49.5111L43.3672 24.8107L51.037 32.7404H45.2345L39.3115 26.5364Z\"\n              fill=\"#FC4C02\"/>\n          </svg>\n        </a>\n      </div>\n    </div>\n    <div id=\"header-menu\" class=\"header__menu\">\n      <ul *ngIf=\"navigationNodes\" class=\"header__menu-list\">\n        <!-- \u041C\u043E\u0431\u0438\u043B\u044C\u043D\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 -->\n        <li *ngIf=\"notifications?.length > 0\" class=\"header__menu-item header__menu-item--show-mobile\"\n            [class.header__menu-item--open]=\"openedSubmenus.includes(null)\">\n          <a [attr.href]=\"\" class=\"header__menu-link\">\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F</a>\n          <div class=\"header__menu-item-indicator\"></div>\n          <a class=\"header__menu-link-icon\" (click)=\"toggleSubmenu(null)\">\n            <svg *ngIf=\"!openedSubmenus.includes(null)\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"\n                 viewBox=\"0 0 24 24\">\n              <path fill=\"#A1A1A1\" fill-rule=\"evenodd\" stroke=\"#A1A1A1\" stroke-width=\".6\"\n                    d=\"M18.481 11.222H12.52V5.52a.518.518 0 1 0-1.038 0v5.703H5.52a.518.518 0 1 0 0 1.037h5.962v6.222a.518.518 0 1 0 1.038 0V12.26h5.962a.518.518 0 1 0 0-1.037z\"/>\n            </svg>\n            <svg *ngIf=\"openedSubmenus.includes(null)\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"\n                 viewBox=\"0 0 24 24\">\n              <path fill=\"#4183F2\" fill-rule=\"evenodd\" stroke=\"#4183F2\"\n                    d=\"M12.519 11.222h-7a.518.518 0 1 0 0 1.037H18.48a.518.518 0 1 0 0-1.037H12.52z\"/>\n            </svg>\n          </a>\n          <div class=\"header__submenu-list\" [class.header__submenu-list--open]=\"openedSubmenus.includes(null)\">\n            <div class=\"header__submenu-list--hide\" (click)=\"hideAllNotification()\" *ngIf=\"notifications?.length > 5\">\n              \u0421\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0435\n            </div>\n            <ul class=\"header__submenu-notifications\">\n              <perfect-scrollbar class=\"header__submenu-ps\" *ngIf=\"notifications?.length > 0\" [config]=\"config\"\n                                 (psYReachEnd)=\"onScrollDown()\">\n                <li *ngFor=\"let notification of notifications\" class=\"header__submenu-item\">\n                  <app-notifications [notification]=\"notification\" (hideNotification)=\"hideNotification($event)\">\n                  </app-notifications>\n                </li>\n              </perfect-scrollbar>\n            </ul>\n          </div>\n        </li>\n        <ng-container *ngFor=\"let item of navigationNodes; let i = index\">\n          <li *ngIf=\"i < menuItemsLimit\" class=\"header__menu-item\"\n              [class.header__menu-item--open]=\"openedSubmenus.includes(item.id)\">\n            <a [attr.href]=\"item.url\" [target]=\"item.isNewTab ? '_blank' : '_self'\"\n               class=\"header__menu-link\" (mousedown)=\"sendGAEvent(item, $event)\">{{item.title}}</a>\n            <a *ngIf=\"item.children?.length > 0\" class=\"header__menu-link-icon\" (click)=\"toggleSubmenu(item.id)\">\n              <svg *ngIf=\"!openedSubmenus.includes(item.id)\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"\n                   viewBox=\"0 0 24 24\">\n                <path fill=\"#A1A1A1\" fill-rule=\"evenodd\" stroke=\"#A1A1A1\" stroke-width=\".6\"\n                      d=\"M18.481 11.222H12.52V5.52a.518.518 0 1 0-1.038 0v5.703H5.52a.518.518 0 1 0 0 1.037h5.962v6.222a.518.518 0 1 0 1.038 0V12.26h5.962a.518.518 0 1 0 0-1.037z\"/>\n              </svg>\n              <svg *ngIf=\"openedSubmenus.includes(item.id)\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"\n                   viewBox=\"0 0 24 24\">\n                <path fill=\"#4183F2\" fill-rule=\"evenodd\" stroke=\"#4183F2\"\n                      d=\"M12.519 11.222h-7a.518.518 0 1 0 0 1.037H18.48a.518.518 0 1 0 0-1.037H12.52z\"/>\n              </svg>\n            </a>\n            <ul *ngIf=\"item.children?.length > 0\" class=\"header__submenu-list\"\n                [class.header__submenu-list--open]=\"openedSubmenus.includes(item.id)\">\n              <li *ngFor=\"let child of item.children\" class=\"header__submenu-item\">\n                <a [attr.href]=\"child.url\" [target]=\"child.isNewTab ? '_blank' : '_self'\"\n                   class=\"header__submenu-link\" (mousedown)=\"sendGAEvent(child, $event)\">{{child.title}}</a>\n              </li>\n            </ul>\n          </li>\n        </ng-container>\n        <li *ngIf=\"navigationNodes?.length > menuItemsLimit + 1\" class=\"header__menu-item header__menu-item--more\"\n            [class.header__menu-item--hover]=\"isAdditionalOpen\">\n          <a class=\"header__menu-link\">\u0415\u0449\u0451</a>\n        </li>\n        <div class=\"header__menu-list header__menu-list--additional\" (mouseover)=\"isAdditionalOpen = true\"\n             (mouseleave)=\"isAdditionalOpen = false\">\n          <ng-container *ngFor=\"let item of navigationNodes; let i = index\">\n            <li *ngIf=\"i >= menuItemsLimit\" class=\"header__menu-item\"\n                [class.header__menu-item--open]=\"openedSubmenus.includes(item.id)\">\n              <a [attr.href]=\"item.url\" class=\"header__menu-link\"\n                 (mousedown)=\"sendGAEvent(item, $event)\">{{item.title}}</a>\n              <a *ngIf=\"item.children?.length > 0\" class=\"header__menu-link-icon\" (click)=\"toggleSubmenu(item.id)\">\n                <svg *ngIf=\"!openedSubmenus.includes(item.id)\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"\n                     viewBox=\"0 0 24 24\">\n                  <path fill=\"#A1A1A1\" fill-rule=\"evenodd\" stroke=\"#A1A1A1\" stroke-width=\".6\"\n                        d=\"M18.481 11.222H12.52V5.52a.518.518 0 1 0-1.038 0v5.703H5.52a.518.518 0 1 0 0 1.037h5.962v6.222a.518.518 0 1 0 1.038 0V12.26h5.962a.518.518 0 1 0 0-1.037z\"/>\n                </svg>\n                <svg *ngIf=\"openedSubmenus.includes(item.id)\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"\n                     viewBox=\"0 0 24 24\">\n                  <path fill=\"#4183F2\" fill-rule=\"evenodd\" stroke=\"#4183F2\"\n                        d=\"M12.519 11.222h-7a.518.518 0 1 0 0 1.037H18.48a.518.518 0 1 0 0-1.037H12.52z\"/>\n                </svg>\n              </a>\n              <ul class=\"header__submenu-list\" [class.header__submenu-list--open]=\"openedSubmenus.includes(item.id)\">\n                <li *ngFor=\"let child of item.children\" class=\"header__submenu-item\">\n                  <a [attr.href]=\"child.url\" class=\"header__submenu-link\"\n                     (mousedown)=\"sendGAEvent(child, $event)\">{{child.title}}</a>\n                </li>\n              </ul>\n            </li>\n          </ng-container>\n        </div>\n      </ul>\n    </div>\n\n    <!-- Search starts here -->\n    <div *ngIf=\"!hideSearch\" class=\"header__search\" [class.header__search--open]=\"isSearchOpen\">\n      <div class=\"header__search-toggle\" (click)=\"toggleSearch()\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" class=\"header__search-icon\">\n          <g fill=\"none\" fill-rule=\"evenodd\">\n            <path fill=\"#FFF\" d=\"M-1604-31H316v90h-1920z\"/>\n            <path fill=\"#EF4E23\" stroke=\"#EF4E23\" stroke-width=\"2\"\n                  d=\"M25.869 26.2l-6.993-7.293a9.896 9.896 0 0 0 2.889-6.995C21.765 6.446 17.332 2 11.882 2 6.433 2 2 6.446 2 11.912c0 5.466 4.433 9.912 9.882 9.912a9.819 9.819 0 0 0 6.299-2.28l7.01 7.311a.466.466 0 0 0 .665.013.473.473 0 0 0 .013-.667zm-13.987-5.32c-4.93 0-8.94-4.023-8.94-8.968s4.01-8.968 8.94-8.968 8.942 4.023 8.942 8.968-4.012 8.968-8.942 8.968z\"/>\n          </g>\n        </svg>\n      </div>\n    </div>\n\n    <!-- Notifications start here -->\n    <div *ngIf=\"!hideNotifications\"\n         class=\"header__notifications header__notifications--active\"\n         [class.header__notifications--search-hidden]=\"hideSearch\"\n    >\n      <div *ngIf=\"notifications?.length > 0\" class=\"header__notification-indicator\"></div>\n      <svg width=\"28\" height=\"28\" class=\"header__user-picoins-icon\">\n        <use xlink:href=\"#notification\"></use>\n      </svg>\n      <div class=\"header__notifications-dropdown\">\n        <div (click)=\"hideAllNotification()\" class=\"header__notifications-list--hide\" *ngIf=\"notifications?.length > 5\">\n          \u0421\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0435\n        </div>\n        <div style=\"margin: 5px;\" *ngIf=\"notifications?.length > 0\">\n          <perfect-scrollbar class=\"header__notifications-list\" [config]=\"config\" (psYReachEnd)=\"onScrollDown()\">\n            <app-notifications *ngFor=\"let notification of notifications\" [notification]=\"notification\"\n                               (hideNotification)=\"hideNotification($event)\"></app-notifications>\n          </perfect-scrollbar>\n        </div>\n      </div>\n      <div class=\"header__notifications-dropdown\" *ngIf=\"!notifications || notifications?.length === 0\">\n        <div class=\"header__notifications-empty\">\n          <p>\u041D\u043E\u0432\u044B\u0445 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043D\u0435\u0442</p>\n        </div>\n        <!-- <div class=\"header__notifications-show-all\">\n        <a href=\"\">\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435</a>\n      </div> -->\n      </div>\n    </div>\n\n    <ng-content select=\"[before-user-avatar]\"></ng-content>\n\n    <!-- User personal area starts here -->\n    <div class=\"header__lk\" [class.header__lk--open]=\"isLkOpen\" (click)=\"changeIsOpenLK()\">\n      <div class=\"header__user\">\n        <div class=\"header__user-info\">\n          <a [attr.href]=\"userUrl\" class=\"header__user-name\">\n            {{userName}}\n          </a>\n        </div>\n        <div class=\"header__user-photo\">\n          <app-header-user-image [userIdentity]=\"userIdentity\" [cssClass]=\"'nav-user-img'\"\n                                 [big]=\"true\"></app-header-user-image>\n        </div>\n      </div>\n\n      <div class=\"header__gamification\">\n        <ul class=\"header__gamification-list\">\n          <!-- <li class=\"header__gamification-item\">\n          <a href=\"\" class=\"header__gamification-link\">\u0411\u0435\u0439\u0434\u0436\u0438</a>\n        </li> -->\n          <!-- <li class=\"header__gamification-item\">\n          <a href=\"\" class=\"header__gamification-link\">\u0417\u0430\u0434\u0430\u0447\u0438</a>\n        </li> -->\n          <!-- <li class=\"header__gamification-item\">\n          <a href=\"\" class=\"header__gamification-link\">\u0420\u0435\u0439\u0442\u0438\u043D\u0433</a>\n        </li> -->\n          <li class=\"header__gamification-item\">\n            <a [attr.href]=\"userUrl\" class=\"header__gamification-link\">\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442</a>\n          </li>\n          <li class=\"header__gamification-item\">\n            <a [href]=\"changePasswordUrl\" target=\"_blank\" class=\"header__gamification-link\">\u0421\u043C\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u044F</a>\n          </li>\n          <li class=\"header__gamification-item header__gamification-item--exit\">\n            <a href=\"javascript:;\" (click)=\"logout()\" class=\"header__gamification-link\">\n              \u0412\u044B\u0445\u043E\u0434\n              <svg width=\"23px\" height=\"16px\" viewBox=\"0 0 23 28\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n                   xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"header__gamification-exit-icon\">\n                <g transform=\"translate(-1869.000000, -32.000000)\" fill-rule=\"nonzero\" fill=\"#757575\">\n                  <g id=\"Exit\" transform=\"translate(1864.000000, 30.000000)\">\n                    <g id=\"Group\" transform=\"translate(5.333333, 2.666667)\">\n                      <path\n                        d=\"M17.3902261,18.2492195 C17.1898468,18.2492195 16.9890591,18.1727206 16.8360029,18.0196645 C16.5303574,17.7137856 16.5303574,17.2175638 16.8360029,16.9116849 L19.6441138,14.1039825 L8.46220277,14.1039825 C8.0296426,14.1039825 7.67865791,13.7532312 7.67865791,13.3204376 C7.67865791,12.8876441 8.0296426,12.5368928 8.46220277,12.5368928 L19.5976076,12.5368928 L16.8315098,9.7246973 C16.529132,9.41700948 16.5319912,8.92259664 16.8384537,8.61876003 C17.1440992,8.31515682 17.6387454,8.31556528 17.944391,8.6212108 L22.0898614,12.7665062 C22.2367907,12.9134354 22.3192414,13.1127644 22.3192414,13.320496 C22.3192414,13.5282276 22.2367907,13.7275565 22.0898614,13.8744858 L17.944391,18.0197812 C17.7913348,18.1726623 17.590547,18.2492195 17.3902261,18.2492195 Z\"\n                        id=\"Shape\"></path>\n                      <path\n                        d=\"M16.0140627,26.6407586 L0.787045952,26.6407586 C0.354485777,26.6407586 0.00350109409,26.2900073 0.00350109409,25.8572137 L0.00350109409,0.783544858 C0.00350109409,0.350751276 0.354485777,0 0.787045952,0 L16.0140627,0 C16.4466229,0 16.7976076,0.350751276 16.7976076,0.783544858 L16.7976076,2.87183078 C16.7976076,3.30462436 16.4466229,3.65537564 16.0140627,3.65537564 C15.5815026,3.65537564 15.2305179,3.30462436 15.2305179,2.87183078 L15.2305179,1.56708972 L1.57059081,1.56708972 L1.57059081,25.0736689 L15.2305179,25.0736689 L15.2305179,23.7689278 C15.2305179,23.3361342 15.5815026,22.9853829 16.0140627,22.9853829 C16.4466229,22.9853829 16.7976076,23.3361342 16.7976076,23.7689278 L16.7976076,25.8572137 C16.7976659,26.2900073 16.4466813,26.6407586 16.0140627,26.6407586 Z\"\n                        id=\"Shape\"></path>\n                    </g>\n                  </g>\n                </g>\n              </svg>\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </nav>\n\n  <app-header-search *ngIf=\"!hideSearch\" [(isSearchOpen)]=\"isSearchOpen\"\n                     (searchClose)=\"isSearchOpen=false\"></app-header-search>\n\n</ng-container>\n",
                styles: ["@charset \"UTF-8\";*,:after,:before{box-sizing:inherit}a{transition:all .2s}.header{display:flex;flex-flow:row nowrap;align-items:center;height:5.625rem;font-family:ProbaPro;font-weight:400;line-height:1.4;color:#212121;background:#fff;border-bottom:1px solid #d8d8d8}.header__menu-toggle{display:none}.header__logo{display:flex;flex:0 0 auto;align-items:center;height:5.625rem;margin:0 2rem}.header__logo-wrapper{position:relative;width:3rem;height:3rem}.header__logo-tape{position:absolute;width:300px;height:65px;left:28px;bottom:-2px}.header__logo-hat{position:absolute;top:-17px;width:40px;height:30px;left:11px}.header__menu-item-indicator,.header__menu-toggle-indicator{display:none}.header__menu{position:relative;top:0;flex:1 1;flex-flow:row wrap;align-items:center;height:100%}.header__menu,.header__menu-list{display:flex;justify-content:flex-start;width:100%}.header__menu-list{flex-flow:row nowrap;padding:0;margin:0;list-style:none;transition:all .2s}.header__menu-item{position:relative;flex:0 0 auto;margin:0;white-space:nowrap;transition:all .2s}@media (min-width:1025px){.header__menu-item:last-child{position:static}}.header__menu-item--hover .header__menu-link,.header__menu-item:active .header__menu-link,.header__menu-item:hover .header__menu-link{color:#4285f4;box-shadow:inset 0 -2px 0 0 #4285f4}@media (min-width:1025px){.header__menu-item:hover .header__submenu-list{display:block;opacity:1}}@media (max-width:1025px){.header__menu-item--more{display:none}}.header__menu-link{display:block;height:5.625rem;padding:0 1.5rem;line-height:5.625rem;text-decoration:none;color:inherit;transition:box-shadow .2s,color .2s}.header__menu-link-icon{display:none}.header__submenu-list{position:absolute;top:100%;z-index:20;display:none;width:15.5rem;padding:1.25rem 0;margin:0;list-style:none;background:#fff;border-bottom-left-radius:4px;border-bottom-right-radius:4px;box-shadow:0 6px 10px 0 rgba(0,0,0,.16);opacity:0;transition:all .2s}.header__submenu-link{position:relative;display:block;padding:.625rem 1.5rem;font-size:1rem;line-height:1.4;color:inherit;text-decoration:none;white-space:pre-line}.header__submenu-link:active,.header__submenu-link:hover{color:#4285f4}.header__search{display:flex;justify-content:center;align-items:center;flex:0 0 auto;width:5.625rem;height:5.625rem;margin-left:auto;border-left:1px solid #d8d8d8;border-right:1px solid #d8d8d8}.header__search-toggle{position:relative;width:100%;height:100%;cursor:pointer}.header__search-icon{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.header__notifications{position:relative;display:flex;justify-content:center;align-items:center;flex:0 0 auto;width:5.625rem;height:5.625rem;margin-left:auto;border-right:1px solid #d8d8d8;transition:all .2s}.header__notifications--search-hidden{border-left:1px solid #d8d8d8}.header__notifications--active:active,.header__notifications--active:hover{box-shadow:inset 0 -2px 0 0 #4285f4}.header__notifications--active:active .header__notifications-dropdown,.header__notifications--active:hover .header__notifications-dropdown{height:auto;opacity:1}.header__notification-indicator{position:absolute;top:calc(50% - .75rem);right:calc(50% - .75rem);width:.5rem;height:.5rem;background:#ef4e23;border-radius:10rem;box-shadow:0 0 4px 0 #ef4e23}.header__notifications-dropdown{position:absolute;top:calc(100%);right:0;z-index:20;width:19.5rem;height:0;background:#fff;border-radius:4px;overflow:hidden;box-shadow:0 6px 10px 0 rgba(0,0,0,.16);opacity:0;transition:opacity .25s ease-out}.header__notifications-list{position:relative;max-height:350px;overflow-y:auto}.header__notifications-list--hide{border-radius:4px 4px 0 0;padding:15.5px 0;text-align:center;font-size:15px;background-color:#f5f5f5;cursor:pointer}.header__notifications-empty{padding:1rem .5rem;color:#757575;text-align:center}.header__notifications-empty p{padding:0;margin:0}.header__notifications-show-all{padding:.5rem;text-align:center;border-top:1px solid #d8d8d8}.header__notifications-show-all a{color:#212121;text-decoration:none;transition:all .25s}.header__notifications-show-all a:active,.header__notifications-show-all a:focus,.header__notifications-show-all a:hover{color:#4285f4}.header__lk{position:relative;flex:0 0 auto;z-index:25;display:flex;flex-flow:column nowrap;width:15.875rem;padding-right:2rem;transition:all .2s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.header__lk:active,.header__lk:hover{box-shadow:inset 0 -2px 0 0 #4285f4}.header__lk:active .header__gamification,.header__lk:hover .header__gamification{height:auto;opacity:1}.header__user{display:flex;justify-content:flex-end;flex-flow:row nowrap;align-items:center;height:5.625rem;padding-left:1.5rem;font-size:1rem}.header__user-info{display:flex;flex-flow:column nowrap}.header__user-name{margin-bottom:.1875rem;color:#757575;text-decoration:none;line-height:1;white-space:normal;word-wrap:break-word;overflow:hidden}.header__user-picoins{display:inline-flex;justify-content:flex-end;align-items:center;color:#a1a1a1;text-decoration:none;line-height:1}.header__user-picoins-icon{margin-left:.0625rem}.header__user-photo{flex:0 0 auto;width:3rem;height:3rem;margin:0 0 0 1rem;border:1px solid #d8d8d8;border-radius:100px;overflow:hidden}.header__gamification{position:absolute;top:calc(100%);z-index:20;justify-content:flex-start;flex:1 0 auto;width:100%;height:0;background:#fff;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-radius:4px;overflow:hidden;opacity:0;box-shadow:0 6px 10px 0 rgba(0,0,0,.16);transition:opacity .2s ease-out}.header__gamification-list{width:100%;padding:.5rem 0 0;margin:0;list-style:none}.header__gamification-item{padding:0 .75rem 0 1.25rem}.header__gamification-item--exit{margin-top:.5rem;border-top:1px solid #d8d8d8}.header__gamification-item--exit .header__gamification-link{display:block;padding:.75rem}.header__gamification-item--coins{display:none}.header__gamification-coins{display:inline-block;padding:.25rem .75rem;margin:1rem 0;border:1px solid #d8d8d8;border-radius:100px}.header__gamification-link{display:inline-block;padding:.5rem .75rem;color:inherit;text-decoration:none;transition:color .2s}.header__gamification-link:hover{color:#4285f4}.header__gamification-link:hover .header__gamification-exit-icon g{fill:#4285f4}.header__gamification-exit-icon{position:relative;top:3px;float:right}@media (max-width:1025px){.header{top:0;z-index:120;flex-flow:row wrap;justify-content:space-between;align-content:flex-start;align-items:flex-start;width:100%;height:4.125rem;border:none;overflow:hidden;position:relative}.header--open{height:100vh;position:fixed;-webkit-overflow-scrolling:touch}.header--open .header__lk{display:block}.header--open .header__menu-item:last-child{margin-bottom:4rem}.header__menu-toggle{position:relative;display:block;flex:0 0 auto;order:1;width:4.125rem;height:4.125rem;border-bottom:1px solid #d8d8d8;cursor:pointer}.header__menu-bars{top:0;right:0;bottom:0;left:0;margin:auto;height:3px}.header__menu-bars,.header__menu-bars:after,.header__menu-bars:before{position:absolute;width:1.5rem;border-bottom:3px solid #212121;transition:all .2s}.header__menu-bars:after,.header__menu-bars:before{content:\"\";display:block}.header__menu-bars:before{top:-7px}.header__menu-bars:after{top:7px}.header__menu-bars--open{border-color:transparent}.header__menu-bars--open:before{top:0;transform:rotate(-45deg)}.header__menu-bars--open:after{top:0;transform:rotate(45deg)}.header__menu-toggle-indicator{top:1rem;right:1rem}.header__menu-item-indicator,.header__menu-toggle-indicator{position:absolute;display:block;width:.75rem;height:.75rem;border-radius:1rem;background-color:#ef4e23;box-shadow:0 0 4px 0 #ef4e23}.header__menu-item-indicator{top:1.375rem;right:3.75rem}.header__logo{order:2;flex:1 0 auto;justify-content:center;width:4.125rem;height:4.125rem;margin:0;border-bottom:1px solid #d8d8d8}.header__logo-wrapper{width:4rem;height:4rem}.header__menu{order:4;flex:1 0 100%;display:block;height:calc(100vh - 4.125rem - 4rem);padding-top:1rem;overflow-y:scroll}.header__menu-list{display:block}.header__menu-item:active .header__menu-link,.header__menu-item:hover .header__menu-link{color:inherit;box-shadow:none}.header__menu-item--open:not(:first-child),.header__menu-item--open:not(:last-child){box-shadow:0 1px 1px 0 #d8d8d8,0 -1px 1px 0 #d8d8d8}.header__menu-item--open:first-child{box-shadow:0 1px 1px 0 #d8d8d8}.header__menu-item--open:last-child{box-shadow:0 -1px 1px 0 #d8d8d8}.header__menu-item--open .header__menu-link{font-weight:500;color:inherit;box-shadow:none}.header__menu-link{height:auto;padding:1rem;font-size:1.25rem;line-height:1}.header__menu-link-icon{position:absolute;top:0;right:0;display:block;width:auto;height:100%;padding:1rem;line-height:1;cursor:pointer}.header__submenu-list{position:relative;width:100%;padding:0;border-radius:0;box-shadow:none}.header__submenu-list--open{display:block;opacity:1}.header__submenu-list--hide{height:55px;text-align:center;font-size:16px;padding-top:15px;background-color:#f5f5f5;cursor:pointer}.header__submenu-notifications{margin:5px;padding:0;list-style-type:none}.header__submenu-ps{position:relative;max-height:350px}.header__submenu-link{padding:.875rem 1rem}.header__search{order:3;flex:0 0 auto;width:4.125rem;height:4.125rem;margin:0;border:none;border-bottom:1px solid #d8d8d8}.header__search--open .header__search-icon{display:none}.header__search--open .header__search-toggle:after{content:\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\";display:block;line-height:4.125rem;color:#ef4e23}.header__lk,.header__notifications{display:none}.header__lk{position:fixed;bottom:0;width:100%;height:4rem;padding:.5rem 1rem;background-color:#fff}.header__lk,.header__lk:active,.header__lk:focus,.header__lk:hover{box-shadow:0 0 2px 0 rgba(0,0,0,.24)}.header__lk:before{position:absolute;top:.375rem;left:0;right:0;content:\"\";display:block;width:2rem;height:.125rem;margin:auto;background:#d8d8d8}.header__lk--open{height:20rem;box-shadow:0 0 2px 0 rgba(0,0,0,.24)}.header__user{flex:0 0 auto;justify-content:flex-start;height:auto;margin-bottom:1.5rem;padding:0}.header__user-info,.header__user-name{order:2}.header__user-picoins{display:none}.header__user-photo{order:1;margin:0 1rem 0 0}.header__gamification{position:relative;top:0;display:block;flex:0 0 auto;height:auto;overflow:visible;background:transparent;opacity:1;box-shadow:none}.header__gamification-coins{padding:.25rem .75rem;margin:1rem 0;border:1px solid #d8d8d8;border-radius:100px}.header__gamification-item{padding:0}.header__gamification-item--coins{position:absolute;top:-5rem;right:0;display:block}.header__gamification-item--exit{margin:0;border:none}.header__gamification-item--exit .header__gamification-link,.header__gamification-link{display:block;padding:.8125rem 0}}@media (min-width:1025px){.header__menu-item--more:hover+.header__menu-list--additional,.header__menu-list--additional:hover{display:flex;opacity:1;cursor:default}.header__menu-item--show-mobile{display:none}.header__menu-list--additional{position:absolute;top:5.625rem;right:0;z-index:20;display:none;flex-flow:row wrap;width:auto;max-width:1025px;max-height:calc(90vh - 5.625rem);padding:0 .5rem 1rem;background:#fff;box-shadow:0 6px 10px 0 rgba(0,0,0,.16);opacity:0}.header__menu-list--additional .header__menu-item{flex:0 0 25%;min-width:10rem;padding:1rem 0 0;margin:0}.header__menu-list--additional .header__menu-item:active .header__menu-link,.header__menu-list--additional .header__menu-item:focus .header__menu-link,.header__menu-list--additional .header__menu-item:hover .header__menu-link{box-shadow:none}.header__menu-list--additional .header__menu-link{font-weight:500;font-size:1.125rem;height:auto;padding:1rem 1rem .75rem;margin:0;line-height:1}.header__menu-list--additional .header__submenu-list{position:static;display:block;width:100%;padding:0;border-radius:0;box-shadow:none;opacity:1}.header__menu-list--additional .header__submenu-link{padding:.5rem 1rem}}@media print{.header{display:none}}"]
            }]
    }], function () { return [{ type: PikHeaderService }, { type: EmployeeService }, { type: MarketService }, { type: PortalService }, { type: NavigationService }, { type: NotificationService }, { type: PikLocatorService }, { type: PikAuthService }, { type: ɵngcc0.ChangeDetectorRef }, { type: GoogleAnalyticsService }]; }, { hideSearch: [{
            type: Input
        }], hideNotifications: [{
            type: Input
        }], onLogoClick: [{
            type: Output
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], search: [{
            type: ViewChild,
            args: [HeaderSearchComponent]
        }] }); })();

class StatusBarComponent {
    constructor(navigationService) {
        this.navigationService = navigationService;
    }
    ngOnInit() {
        // this.navigationService.getStatusBarSettings().then(res => this.statusBarSettings = res);
    }
}
StatusBarComponent.ɵfac = function StatusBarComponent_Factory(t) { return new (t || StatusBarComponent)(ɵngcc0.ɵɵdirectiveInject(NavigationService)); };
StatusBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StatusBarComponent, selectors: [["app-status-bar"]], decls: 2, vars: 0, template: function StatusBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " status-bar works!\n");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
StatusBarComponent.ctorParameters = () => [
    { type: NavigationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StatusBarComponent, [{
        type: Component,
        args: [{
                selector: 'app-status-bar',
                template: "<p>\n  status-bar works!\n</p>\n",
                styles: [""]
            }]
    }], function () { return [{ type: NavigationService }]; }, null); })();

/**
 * Сервис подразделений компании
 *
 * @export
 * @class UnitService
 * @extends {BaseService}
 */
class UnitService extends BaseService {
    constructor(http, locator, auth, authSettings) {
        super(http, auth, authSettings);
        this.http = http;
        this.locator = locator;
        this.auth = auth;
        this.authSettings = authSettings;
        this.serviceUrl = this.locator.urls.homeApi + '/api/v1.0/unit';
    }
    // get unit by id
    getUnit(id, deep) {
        const url = deep ? '?deep=' + deep + '&' : '?';
        return this.get(`${id}${url}withHierarchy=true&t=${new Date().getTime()}`, null, true);
    }
    // get units tree by parent id and tree deep
    getUnits(parentId, deep, withHierarchy) {
        const url = parentId ? 'parentId=' + parentId + '&' : '';
        return this.get(`?${url}deep=${deep}&withHierarchy=${withHierarchy ? true : false}&t=${new Date().getTime()}`, null, true);
    }
    // helper methods
    getUnitHierarchy(unit, includeCurrent = true) {
        const units = [];
        if (includeCurrent) {
            units.push(unit);
        }
        this.getParentUnitsRecursively(unit, units);
        return Promise.resolve(units);
    }
    getUnitUrl(unit) {
        if (unit) {
            return Helpers.concatUrls(this.locator.urls.homeUrl, `/employees/units/${unit.id}`);
        }
        return 'javascript:void(0);';
    }
    getParentUnitsRecursively(unit, units) {
        if (unit && units) {
            const parentUnit = unit.parent;
            if (parentUnit) {
                units.unshift(parentUnit);
                this.getParentUnitsRecursively(parentUnit, units);
            }
        }
    }
}
UnitService.ɵfac = function UnitService_Factory(t) { return new (t || UnitService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(PikLocatorService), ɵngcc0.ɵɵinject(PikAuthService), ɵngcc0.ɵɵinject(PIK_AUTH_CONFIG)); };
UnitService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UnitService, factory: UnitService.ɵfac });
UnitService.ctorParameters = () => [
    { type: HttpClient },
    { type: PikLocatorService },
    { type: PikAuthService },
    { type: undefined, decorators: [{ type: Inject, args: [PIK_AUTH_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UnitService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: PikLocatorService }, { type: PikAuthService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PIK_AUTH_CONFIG]
            }] }]; }, null); })();

class CommonUserImageComponent {
    constructor(employeeService) {
        this.employeeService = employeeService;
        this.defaultImage = 'https://storage.yandexcloud.net/home-cdn/user.svg';
    }
    onImgLoad(event) {
        const elem = event.srcElement ? event.srcElement : event.target;
        if (elem.naturalHeight === 200 && elem.naturalWidth === 200) {
            this.setClass = true;
        }
        else if (elem.naturalHeight === 0 && elem.naturalWidth === 0) {
            const img = new Image();
            img.onload = () => {
                this.setClass = img.width === 200 && img.height === 200;
            };
            img.src = elem.src;
        }
        else {
            this.setClass = false;
        }
    }
    ngOnChanges(changes) {
        if (changes.employee) {
            if (this.employee) {
                this.employeeSub = this.employeeService.photoUpdated.subscribe((params) => {
                    if (params && params.time && this.employee && params.employeeId === this.employee.id) {
                        this.lazyLoad = this.employeeService.getEmployeePhoto(this.employee, !this.big) + `&t=${params.time.getTime()}`;
                    }
                    else {
                        this.lazyLoad = this.employeeService.getEmployeePhoto(this.employee, !this.big);
                    }
                    if (!this.lazyLoad) {
                        this.lazyLoad = this.defaultImage;
                    }
                });
            }
            else {
                this.lazyLoad = this.defaultImage;
            }
        }
    }
    ngOnDestroy() {
        if (this.employeeSub) {
            this.employeeSub.unsubscribe();
        }
    }
}
CommonUserImageComponent.ɵfac = function CommonUserImageComponent_Factory(t) { return new (t || CommonUserImageComponent)(ɵngcc0.ɵɵdirectiveInject(EmployeeService)); };
CommonUserImageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CommonUserImageComponent, selectors: [["app-common-user-image"]], inputs: { defaultImage: "defaultImage", employee: "employee", cssClass: "cssClass", big: "big" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [[3, "ngClass", "load"]], template: function CommonUserImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "img", 0);
        ɵngcc0.ɵɵlistener("load", function CommonUserImageComponent_Template_img_load_0_listener($event) { return ctx.onImgLoad($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.setClass ? ctx.cssClass : "");
        ɵngcc0.ɵɵattribute("src", ctx.lazyLoad, ɵngcc0.ɵɵsanitizeUrl);
    } }, directives: [ɵngcc5.NgClass], styles: ["img[_ngcontent-%COMP%]{width:100%}"] });
CommonUserImageComponent.ctorParameters = () => [
    { type: EmployeeService }
];
CommonUserImageComponent.propDecorators = {
    employee: [{ type: Input }],
    defaultImage: [{ type: Input }],
    cssClass: [{ type: Input }],
    big: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommonUserImageComponent, [{
        type: Component,
        args: [{
                selector: 'app-common-user-image',
                template: "<img [ngClass]=\"setClass? cssClass :''\" (load)=\"onImgLoad($event)\" [attr.src]=\"lazyLoad\" />\n",
                styles: ["img{width:100%}"]
            }]
    }], function () { return [{ type: EmployeeService }]; }, { defaultImage: [{
            type: Input
        }], employee: [{
            type: Input
        }], cssClass: [{
            type: Input
        }], big: [{
            type: Input
        }] }); })();

class HeaderUserImageComponent extends CommonUserImageComponent {
    constructor(employeeService) {
        super(employeeService);
        this.employeeService = employeeService;
    }
    ngOnChanges(changes) {
        if (changes.userIdentity) {
            if (this.userIdentity) {
                this.employeeSub = this.employeeService.photoUpdated.subscribe((params) => {
                    if (params && params.time && this.userIdentity && params.employeeId === this.userIdentity.id) {
                        this.lazyLoad = this.employeeService.getIndividualPhoto(this.userIdentity, !this.big) + `&t=${params.time.getTime()}`;
                    }
                    else {
                        this.lazyLoad = this.employeeService.getIndividualPhoto(this.userIdentity, !this.big);
                    }
                    if (!this.lazyLoad) {
                        this.lazyLoad = this.defaultImage;
                    }
                });
            }
            else {
                this.lazyLoad = this.defaultImage;
            }
        }
    }
}
HeaderUserImageComponent.ɵfac = function HeaderUserImageComponent_Factory(t) { return new (t || HeaderUserImageComponent)(ɵngcc0.ɵɵdirectiveInject(EmployeeService)); };
HeaderUserImageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderUserImageComponent, selectors: [["app-header-user-image"]], inputs: { userIdentity: "userIdentity" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [[3, "ngClass", "load"]], template: function HeaderUserImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "img", 0);
        ɵngcc0.ɵɵlistener("load", function HeaderUserImageComponent_Template_img_load_0_listener($event) { return ctx.onImgLoad($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.setClass ? ctx.cssClass : "");
        ɵngcc0.ɵɵattribute("src", ctx.lazyLoad, ɵngcc0.ɵɵsanitizeUrl);
    } }, directives: [ɵngcc5.NgClass], styles: ["img[_ngcontent-%COMP%]{width:100%}"] });
HeaderUserImageComponent.ctorParameters = () => [
    { type: EmployeeService }
];
HeaderUserImageComponent.propDecorators = {
    userIdentity: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderUserImageComponent, [{
        type: Component,
        args: [{
                selector: 'app-header-user-image',
                template: "<img [ngClass]=\"setClass? cssClass :''\" (load)=\"onImgLoad($event)\" [attr.src]=\"lazyLoad\" />\n",
                styles: ["img{width:100%}"]
            }]
    }], function () { return [{ type: EmployeeService }]; }, { userIdentity: [{
            type: Input
        }] }); })();

class PikOrgstructureModule {
    static forRoot() {
        return {
            ngModule: PikOrgstructureModule,
            providers: [
                DatePipe,
                UnitService,
                EmployeeService,
                SearchService,
                PortalService,
                MarketService
            ]
        };
    }
}
PikOrgstructureModule.ɵfac = function PikOrgstructureModule_Factory(t) { return new (t || PikOrgstructureModule)(); };
PikOrgstructureModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikOrgstructureModule });
PikOrgstructureModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        UnitService,
        EmployeeService,
        SearchService,
        PortalService,
        MarketService,
        WikiService
    ], imports: [[
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            CommonModule,
            PikCommonModule.forChild()
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikOrgstructureModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BrowserModule,
                    FormsModule,
                    ReactiveFormsModule,
                    CommonModule,
                    PikCommonModule.forChild()
                ],
                declarations: [
                    HeaderUserImageComponent,
                    CommonUserImageComponent
                ],
                exports: [
                    HeaderUserImageComponent,
                    CommonUserImageComponent
                ],
                providers: [
                    UnitService,
                    EmployeeService,
                    SearchService,
                    PortalService,
                    MarketService,
                    WikiService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikOrgstructureModule, { declarations: function () { return [HeaderUserImageComponent, CommonUserImageComponent]; }, imports: function () { return [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule, PikCommonModule]; }, exports: function () { return [HeaderUserImageComponent, CommonUserImageComponent]; } }); })();

class SvgComponent {
    constructor() { }
    ngOnInit() {
    }
}
SvgComponent.ɵfac = function SvgComponent_Factory(t) { return new (t || SvgComponent)(); };
SvgComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SvgComponent, selectors: [["app-svg"]], decls: 55, vars: 0, consts: [[2, "display", "none"], ["id", "logo", "viewBox", "0 0 1984 1984"], ["id", "PIK_Logo_Color_RGB", "transform", "translate(-2.000000, 0.000000)", "fill-rule", "nonzero"], ["id", "g10", "transform", "translate(993.500000, 993.000000) scale(-1, 1) rotate(-180.000000) translate(-993.500000, -993.000000) translate(-0.000000, 0.000000)"], ["id", "g12", "transform", "translate(0.669821, 1265.997277)", "fill", "#0A055F"], ["id", "path14", "points", "993.333308 719.999982 1.33066663 216.002661 1.33066663 0.0026666666 993.333308 503.999987 1985.33062 0.0026666666 1985.33062 216.002661"], ["id", "g16", "transform", "translate(1.999955, 562.002628)", "fill", "#0A055F"], ["id", "path18", "points", "167.999996 487.999988 407.997323 487.999988 407.997323 0 575.997319 0 575.997319 639.999984 0 639.999984 0 0 167.999996 0"], ["id", "g20", "transform", "translate(658.000605, 562.002628)", "fill", "#0A055F"], ["id", "path22", "points", "0 639.999984 0 0 255.999994 0 471.999988 508.234654 471.999988 0 639.999984 0 639.999984 639.999984 383.99999 639.999984 167.999996 131.76533 167.999996 639.999984"], ["id", "g24", "transform", "translate(1378.000587, 562.002628)", "fill", "#0A055F"], ["id", "path26", "points", "0 639.999984 0 0 167.999996 0 167.999996 205.334662 217.398661 254.13466 407.997323 0 607.997318 0 332.281325 367.625324 607.997318 639.999984 391.997324 639.999984 167.999996 400.001323 167.999996 639.999984"], ["id", "g28", "transform", "translate(1663.333247, 217.366503)", "fill", "#FF4114"], ["id", "path30", "points", "38.6666657 113.333331 0.54933332 0.637333317 76.7839981 0.637333317"], ["id", "g32", "transform", "translate(2.000000, 0.000000)", "fill", "#FF4114"], ["id", "g34-Clipped", "transform", "translate(-0.000000, 0.000000)"], ["id", "g34", "transform", "translate(-0.000045, 0.666642)"], ["id", "g40", "transform", "translate(0.000000, 0.003867)"], ["d", "M167.999996,377.333324 L375.999991,377.333324 L375.999991,318.666659 L231.999994,318.666659 L231.999994,105.333331 L167.999996,105.333331 L167.999996,377.333324 Z M415.99999,377.333324 L555.999986,377.333324 C608.726651,377.333324 651.999984,347.798658 651.999984,287.333326 C651.999984,226.869328 608.726651,197.333328 555.999986,197.333328 L479.999988,197.333328 L479.999988,105.333331 L415.99999,105.333331 L415.99999,377.333324 Z M727.999982,377.333324 L793.99998,259.227994 L859.999978,377.333324 L927.999977,377.333324 L775.999981,105.333331 L707.999982,105.333331 L760.169314,198.689328 L653.333317,377.333324 L727.999982,377.333324 Z M959.999976,377.333324 L1207.99997,377.333324 L1207.99997,105.333331 L1143.99997,105.333331 L1143.99997,318.666659 L1023.99997,318.666659 L1023.99997,105.333331 L959.999976,105.333331 L959.999976,377.333324 Z M1263.99997,377.333324 L1511.99996,377.333324 L1511.99996,105.333331 L1447.99996,105.333331 L1447.99996,318.666659 L1327.99997,318.666659 L1327.99997,105.333331 L1263.99997,105.333331 L1263.99997,377.333324 Z M1655.99996,377.333324 L1743.99996,377.333324 L1843.99995,105.333331 L1775.99996,105.333331 L1757.05862,161.333329 L1642.94129,161.333329 L1623.99996,105.333331 L1555.99996,105.333331 L1655.99996,377.333324 Z M0,1.33199997 L1983.99995,1.33199997 L1983.99995,481.331988 L0,481.331988 L0,1.33199997 Z", "id", "path42"], ["id", "g44", "transform", "translate(479.999988, 252.670527)"], ["d", "M108,34.6666667 C108,58.22 91.2973333,68.6666666 70.6666667,68.6666666 L0,68.6666666 L0,0.66666665 L70.6666667,0.66666665 C91.2973333,0.66666665 108,11.1133333 108,34.6666667", "id", "path46"], ["id", "search-icon", "viewBox", "0 0 28 28"], ["fill", "none", "fill-rule", "evenodd"], ["d", "M-1604-31H316v90h-1920z"], ["fill", "#EF4E23", "stroke", "#EF4E23", "stroke-width", "2", "d", "M25.869 26.2l-6.993-7.293a9.896 9.896 0 0 0 2.889-6.995C21.765 6.446 17.332 2 11.882 2 6.433 2 2 6.446 2 11.912c0 5.466 4.433 9.912 9.882 9.912a9.819 9.819 0 0 0 6.299-2.28l7.01 7.311a.466.466 0 0 0 .665.013.473.473 0 0 0 .013-.667zm-13.987-5.32c-4.93 0-8.94-4.023-8.94-8.968s4.01-8.968 8.94-8.968 8.942 4.023 8.942 8.968-4.012 8.968-8.942 8.968z"], ["id", "exit-icon", "viewBox", "0 0 23 28"], ["transform", "translate(-1869.000000, -32.000000)", "fill-rule", "nonzero", "fill", "#757575"], ["id", "Exit", "transform", "translate(1864.000000, 30.000000)"], ["id", "Group", "transform", "translate(5.333333, 2.666667)"], ["d", "M17.3902261,18.2492195 C17.1898468,18.2492195 16.9890591,18.1727206 16.8360029,18.0196645 C16.5303574,17.7137856 16.5303574,17.2175638 16.8360029,16.9116849 L19.6441138,14.1039825 L8.46220277,14.1039825 C8.0296426,14.1039825 7.67865791,13.7532312 7.67865791,13.3204376 C7.67865791,12.8876441 8.0296426,12.5368928 8.46220277,12.5368928 L19.5976076,12.5368928 L16.8315098,9.7246973 C16.529132,9.41700948 16.5319912,8.92259664 16.8384537,8.61876003 C17.1440992,8.31515682 17.6387454,8.31556528 17.944391,8.6212108 L22.0898614,12.7665062 C22.2367907,12.9134354 22.3192414,13.1127644 22.3192414,13.320496 C22.3192414,13.5282276 22.2367907,13.7275565 22.0898614,13.8744858 L17.944391,18.0197812 C17.7913348,18.1726623 17.590547,18.2492195 17.3902261,18.2492195 Z", "id", "Shape"], ["d", "M16.0140627,26.6407586 L0.787045952,26.6407586 C0.354485777,26.6407586 0.00350109409,26.2900073 0.00350109409,25.8572137 L0.00350109409,0.783544858 C0.00350109409,0.350751276 0.354485777,0 0.787045952,0 L16.0140627,0 C16.4466229,0 16.7976076,0.350751276 16.7976076,0.783544858 L16.7976076,2.87183078 C16.7976076,3.30462436 16.4466229,3.65537564 16.0140627,3.65537564 C15.5815026,3.65537564 15.2305179,3.30462436 15.2305179,2.87183078 L15.2305179,1.56708972 L1.57059081,1.56708972 L1.57059081,25.0736689 L15.2305179,25.0736689 L15.2305179,23.7689278 C15.2305179,23.3361342 15.5815026,22.9853829 16.0140627,22.9853829 C16.4466229,22.9853829 16.7976076,23.3361342 16.7976076,23.7689278 L16.7976076,25.8572137 C16.7976659,26.2900073 16.4466813,26.6407586 16.0140627,26.6407586 Z", "id", "Shape"], ["id", "cross-icon", "viewBox", "0 0 24 24"], ["fill", "#A1A1A1", "fill-rule", "evenodd", "d", "M20 4.914L19.086 4 12 11.086 4.914 4 4 4.914 11.086 12 4 19.086l.914.914L12 12.914 19.086 20l.914-.914L12.914 12z"], ["id", "user", "viewBox", "0 0 200 200"], ["id", "path-1", "cx", "100", "cy", "100", "r", "100"], ["id", "1422", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["id", "#1422-3)\u0437\u0430\u0433\u043B\u0443\u0448\u043A\u0443-\u0444\u043E\u0442\u043E-\u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430", "transform", "translate(-519.000000, -248.000000)"], ["id", "\u0417\u0430\u0433\u043B\u0443\u0448\u043A\u0430", "transform", "translate(519.000000, 248.000000)"], ["id", "mask-2", "fill", "white"], [0, "xlink", "href", "#path-1"], ["id", "\u041F\u043E\u0440\u0442\u0440\u0435\u0442", "fill", "#FFFFFF", 0, "xlink", "href", "#path-1"], ["d", "M100.300823,202.988033 C129.814105,202.988033 156.484813,190.777917 175.601646,171.116879 C164.257672,149.310077 148.16976,144.839735 148.16976,144.839735 L138.595551,144.839735 C128.020125,144.839735 119.448187,136.222821 119.448187,125.595576 L119.448187,119.414337 C123.683621,114.353593 126.722017,108.369155 128.610749,102.044018 C128.805518,100.977485 129.827791,100.450566 130.510009,99.7173245 C134.174823,96.0352444 134.895994,89.819089 132.145015,85.3931864 C131.772322,84.7223707 131.096421,84.1383166 131.133269,83.3066743 C131.133269,77.6639924 131.162748,72.0117878 131.126953,66.3743961 C130.977454,59.5678383 129.042399,52.4861824 124.292143,47.4455417 C120.45888,43.3730342 115.193802,40.9489981 109.763434,39.9110324 C102.900198,38.5947946 95.7200686,38.6603948 88.9221068,40.3988022 C83.031663,41.8927956 77.4981201,45.3600877 74.0765039,50.5001869 C71.0454784,54.9684123 69.7178913,60.3931321 69.4936438,65.7406128 C69.4094194,71.4816952 69.4757461,77.2365325 69.4578485,82.9913698 C69.5873435,84.1436069 68.6166573,84.9234038 68.1765848,85.8767239 C65.5856318,90.5988859 66.7268724,97.0308873 70.8875576,100.465379 C71.9424682,101.196505 72.1414483,102.531788 72.5236166,103.684025 C74.3386523,109.367972 77.3475689,114.624459 81.1534589,119.205897 L81.1534589,125.595576 C81.1534589,136.222821 72.580468,144.839735 62.0060949,144.839735 L52.4308336,144.839735 C52.4308336,144.839735 36.3439736,149.30796 25,171.115821 C44.1157799,190.777917 70.7875411,202.988033 100.300823,202.988033 Z", "id", "Stroke-3", "stroke", "#D6D6D6", "stroke-width", "3", "mask", "url(#mask-2)"], ["id", "picoin", "viewBox", "0 0 24 24"], ["fill", "#A1A1A1", "fill-rule", "evenodd"], ["fill-rule", "nonzero", "d", "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-.86a9.14 9.14 0 1 0 0-18.28 9.14 9.14 0 0 0 0 18.28z"], ["d", "M12.018 5L6 8.37v1.445l6.018-3.371 6.019 3.37V8.37zM6 17.037h12.037v-1.204H6zM6 10.417v4.213h1.023v-3.311h1.565v3.31h1.023v-4.212zM10.213 10.417v4.213h1.264l1.324-3.01v3.01h1.023v-4.213H12.56l-1.324 3.009v-3.01zM16.833 10.417l-1.383 1.565v-1.565h-1.024v4.213h1.024v-1.445l.296-.317 1.148 1.762h1.143l-1.617-2.483 1.617-1.73z"], ["id", "notification", "viewBox", "0 0 24 24"], ["fill", "#000", "fill-opacity", ".87", "fill-rule", "evenodd", "stroke", "#212121", "stroke-width", ".2"], ["d", "M20.591 18.47c-1.694-1.685-2.553-3.678-2.553-5.925v-3.27c.015-2.494-1.661-4.147-3.102-4.806a7.31 7.31 0 0 0-1.27-.442v-.209A1.82 1.82 0 0 0 11.846 2a1.82 1.82 0 0 0-1.818 1.818v.24a7.2 7.2 0 0 0-1.144.414c-1.592.734-3.205 2.503-3.22 4.8v3.273c0 2.323-.82 4.316-2.438 5.924a.364.364 0 0 0 .194.617l3.452.596c.643.11 1.235.202 1.798.277C9.306 21.202 10.552 22 11.913 22c1.362 0 2.609-.799 3.243-2.043.561-.074 1.15-.165 1.79-.276l3.45-.596a.364.364 0 0 0 .195-.616zM10.756 3.817c0-.601.49-1.09 1.09-1.09.602 0 1.092.489 1.092 1.09v.066a7.23 7.23 0 0 0-2.182.017v-.083zm1.157 17.455c-.92 0-1.78-.458-2.333-1.206.813.084 1.571.126 2.33.126.76 0 1.522-.042 2.338-.127-.553.749-1.414 1.207-2.335 1.207zm4.909-2.308c-.698.12-1.338.218-1.942.295h-.002c-.266.034-.525.063-.779.089h-.008c-.231.024-.458.042-.682.059l-.127.008c-.194.013-.386.023-.577.03l-.118.005a20.15 20.15 0 0 1-2.177-.043 25.242 25.242 0 0 1-1.46-.147h-.004a44.16 44.16 0 0 1-1.95-.296l-2.785-.481c1.448-1.656 2.181-3.65 2.181-5.939v-3.27C6.405 7.299 7.806 5.77 9.19 5.133a6.5 6.5 0 0 1 1.272-.43c.003-.001.007 0 .011-.002a6.611 6.611 0 0 1 2.756-.024h.015c.474.098.94.248 1.39.454 1.342.613 2.69 2.13 2.677 4.142v3.273c0 2.194.791 4.234 2.296 5.938l-2.784.48z"], ["d", "M14.18 6.123c-1.409-.644-3.134-.645-4.534 0-.798.369-2.152 1.445-2.163 3.148 0 .2.16.364.362.365h.002c.2 0 .362-.16.364-.361.008-1.337 1.097-2.195 1.74-2.491 1.21-.559 2.707-.557 3.926 0a.364.364 0 0 0 .303-.661z"], ["id", "notification-small", "viewBox", "0 0 24 24"], ["fill", "#000", "fill-opacity", ".5", "fill-rule", "evenodd", "stroke", "#212121", "stroke-width", ".2"]], template: function SvgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelementStart(1, "symbol", 1);
        ɵngcc0.ɵɵelementStart(2, "g", 2);
        ɵngcc0.ɵɵelementStart(3, "g", 3);
        ɵngcc0.ɵɵelementStart(4, "g", 4);
        ɵngcc0.ɵɵelement(5, "polygon", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "g", 6);
        ɵngcc0.ɵɵelement(7, "polygon", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "g", 8);
        ɵngcc0.ɵɵelement(9, "polygon", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "g", 10);
        ɵngcc0.ɵɵelement(11, "polygon", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "g", 12);
        ɵngcc0.ɵɵelement(13, "polygon", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "g", 14);
        ɵngcc0.ɵɵelementStart(15, "g", 15);
        ɵngcc0.ɵɵelementStart(16, "g", 16);
        ɵngcc0.ɵɵelementStart(17, "g", 17);
        ɵngcc0.ɵɵelement(18, "path", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "g", 19);
        ɵngcc0.ɵɵelement(20, "path", 20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "symbol", 21);
        ɵngcc0.ɵɵelementStart(22, "g", 22);
        ɵngcc0.ɵɵelement(23, "path", 23);
        ɵngcc0.ɵɵelement(24, "path", 24);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "symbol", 25);
        ɵngcc0.ɵɵelementStart(26, "g", 26);
        ɵngcc0.ɵɵelementStart(27, "g", 27);
        ɵngcc0.ɵɵelementStart(28, "g", 28);
        ɵngcc0.ɵɵelement(29, "path", 29);
        ɵngcc0.ɵɵelement(30, "path", 30);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "symbol", 31);
        ɵngcc0.ɵɵelement(32, "path", 32);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "symbol", 33);
        ɵngcc0.ɵɵelementStart(34, "defs");
        ɵngcc0.ɵɵelement(35, "circle", 34);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "g", 35);
        ɵngcc0.ɵɵelementStart(37, "g", 36);
        ɵngcc0.ɵɵelementStart(38, "g", 37);
        ɵngcc0.ɵɵelementStart(39, "mask", 38);
        ɵngcc0.ɵɵelement(40, "use", 39);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(41, "use", 40);
        ɵngcc0.ɵɵelement(42, "path", 41);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "symbol", 42);
        ɵngcc0.ɵɵelementStart(44, "g", 43);
        ɵngcc0.ɵɵelement(45, "path", 44);
        ɵngcc0.ɵɵelement(46, "path", 45);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "symbol", 46);
        ɵngcc0.ɵɵelementStart(48, "g", 47);
        ɵngcc0.ɵɵelement(49, "path", 48);
        ɵngcc0.ɵɵelement(50, "path", 49);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "symbol", 50);
        ɵngcc0.ɵɵelementStart(52, "g", 51);
        ɵngcc0.ɵɵelement(53, "path", 48);
        ɵngcc0.ɵɵelement(54, "path", 49);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
SvgComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgComponent, [{
        type: Component,
        args: [{
                selector: 'app-svg',
                template: "<svg style=\"display: none\">\n  <!-- Logo -->\n  <symbol id=\"logo\" viewBox=\"0 0 1984 1984\">\n    <g id=\"PIK_Logo_Color_RGB\" transform=\"translate(-2.000000, 0.000000)\" fill-rule=\"nonzero\">\n      <g id=\"g10\" transform=\"translate(993.500000, 993.000000) scale(-1, 1) rotate(-180.000000) translate(-993.500000, -993.000000) translate(-0.000000, 0.000000)\">\n        <g id=\"g12\" transform=\"translate(0.669821, 1265.997277)\" fill=\"#0A055F\">\n          <polygon id=\"path14\" points=\"993.333308 719.999982 1.33066663 216.002661 1.33066663 0.0026666666 993.333308 503.999987 1985.33062 0.0026666666 1985.33062 216.002661\"></polygon>\n        </g>\n        <g id=\"g16\" transform=\"translate(1.999955, 562.002628)\" fill=\"#0A055F\">\n          <polygon id=\"path18\" points=\"167.999996 487.999988 407.997323 487.999988 407.997323 0 575.997319 0 575.997319 639.999984 0 639.999984 0 0 167.999996 0\"></polygon>\n        </g>\n        <g id=\"g20\" transform=\"translate(658.000605, 562.002628)\" fill=\"#0A055F\">\n          <polygon id=\"path22\" points=\"0 639.999984 0 0 255.999994 0 471.999988 508.234654 471.999988 0 639.999984 0 639.999984 639.999984 383.99999 639.999984 167.999996 131.76533 167.999996 639.999984\"></polygon>\n        </g>\n        <g id=\"g24\" transform=\"translate(1378.000587, 562.002628)\" fill=\"#0A055F\">\n          <polygon id=\"path26\" points=\"0 639.999984 0 0 167.999996 0 167.999996 205.334662 217.398661 254.13466 407.997323 0 607.997318 0 332.281325 367.625324 607.997318 639.999984 391.997324 639.999984 167.999996 400.001323 167.999996 639.999984\"></polygon>\n        </g>\n        <g id=\"g28\" transform=\"translate(1663.333247, 217.366503)\" fill=\"#FF4114\">\n          <polygon id=\"path30\" points=\"38.6666657 113.333331 0.54933332 0.637333317 76.7839981 0.637333317\"></polygon>\n        </g>\n        <g id=\"g32\" transform=\"translate(2.000000, 0.000000)\" fill=\"#FF4114\">\n          <g id=\"g34-Clipped\" transform=\"translate(-0.000000, 0.000000)\">\n            <g id=\"g34\" transform=\"translate(-0.000045, 0.666642)\">\n              <g id=\"g40\" transform=\"translate(0.000000, 0.003867)\">\n                <path d=\"M167.999996,377.333324 L375.999991,377.333324 L375.999991,318.666659 L231.999994,318.666659 L231.999994,105.333331 L167.999996,105.333331 L167.999996,377.333324 Z M415.99999,377.333324 L555.999986,377.333324 C608.726651,377.333324 651.999984,347.798658 651.999984,287.333326 C651.999984,226.869328 608.726651,197.333328 555.999986,197.333328 L479.999988,197.333328 L479.999988,105.333331 L415.99999,105.333331 L415.99999,377.333324 Z M727.999982,377.333324 L793.99998,259.227994 L859.999978,377.333324 L927.999977,377.333324 L775.999981,105.333331 L707.999982,105.333331 L760.169314,198.689328 L653.333317,377.333324 L727.999982,377.333324 Z M959.999976,377.333324 L1207.99997,377.333324 L1207.99997,105.333331 L1143.99997,105.333331 L1143.99997,318.666659 L1023.99997,318.666659 L1023.99997,105.333331 L959.999976,105.333331 L959.999976,377.333324 Z M1263.99997,377.333324 L1511.99996,377.333324 L1511.99996,105.333331 L1447.99996,105.333331 L1447.99996,318.666659 L1327.99997,318.666659 L1327.99997,105.333331 L1263.99997,105.333331 L1263.99997,377.333324 Z M1655.99996,377.333324 L1743.99996,377.333324 L1843.99995,105.333331 L1775.99996,105.333331 L1757.05862,161.333329 L1642.94129,161.333329 L1623.99996,105.333331 L1555.99996,105.333331 L1655.99996,377.333324 Z M0,1.33199997 L1983.99995,1.33199997 L1983.99995,481.331988 L0,481.331988 L0,1.33199997 Z\"\n                  id=\"path42\"></path>\n              </g>\n              <g id=\"g44\" transform=\"translate(479.999988, 252.670527)\">\n                <path d=\"M108,34.6666667 C108,58.22 91.2973333,68.6666666 70.6666667,68.6666666 L0,68.6666666 L0,0.66666665 L70.6666667,0.66666665 C91.2973333,0.66666665 108,11.1133333 108,34.6666667\"\n                  id=\"path46\"></path>\n              </g>\n            </g>\n          </g>\n        </g>\n      </g>\n    </g>\n  </symbol>\n\n  <!-- Search icon -->\n  <symbol id=\"search-icon\" viewBox=\"0 0 28 28\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n      <path d=\"M-1604-31H316v90h-1920z\" />\n      <path fill=\"#EF4E23\" stroke=\"#EF4E23\" stroke-width=\"2\" d=\"M25.869 26.2l-6.993-7.293a9.896 9.896 0 0 0 2.889-6.995C21.765 6.446 17.332 2 11.882 2 6.433 2 2 6.446 2 11.912c0 5.466 4.433 9.912 9.882 9.912a9.819 9.819 0 0 0 6.299-2.28l7.01 7.311a.466.466 0 0 0 .665.013.473.473 0 0 0 .013-.667zm-13.987-5.32c-4.93 0-8.94-4.023-8.94-8.968s4.01-8.968 8.94-8.968 8.942 4.023 8.942 8.968-4.012 8.968-8.942 8.968z\"\n      />\n    </g>\n  </symbol>\n\n  <!-- Exit icon -->\n  <symbol id=\"exit-icon\" viewBox=\"0 0 23 28\">\n    <g transform=\"translate(-1869.000000, -32.000000)\" fill-rule=\"nonzero\" fill=\"#757575\">\n      <g id=\"Exit\" transform=\"translate(1864.000000, 30.000000)\">\n        <g id=\"Group\" transform=\"translate(5.333333, 2.666667)\">\n          <path d=\"M17.3902261,18.2492195 C17.1898468,18.2492195 16.9890591,18.1727206 16.8360029,18.0196645 C16.5303574,17.7137856 16.5303574,17.2175638 16.8360029,16.9116849 L19.6441138,14.1039825 L8.46220277,14.1039825 C8.0296426,14.1039825 7.67865791,13.7532312 7.67865791,13.3204376 C7.67865791,12.8876441 8.0296426,12.5368928 8.46220277,12.5368928 L19.5976076,12.5368928 L16.8315098,9.7246973 C16.529132,9.41700948 16.5319912,8.92259664 16.8384537,8.61876003 C17.1440992,8.31515682 17.6387454,8.31556528 17.944391,8.6212108 L22.0898614,12.7665062 C22.2367907,12.9134354 22.3192414,13.1127644 22.3192414,13.320496 C22.3192414,13.5282276 22.2367907,13.7275565 22.0898614,13.8744858 L17.944391,18.0197812 C17.7913348,18.1726623 17.590547,18.2492195 17.3902261,18.2492195 Z\"\n            id=\"Shape\"></path>\n          <path d=\"M16.0140627,26.6407586 L0.787045952,26.6407586 C0.354485777,26.6407586 0.00350109409,26.2900073 0.00350109409,25.8572137 L0.00350109409,0.783544858 C0.00350109409,0.350751276 0.354485777,0 0.787045952,0 L16.0140627,0 C16.4466229,0 16.7976076,0.350751276 16.7976076,0.783544858 L16.7976076,2.87183078 C16.7976076,3.30462436 16.4466229,3.65537564 16.0140627,3.65537564 C15.5815026,3.65537564 15.2305179,3.30462436 15.2305179,2.87183078 L15.2305179,1.56708972 L1.57059081,1.56708972 L1.57059081,25.0736689 L15.2305179,25.0736689 L15.2305179,23.7689278 C15.2305179,23.3361342 15.5815026,22.9853829 16.0140627,22.9853829 C16.4466229,22.9853829 16.7976076,23.3361342 16.7976076,23.7689278 L16.7976076,25.8572137 C16.7976659,26.2900073 16.4466813,26.6407586 16.0140627,26.6407586 Z\"\n            id=\"Shape\"></path>\n        </g>\n      </g>\n    </g>\n  </symbol>\n\n  <!-- Cross -->\n  <symbol id=\"cross-icon\" viewBox=\"0 0 24 24\">\n    <path fill=\"#A1A1A1\" fill-rule=\"evenodd\" d=\"M20 4.914L19.086 4 12 11.086 4.914 4 4 4.914 11.086 12 4 19.086l.914.914L12 12.914 19.086 20l.914-.914L12.914 12z\"\n    />\n  </symbol>\n\n  <!-- User -->\n  <symbol id=\"user\" viewBox=\"0 0 200 200\">\n    <defs>\n      <circle id=\"path-1\" cx=\"100\" cy=\"100\" r=\"100\"></circle>\n    </defs>\n    <g id=\"1422\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n      <g id=\"#1422-3)\u0437\u0430\u0433\u043B\u0443\u0448\u043A\u0443-\u0444\u043E\u0442\u043E-\u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\" transform=\"translate(-519.000000, -248.000000)\">\n        <g id=\"\u0417\u0430\u0433\u043B\u0443\u0448\u043A\u0430\" transform=\"translate(519.000000, 248.000000)\">\n          <mask id=\"mask-2\" fill=\"white\">\n            <use xlink:href=\"#path-1\"></use>\n          </mask>\n          <use id=\"\u041F\u043E\u0440\u0442\u0440\u0435\u0442\" fill=\"#FFFFFF\" xlink:href=\"#path-1\"></use>\n          <path d=\"M100.300823,202.988033 C129.814105,202.988033 156.484813,190.777917 175.601646,171.116879 C164.257672,149.310077 148.16976,144.839735 148.16976,144.839735 L138.595551,144.839735 C128.020125,144.839735 119.448187,136.222821 119.448187,125.595576 L119.448187,119.414337 C123.683621,114.353593 126.722017,108.369155 128.610749,102.044018 C128.805518,100.977485 129.827791,100.450566 130.510009,99.7173245 C134.174823,96.0352444 134.895994,89.819089 132.145015,85.3931864 C131.772322,84.7223707 131.096421,84.1383166 131.133269,83.3066743 C131.133269,77.6639924 131.162748,72.0117878 131.126953,66.3743961 C130.977454,59.5678383 129.042399,52.4861824 124.292143,47.4455417 C120.45888,43.3730342 115.193802,40.9489981 109.763434,39.9110324 C102.900198,38.5947946 95.7200686,38.6603948 88.9221068,40.3988022 C83.031663,41.8927956 77.4981201,45.3600877 74.0765039,50.5001869 C71.0454784,54.9684123 69.7178913,60.3931321 69.4936438,65.7406128 C69.4094194,71.4816952 69.4757461,77.2365325 69.4578485,82.9913698 C69.5873435,84.1436069 68.6166573,84.9234038 68.1765848,85.8767239 C65.5856318,90.5988859 66.7268724,97.0308873 70.8875576,100.465379 C71.9424682,101.196505 72.1414483,102.531788 72.5236166,103.684025 C74.3386523,109.367972 77.3475689,114.624459 81.1534589,119.205897 L81.1534589,125.595576 C81.1534589,136.222821 72.580468,144.839735 62.0060949,144.839735 L52.4308336,144.839735 C52.4308336,144.839735 36.3439736,149.30796 25,171.115821 C44.1157799,190.777917 70.7875411,202.988033 100.300823,202.988033 Z\"\n            id=\"Stroke-3\" stroke=\"#D6D6D6\" stroke-width=\"3\" mask=\"url(#mask-2)\"></path>\n        </g>\n      </g>\n    </g>\n  </symbol>\n\n  <!-- Picoin -->\n  <symbol id=\"picoin\" viewBox=\"0 0 24 24\">\n    <g fill=\"#A1A1A1\" fill-rule=\"evenodd\">\n      <path fill-rule=\"nonzero\" d=\"M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-.86a9.14 9.14 0 1 0 0-18.28 9.14 9.14 0 0 0 0 18.28z\"\n      />\n      <path d=\"M12.018 5L6 8.37v1.445l6.018-3.371 6.019 3.37V8.37zM6 17.037h12.037v-1.204H6zM6 10.417v4.213h1.023v-3.311h1.565v3.31h1.023v-4.212zM10.213 10.417v4.213h1.264l1.324-3.01v3.01h1.023v-4.213H12.56l-1.324 3.009v-3.01zM16.833 10.417l-1.383 1.565v-1.565h-1.024v4.213h1.024v-1.445l.296-.317 1.148 1.762h1.143l-1.617-2.483 1.617-1.73z\"\n      />\n    </g>\n  </symbol>\n\n  <!-- Notification icon -->\n  <symbol id=\"notification\" viewBox=\"0 0 24 24\">\n    <g fill=\"#000\" fill-opacity=\".87\" fill-rule=\"evenodd\" stroke=\"#212121\" stroke-width=\".2\">\n      <path d=\"M20.591 18.47c-1.694-1.685-2.553-3.678-2.553-5.925v-3.27c.015-2.494-1.661-4.147-3.102-4.806a7.31 7.31 0 0 0-1.27-.442v-.209A1.82 1.82 0 0 0 11.846 2a1.82 1.82 0 0 0-1.818 1.818v.24a7.2 7.2 0 0 0-1.144.414c-1.592.734-3.205 2.503-3.22 4.8v3.273c0 2.323-.82 4.316-2.438 5.924a.364.364 0 0 0 .194.617l3.452.596c.643.11 1.235.202 1.798.277C9.306 21.202 10.552 22 11.913 22c1.362 0 2.609-.799 3.243-2.043.561-.074 1.15-.165 1.79-.276l3.45-.596a.364.364 0 0 0 .195-.616zM10.756 3.817c0-.601.49-1.09 1.09-1.09.602 0 1.092.489 1.092 1.09v.066a7.23 7.23 0 0 0-2.182.017v-.083zm1.157 17.455c-.92 0-1.78-.458-2.333-1.206.813.084 1.571.126 2.33.126.76 0 1.522-.042 2.338-.127-.553.749-1.414 1.207-2.335 1.207zm4.909-2.308c-.698.12-1.338.218-1.942.295h-.002c-.266.034-.525.063-.779.089h-.008c-.231.024-.458.042-.682.059l-.127.008c-.194.013-.386.023-.577.03l-.118.005a20.15 20.15 0 0 1-2.177-.043 25.242 25.242 0 0 1-1.46-.147h-.004a44.16 44.16 0 0 1-1.95-.296l-2.785-.481c1.448-1.656 2.181-3.65 2.181-5.939v-3.27C6.405 7.299 7.806 5.77 9.19 5.133a6.5 6.5 0 0 1 1.272-.43c.003-.001.007 0 .011-.002a6.611 6.611 0 0 1 2.756-.024h.015c.474.098.94.248 1.39.454 1.342.613 2.69 2.13 2.677 4.142v3.273c0 2.194.791 4.234 2.296 5.938l-2.784.48z\"\n      />\n      <path d=\"M14.18 6.123c-1.409-.644-3.134-.645-4.534 0-.798.369-2.152 1.445-2.163 3.148 0 .2.16.364.362.365h.002c.2 0 .362-.16.364-.361.008-1.337 1.097-2.195 1.74-2.491 1.21-.559 2.707-.557 3.926 0a.364.364 0 0 0 .303-.661z\"\n      />\n    </g>\n  </symbol>\n\n  <!-- Notification small icon -->\n  <symbol id=\"notification-small\" viewBox=\"0 0 24 24\">\n    <g fill=\"#000\" fill-opacity=\".5\" fill-rule=\"evenodd\" stroke=\"#212121\" stroke-width=\".2\">\n      <path d=\"M20.591 18.47c-1.694-1.685-2.553-3.678-2.553-5.925v-3.27c.015-2.494-1.661-4.147-3.102-4.806a7.31 7.31 0 0 0-1.27-.442v-.209A1.82 1.82 0 0 0 11.846 2a1.82 1.82 0 0 0-1.818 1.818v.24a7.2 7.2 0 0 0-1.144.414c-1.592.734-3.205 2.503-3.22 4.8v3.273c0 2.323-.82 4.316-2.438 5.924a.364.364 0 0 0 .194.617l3.452.596c.643.11 1.235.202 1.798.277C9.306 21.202 10.552 22 11.913 22c1.362 0 2.609-.799 3.243-2.043.561-.074 1.15-.165 1.79-.276l3.45-.596a.364.364 0 0 0 .195-.616zM10.756 3.817c0-.601.49-1.09 1.09-1.09.602 0 1.092.489 1.092 1.09v.066a7.23 7.23 0 0 0-2.182.017v-.083zm1.157 17.455c-.92 0-1.78-.458-2.333-1.206.813.084 1.571.126 2.33.126.76 0 1.522-.042 2.338-.127-.553.749-1.414 1.207-2.335 1.207zm4.909-2.308c-.698.12-1.338.218-1.942.295h-.002c-.266.034-.525.063-.779.089h-.008c-.231.024-.458.042-.682.059l-.127.008c-.194.013-.386.023-.577.03l-.118.005a20.15 20.15 0 0 1-2.177-.043 25.242 25.242 0 0 1-1.46-.147h-.004a44.16 44.16 0 0 1-1.95-.296l-2.785-.481c1.448-1.656 2.181-3.65 2.181-5.939v-3.27C6.405 7.299 7.806 5.77 9.19 5.133a6.5 6.5 0 0 1 1.272-.43c.003-.001.007 0 .011-.002a6.611 6.611 0 0 1 2.756-.024h.015c.474.098.94.248 1.39.454 1.342.613 2.69 2.13 2.677 4.142v3.273c0 2.194.791 4.234 2.296 5.938l-2.784.48z\"\n      />\n      <path d=\"M14.18 6.123c-1.409-.644-3.134-.645-4.534 0-.798.369-2.152 1.445-2.163 3.148 0 .2.16.364.362.365h.002c.2 0 .362-.16.364-.361.008-1.337 1.097-2.195 1.74-2.491 1.21-.559 2.707-.557 3.926 0a.364.364 0 0 0 .303-.661z\"\n      />\n    </g>\n  </symbol>\n\n</svg>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

class NotificationsComponent {
    constructor() {
        this.hideNotification = new EventEmitter();
    }
    hide(id) {
        this.hideNotification.emit(id);
    }
}
NotificationsComponent.ɵfac = function NotificationsComponent_Factory(t) { return new (t || NotificationsComponent)(); };
NotificationsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationsComponent, selectors: [["app-notifications"]], inputs: { notification: "notification" }, outputs: { hideNotification: "hideNotification" }, decls: 7, vars: 7, consts: [[3, "ngSwitch"], ["class", "notification", 4, "ngSwitchCase"], [1, "notification"], [1, "notification__inner"], [1, "notification__icon"], ["width", "22", "height", "22", 4, "ngIf"], ["alt", "", 3, "src", 4, "ngIf"], [1, "notification__info"], [1, "notification__title"], [1, "notification__date"], ["width", "22", "height", "22", "class", "notification__close", 3, "click", 4, "ngIf"], ["width", "22", "height", "22"], [0, "xlink", "href", "#notification-small"], ["alt", "", 3, "src"], ["width", "22", "height", "22", 1, "notification__close", 3, "click"], [0, "xlink", "href", "#cross-icon"], ["target", "_blank", 1, "notification__inner"], [1, "notification__html", 3, "innerHTML"]], template: function NotificationsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, NotificationsComponent_div_1_Template, 12, 11, "div", 1);
        ɵngcc0.ɵɵtemplate(2, NotificationsComponent_div_2_Template, 12, 11, "div", 1);
        ɵngcc0.ɵɵtemplate(3, NotificationsComponent_div_3_Template, 12, 10, "div", 1);
        ɵngcc0.ɵɵtemplate(4, NotificationsComponent_div_4_Template, 12, 10, "div", 1);
        ɵngcc0.ɵɵtemplate(5, NotificationsComponent_div_5_Template, 12, 10, "div", 1);
        ɵngcc0.ɵɵtemplate(6, NotificationsComponent_div_6_Template, 13, 9, "div", 1);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.notification == null ? null : ctx.notification.typeInternalName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "link");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "external-link");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "Thanks");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "text");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "banner");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "info_pik");
    } }, directives: [ɵngcc5.NgSwitch, ɵngcc5.NgSwitchCase, ɵngcc5.NgIf], pipes: [ɵngcc5.DatePipe], styles: [".notification[_ngcontent-%COMP%]{position:relative;transition:all .2s}.notification[_ngcontent-%COMP%]:active, .notification[_ngcontent-%COMP%]:focus, .notification[_ngcontent-%COMP%]:hover{background-color:#f5f5f5}.notification[_ngcontent-%COMP%]:active   .notification__close[_ngcontent-%COMP%], .notification[_ngcontent-%COMP%]:focus   .notification__close[_ngcontent-%COMP%], .notification[_ngcontent-%COMP%]:hover   .notification__close[_ngcontent-%COMP%]{opacity:1}.notification__inner[_ngcontent-%COMP%]{display:inline-flex;width:100%;padding:1rem 1rem 1rem 1.25rem;color:inherit;text-decoration:none}.notification__icon[_ngcontent-%COMP%]{position:relative;flex:0 0 auto;width:2rem;height:2rem;margin-right:1rem;background:#f5f5f5;border-radius:10rem}.notification__icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], .notification__icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;max-width:2rem;max-height:2rem;transform:translate(-50%,-50%)}.notification__info[_ngcontent-%COMP%]{display:flex;flex-flow:column nowrap}.notification__title[_ngcontent-%COMP%]{margin-right:30px;color:#212121;line-height:1.25;white-space:normal}.notification__html[_ngcontent-%COMP%]{white-space:normal}.notification__date[_ngcontent-%COMP%]{font-size:.875rem;color:#757575}.notification__close[_ngcontent-%COMP%]{position:absolute;right:1rem;top:1rem;opacity:0;transition:.2s;cursor:pointer}"] });
NotificationsComponent.propDecorators = {
    notification: [{ type: Input }],
    hideNotification: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationsComponent, [{
        type: Component,
        args: [{
                selector: 'app-notifications',
                template: "<ng-container [ngSwitch]=\"notification?.typeInternalName\">\n  <!-- \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0441\u0441\u044B\u043B\u043A\u0430 -->\n  <div *ngSwitchCase=\"'link'\" class=\"notification\">\n    <a [attr.href]=\"notification.value\" class=\"notification__inner\">\n      <div class=\"notification__icon\">\n\n        <svg *ngIf=\"!notification.pictureUrl\" width=\"22\" height=\"22\">\n          <use xlink:href=\"#notification-small\"></use>\n        </svg>\n\n        <img *ngIf=\"notification.pictureUrl\" [src]=\"notification.pictureUrl\" alt=\"\">\n      </div>\n      <div class=\"notification__info\">\n        <div class=\"notification__title\">{{notification.name}}</div>\n        <!-- \u041D\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B -->\n        <div class=\"notification__date\">{{(notification.created + 'Z') | date:'short':'timezone':'ru-RU'}}</div>\n      </div>\n    </a>\n    <svg *ngIf=\"notification.fixed !== true\" width=\"22\" height=\"22\" class=\"notification__close\"\n      (click)=\"hide(notification.id)\">\n      <use xlink:href=\"#cross-icon\"></use>\n    </svg>\n  </div>\n\n  <!-- \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0432\u043D\u0435\u0448\u043D\u044F\u044F \u0441\u0441\u044B\u043B\u043A\u0430 -->\n  <div *ngSwitchCase=\"'external-link'\" class=\"notification\">\n    <a [attr.href]=\"notification.value\" target=\"_blank\" class=\"notification__inner\">\n      <div class=\"notification__icon\">\n\n        <svg *ngIf=\"!notification.pictureUrl\" width=\"22\" height=\"22\">\n          <use xlink:href=\"#notification-small\"></use>\n        </svg>\n\n        <img *ngIf=\"notification.pictureUrl\" [src]=\"notification.pictureUrl\" alt=\"\">\n      </div>\n      <div class=\"notification__info\">\n        <div class=\"notification__title\">{{notification.name}}</div>\n        <!-- \u041D\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B -->\n        <div class=\"notification__date\">{{(notification.created + 'Z') | date:'short':'timezone':'ru-RU'}}</div>\n      </div>\n    </a>\n    <svg *ngIf=\"notification.fixed !== true\" width=\"22\" height=\"22\" class=\"notification__close\"\n      (click)=\"hide(notification.id)\">\n      <use xlink:href=\"#cross-icon\"></use>\n    </svg>\n  </div>\n\n  <!-- \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043E \u0441\u043F\u0430\u0441\u0438\u0431\u043E \u0423\u0417\u041D\u0410\u0422\u042C \u0423 \u0412\u0418\u041A\u0418 \u041E \u0422\u041E\u041C, \u041A\u0410\u041A \u0414\u041E\u041B\u0416\u0415\u041D \u0412\u042B\u0413\u041B\u042F\u0414\u0415\u0422\u042C-->\n  <div *ngSwitchCase=\"'Thanks'\" class=\"notification\">\n    <div class=\"notification__inner\">\n      <div class=\"notification__icon\">\n        <svg *ngIf=\"!notification.pictureUrl\" width=\"22\" height=\"22\">\n          <use xlink:href=\"#notification-small\"></use>\n        </svg>\n        <img *ngIf=\"notification.pictureUrl\" [src]=\"notification.pictureUrl\" alt=\"\">\n      </div>\n      <div class=\"notification__info\">\n        <div class=\"notification__title\">{{notification.value}}</div>\n        <!-- \u041D\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B -->\n        <div class=\"notification__date\">{{(notification.created + 'Z') | date:'short':'timezone':'ru-RU'}}</div>\n      </div>\n    </div>\n\n    <svg *ngIf=\"notification.fixed !== true\" width=\"22\" height=\"22\" class=\"notification__close\"\n    (click)=\"hide(notification.id)\">\n    <use xlink:href=\"#cross-icon\"></use>\n  </svg>\n  </div>\n\n  <!-- \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442 -->\n  <div *ngSwitchCase=\"'text'\" class=\"notification\">\n    <div class=\"notification__inner\">\n      <div class=\"notification__icon\">\n\n        <svg *ngIf=\"!notification.pictureUrl\" width=\"22\" height=\"22\">\n          <use xlink:href=\"#notification-small\"></use>\n        </svg>\n\n        <img *ngIf=\"notification.pictureUrl\" [src]=\"notification.pictureUrl\" alt=\"\">\n      </div>\n      <div class=\"notification__info\">\n        <div class=\"notification__title\">{{notification.value}}</div>\n        <!-- \u041D\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B -->\n        <div class=\"notification__date\">{{(notification.created + 'Z') | date:'short':'timezone':'ru-RU'}}</div>\n      </div>\n    </div>\n\n    <svg *ngIf=\"notification.fixed !== true\" width=\"22\" height=\"22\" class=\"notification__close\"\n      (click)=\"hide(notification.id)\">\n      <use xlink:href=\"#cross-icon\"></use>\n    </svg>\n  </div>\n\n  <!-- \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043D\u0435\u0440 -->\n  <div *ngSwitchCase=\"'banner'\" class=\"notification\">\n    <div class=\"notification__inner\">\n      <div class=\"notification__icon\">\n\n        <svg *ngIf=\"!notification.pictureUrl\" width=\"22\" height=\"22\">\n          <use xlink:href=\"#notification-small\"></use>\n        </svg>\n\n        <img *ngIf=\"notification.pictureUrl\" [src]=\"notification.pictureUrl\" alt=\"\">\n      </div>\n      <div class=\"notification__info\">\n        <div class=\"notification__title\">{{notification.name}}</div>\n        <!-- \u041D\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B -->\n        <div class=\"notification__date\">{{(notification.created + 'Z') | date:'short':'timezone':'ru-RU'}}</div>\n      </div>\n    </div>\n\n    <svg *ngIf=\"notification.fixed !== true\" width=\"22\" height=\"22\" class=\"notification__close\"\n      (click)=\"hide(notification.id)\">\n      <use xlink:href=\"#cross-icon\"></use>\n    </svg>\n  </div>\n\n  <!-- \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043D\u0435\u0440 -->\n  <div *ngSwitchCase=\"'info_pik'\" class=\"notification\">\n    <div class=\"notification__inner\">\n      <div class=\"notification__icon\">\n        <svg width=\"22\" height=\"22\">\n          <use xlink:href=\"#notification-small\"></use>\n        </svg>\n      </div>\n      <div class=\"notification__info\">\n        <div class=\"notification__title\">{{notification.name}}</div>\n        <div class=\"notification__date\">{{(notification.created + 'Z') | date:'short':'timezone':'ru-RU'}}</div>\n        <div class=\"notification__html\" [innerHTML]=\"notification.value\"></div>\n      </div>\n    </div>\n\n    <svg *ngIf=\"notification.fixed !== true\" width=\"22\" height=\"22\" class=\"notification__close\"\n      (click)=\"hide(notification.id)\">\n      <use xlink:href=\"#cross-icon\"></use>\n    </svg>\n  </div>\n</ng-container>\n",
                styles: [".notification{position:relative;transition:all .2s}.notification:active,.notification:focus,.notification:hover{background-color:#f5f5f5}.notification:active .notification__close,.notification:focus .notification__close,.notification:hover .notification__close{opacity:1}.notification__inner{display:inline-flex;width:100%;padding:1rem 1rem 1rem 1.25rem;color:inherit;text-decoration:none}.notification__icon{position:relative;flex:0 0 auto;width:2rem;height:2rem;margin-right:1rem;background:#f5f5f5;border-radius:10rem}.notification__icon img,.notification__icon svg{position:absolute;top:50%;left:50%;max-width:2rem;max-height:2rem;transform:translate(-50%,-50%)}.notification__info{display:flex;flex-flow:column nowrap}.notification__title{margin-right:30px;color:#212121;line-height:1.25;white-space:normal}.notification__html{white-space:normal}.notification__date{font-size:.875rem;color:#757575}.notification__close{position:absolute;right:1rem;top:1rem;opacity:0;transition:.2s;cursor:pointer}"]
            }]
    }], function () { return []; }, { hideNotification: [{
            type: Output
        }], notification: [{
            type: Input
        }] }); })();

/**
 * Отображение результатов поиска
 *
 * @export
 * @class SearchResultComponent
 */
class SearchResultComponent extends BaseSearchComponent {
    constructor(employeeService, unitService, router, auth, searchService, locator) {
        super();
        this.employeeService = employeeService;
        this.unitService = unitService;
        this.router = router;
        this.auth = auth;
        this.searchService = searchService;
        this.locator = locator;
        this.destroyed$ = new Subject();
        this.checkCategoryOrder();
    }
    set setKeyword(keyword) {
        this.keyword = keyword;
        this.checkQuery(this.keyword);
    }
    ngOnInit() {
        this.router.events.pipe(filter((e) => e instanceof NavigationEnd), takeUntil(this.destroyed$))
            .subscribe((n) => {
            this.checkCategoryOrder();
        });
    }
    /**
     * Выводим информацию о количестве найденного в категории
     *
     * @returns
     * @memberof SearchResultComponent
     */
    getCountText(data) {
        if (data.count < this.limit) {
            return data.count;
        }
        else {
            return `${data.items.length} из ${data.count}`;
        }
    }
    /**
     * Проверим порядок вывода результатов в зависимости от текущего раздела сайта
     *
     * @protected
     * @memberof SearchResultComponent
     */
    checkCategoryOrder() {
        const urlReg = /^(?:https?:\/\/)?(?:www\.)?/i;
        const url = window.location.href.replace(urlReg, '');
        this.categoryOrder = { news: 2, employee: 2, unit: 2, pages: 2 };
        if (url && url.length > 0) {
            if (url.includes(Helpers.concatUrls(this.locator.urls.homeUrl.replace(urlReg, ''), '/news'))) {
                this.categoryOrder.news = 1;
            }
            else if (url.includes(this.locator.urls.infoUrl.replace(urlReg, ''))) {
                this.categoryOrder.pages = 1;
            }
        }
    }
    /**
     * Получить ссылку на новость
     *
     * @param news
     * @returns
     * @memberof SearchResultComponent
     */
    getNewsUrl(news) {
        return Helpers.concatUrls(this.locator.urls.homeUrl, `/news/${news.id}`);
    }
    /**
     * Получить ссылку на страницу в Wiki
     */
    getPageUrl(page) {
        const url = page.spaceUrl ? `/spaces/${page.spaceUrl}/pages/${page.id}` : `/pages/${page.id}`;
        return Helpers.concatUrls(this.locator.urls.infoUrl, url);
    }
    /**
     * Выбор элемента
     *
     * @param event
     * @memberof SearchResultComponent
     */
    onKeyDown(event) {
        if (document.querySelectorAll('.search-pik-header-result__item').length) {
            const workItems = document.querySelectorAll('.search-pik-header-result__item');
            if (this.selectedItemIndex < workItems.length) {
                if (event.keyCode === 40 && this.selectedItemIndex < workItems.length - 1) {
                    workItems[this.selectedItemIndex + 1].focus();
                    this.selectedItemIndex++;
                }
                if (event.keyCode === 38 && this.selectedItemIndex > 0) {
                    workItems[this.selectedItemIndex - 1].focus();
                    this.selectedItemIndex--;
                }
            }
        }
    }
    getResultsSectionLink(resultType) {
        return Helpers.concatUrls(this.locator.urls.homeUrl, `/search?k=${this.query}&t=${resultType}`);
    }
    ngOnDestroy() {
        this.destroyed$.next();
    }
}
SearchResultComponent.ɵfac = function SearchResultComponent_Factory(t) { return new (t || SearchResultComponent)(ɵngcc0.ɵɵdirectiveInject(EmployeeService), ɵngcc0.ɵɵdirectiveInject(UnitService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(PikAuthService), ɵngcc0.ɵɵdirectiveInject(SearchService), ɵngcc0.ɵɵdirectiveInject(PikLocatorService)); };
SearchResultComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SearchResultComponent, selectors: [["app-search-pik-header-result"]], inputs: { setKeyword: "setKeyword", searchResults: "searchResults", limit: "limit", selectedItemIndex: "selectedItemIndex" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "search-pik-header-result", 3, "keydown", 4, "ngIf"], [1, "search-pik-header-result", 3, "keydown"], [3, "order", 4, "ngIf"], [4, "ngIf"], [1, "search-pik-header-result__title"], [3, "href"], [1, "search-pik-header-result__list"], ["class", "search-pik-header-result__item", 3, "href", 4, "ngFor", "ngForOf"], [1, "search-pik-header-result__item", 3, "href"], [1, "search-pik-header-result__user"], [1, "search-pik-header-result__user-photo"], [3, "employee", "cssClass"], [1, "search-pik-header-result__user--info"], [1, "search-pik-header-result__user--name", 3, "innerHTML"], ["class", "search-pik-header-result__user--position", 3, "innerHTML", 4, "ngIf"], [1, "search-pik-header-result__user--contacts"], [3, "innerHTML", 4, "ngIf"], ["class", "search-pik-header-result__user--birthday", 4, "ngIf"], [1, "search-pik-header-result__user--position", 3, "innerHTML"], [3, "innerHTML"], ["class", "search-pik-header-result__user--vacation", 4, "ngIf"], [1, "search-pik-header-result__user--vacation"], ["src", "data:image/png;base64,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", "alt", "", 1, "search-pik-header-result__icon"], ["src", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4gICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJub256ZXJvIj4gICAgICAgIDxwYXRoIGZpbGw9IiM4MDUzMzMiIGQ9Ik0yOS44NzEgMzAuNjlIMi4xM0EyLjEyOCAyLjEyOCAwIDAgMSAwIDI4LjU2VjEwLjE5OGMwLTEuMTc2Ljk1My0yLjEyOSAyLjEyOS0yLjEyOUgyOS44N2MxLjE3NiAwIDIuMTI5Ljk1MyAyLjEyOSAyLjEyOVYyOC41NmEyLjEyOCAyLjEyOCAwIDAgMS0yLjEyOSAyLjEyOXoiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNDQjgyNTIiIGQ9Ik01LjUxNyA2LjQxNGgzLjMxVjMwLjY5aC0zLjMxek0yMy4xNzIgNi40MTRoMy4zMVYzMC42OWgtMy4zMXoiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNCREMzQzciIGQ9Ik0xNiAyYTUuNTI0IDUuNTI0IDAgMCAwLTUuNTE3IDUuNTE3di41NTJoMi4yMDd2LS41NTJBMy4zMiAzLjMyIDAgMCAxIDE2IDQuMjA3YTMuMzIgMy4zMiAwIDAgMSAzLjMxIDMuMzF2LjU1MmgyLjIwN3YtLjU1MkE1LjUyNCA1LjUyNCAwIDAgMCAxNiAyeiIvPiAgICAgICAgPHBhdGggZmlsbD0iIzcxQzI4NSIgZD0iTTExLjY4MyAxOS42M2w0LjYyOCAxLjk1My0xLjMwMyAzLjA4Ni00LjYyNy0xLjk1M3oiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNFMTcwNUMiIGQ9Ik0xMi42OSAxNi44OTd2My4xNThsMy42MjMgMS41MjktLjM1LjgzaDUuMDAzdi01LjUxN3oiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNGMEM0MTkiIGQ9Ik0xOS42MTcgMTYuODk3bDEuMzQ5LS42My0xLjkxMi00LjA5My02LjE0IDIuODY3Ljg2NyAxLjg1NnoiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNFNEMwNUMiIGQ9Ik0zMiAxMS44NTR2LTEuNjU2YTIuMTI4IDIuMTI4IDAgMCAwLTIuMTI5LTIuMTI5aC0xLjY1NkE0LjY4OSA0LjY4OSAwIDAgMCAzMiAxMS44NTR6TTMyIDI4LjU2MXYtMS42NTZhNC42ODkgNC42ODkgMCAwIDAtMy43ODUgMy43ODVoMS42NTZBMi4xMjggMi4xMjggMCAwIDAgMzIgMjguNTZ6TTAgMTEuODU0YTQuNjg5IDQuNjg5IDAgMCAwIDMuNzg1LTMuNzg1SDIuMTI5QTIuMTI4IDIuMTI4IDAgMCAwIDAgMTAuMTk4djEuNjU2ek0wIDI2LjkwNXYxLjY1NmMwIDEuMTc2Ljk1MyAyLjEyOSAyLjEyOSAyLjEyOWgxLjY1NkE0LjY4OSA0LjY4OSAwIDAgMCAwIDI2LjkwNXoiLz4gICAgPC9nPjwvc3ZnPg==", "alt", "", 1, "search-pik-header-result__icon"], [1, "search-pik-header-result__user--birthday"], ["src", "data:image/png;base64,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", "alt", "", 1, "search-pik-header-result__icon"], [1, "search-pik-header-result__list--departments"], [1, "search-pik-header-result__list--news"], [1, "search-pik-header-result__news"], [1, "search-pik-header-result__news--info"], [1, "search-pik-header-result__news--title", 3, "innerHTML"], ["class", "search-pik-header-result__news--announce", 3, "innerHTML", 4, "ngIf"], [1, "search-pik-header-result__news--announce", 3, "innerHTML"], [1, "search-pik-header-result__list--pages"], [1, "search-pik-header-result__page"], [1, "search-pik-header-result__page--info"], [1, "search-pik-header-result__page--title", 3, "innerHTML"], ["class", "search-pik-header-result__page--body", 3, "innerHTML", 4, "ngIf"], ["class", "search-pik-header-result__page--tags", 4, "ngIf"], ["class", "search-pik-header-result__space--title", 4, "ngIf"], [1, "search-pik-header-result__page--body", 3, "innerHTML"], [1, "search-pik-header-result__page--tags"], [1, "search-pik-header-result__space--title"], [1, "search-pik-header-result__message"]], template: function SearchResultComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SearchResultComponent_div_0_Template, 6, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", (ctx.searchResults == null ? null : ctx.searchResults.count) > 0 || (ctx.searchResults == null ? null : ctx.searchResults.message));
    } }, directives: [ɵngcc5.NgIf, ɵngcc5.NgForOf, CommonUserImageComponent], pipes: [HighlightPipe, SafeHtmlPipe], styles: [".search-pik-header-result{max-height:500px;border-top:1px solid #d8d8d8;overflow-y:auto;padding-bottom:5px;display:flex;flex-direction:column}.search-pik-header-result .search-highlight{background-color:rgba(239,78,35,.2)}.search-pik-header-result :host{-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;box-sizing:border-box}.search-pik-header-result *,.search-pik-header-result :after,.search-pik-header-result :before{box-sizing:inherit}.search-pik-header-result highlight{background-color:rgba(239,78,35,.2)}.search-pik-header-result__title{margin:1.5rem;font-weight:500}.search-pik-header-result__title a{text-decoration:none;font-weight:inherit;color:#212121}.search-pik-header-result__message{font-size:16px;padding:1.1rem 1.1rem 1.1rem 1.5rem}.search-pik-header-result__list--departments .search-pik-header-result__item,.search-pik-header-result__list--news .search-pik-header-result__item,.search-pik-header-result__list--pages .search-pik-header-result__item{padding:.5rem 1.5rem}a.search-pik-header-result__item{display:block;padding:.8rem 1.5rem;text-decoration:none;color:inherit;cursor:pointer;transition:.2s;border:1px solid transparent;border-left-width:3px}a.search-pik-header-result__item:focus,a.search-pik-header-result__item:hover{border:1px solid #d6d6d6;border-left:3px solid #ef4e23;outline:none}.search-pik-header-result__news,.search-pik-header-result__page,.search-pik-header-result__space,.search-pik-header-result__user{display:flex;flex-flow:row nowrap}.search-pik-header-result__news--tags,.search-pik-header-result__news--title,.search-pik-header-result__page--tags,.search-pik-header-result__page--title,.search-pik-header-result__space--tags,.search-pik-header-result__space--title,.search-pik-header-result__user--tags,.search-pik-header-result__user--title{color:#6b6e72}.search-pik-header-result__news--tags span:first-child,.search-pik-header-result__news--title span:first-child,.search-pik-header-result__page--tags span:first-child,.search-pik-header-result__page--title span:first-child,.search-pik-header-result__space--tags span:first-child,.search-pik-header-result__space--title span:first-child,.search-pik-header-result__user--tags span:first-child,.search-pik-header-result__user--title span:first-child{font-weight:700}.search-pik-header-result__user-photo{flex:0 0 auto;width:3.5rem;height:3.5rem;margin-right:1.5rem;border:1px solid #d8d8d8;border-radius:10rem;overflow:hidden}.search-pik-header-result__news--info,.search-pik-header-result__page--info,.search-pik-header-result__user--info{font-size:.875rem}.search-pik-header-result__news--title,.search-pik-header-result__page--title,.search-pik-header-result__user--name{font-weight:500;color:#4280cc}.search-pik-header-result__user--birthday,.search-pik-header-result__user--vacation{color:#ef4e23;display:flex}.search-pik-header-result__icon{margin-right:.5rem;height:1rem;width:1rem}@media (max-width:1024px){.search-pik-header-result{max-height:calc(100vh - 4.125rem - 2.875rem)}}"], encapsulation: 2 });
SearchResultComponent.ctorParameters = () => [
    { type: EmployeeService },
    { type: UnitService },
    { type: Router },
    { type: PikAuthService },
    { type: SearchService },
    { type: PikLocatorService }
];
SearchResultComponent.propDecorators = {
    searchResults: [{ type: Input }],
    limit: [{ type: Input }],
    selectedItemIndex: [{ type: Input }],
    setKeyword: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchResultComponent, [{
        type: Component,
        args: [{
                selector: 'app-search-pik-header-result',
                template: "<div *ngIf=\"searchResults?.count > 0 || searchResults?.message\" class=\"search-pik-header-result\"\n  (keydown)=\"onKeyDown($event)\">\n  <div *ngIf=\"searchResults.employees.items?.length\" [style.order]=\"categoryOrder['employee']\">\n    <h3 class=\"search-pik-header-result__title\">\n      <a href=\"{{getResultsSectionLink('employees')}}\">\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0438 {{getCountText(searchResults.employees)}}</a>\n    </h3>\n    <div class=\"search-pik-header-result__list\">\n\n      <a class=\"search-pik-header-result__item\" href=\"{{employeeService.getEmployeeUrl(e)}}\" *ngFor=\"let e of searchResults.employees.items let idx=index\">\n        <div class=\"search-pik-header-result__user\">\n          <div class=\"search-pik-header-result__user-photo\">\n            <app-common-user-image [employee]=\"e\" [cssClass]=\"''\"></app-common-user-image>\n          </div>\n          <div class=\"search-pik-header-result__user--info\">\n            <div class=\"search-pik-header-result__user--name\" [innerHTML]=\"e.name | highlight: query\"></div>\n            <span class=\"search-pik-header-result__user--position\" *ngIf=\"e.position\" [innerHTML]=\"e.position | highlight: query\"></span>\n            <span *ngIf=\"e.position && e.unitName\">, </span>\n            <span class=\"search-pik-header-result__user--position\" *ngIf=\"e.unitName\" [innerHTML]=\"e.unitName | highlight: query\"></span>\n            <div class=\"search-pik-header-result__user--contacts\">\n              <span *ngIf=\"e.workPhone\" [innerHTML]=\"e.workPhone | highlight: query: true\"></span>\n              <ng-container *ngIf=\"e.workPhone && e.internalPhone && (e.internalPhone!=e.workPhone)\">, </ng-container>\n              <span *ngIf=\"e.internalPhone && (e.internalPhone!=e.workPhone)\" [innerHTML]=\"e.internalPhone\"></span>\n              <ng-container *ngIf=\"e.mobilePhone && (e.workPhone || e.internalPhone && (e.internalPhone!=e.workPhone))\">,\n              </ng-container>\n              <span *ngIf=\"e.mobilePhone\" [innerHTML]=\"e.mobilePhone | highlight: query: true\"></span>\n              <ng-container *ngIf=\"e.email && (e.internalPhone || e.workPhone || e.mobilePhone)\">, </ng-container>\n              <span *ngIf=\"e.email\" [innerHTML]=\"e.email\"></span>\n            </div>\n            <ng-container *ngIf=\"e.vacations[0]; let vacation\">\n              <div class=\"search-pik-header-result__user--vacation\" *ngIf=\"vacation.started\">\n                <img src=\"data:image/png;base64,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\" alt=\"\" class=\"search-pik-header-result__icon\" />\n                <span>{{ vacation.text }}</span>\n              </div>\n              <div class=\"search-pik-header-result__user--vacation\" *ngIf=\"!vacation.started\">\n                <img src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4gICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJub256ZXJvIj4gICAgICAgIDxwYXRoIGZpbGw9IiM4MDUzMzMiIGQ9Ik0yOS44NzEgMzAuNjlIMi4xM0EyLjEyOCAyLjEyOCAwIDAgMSAwIDI4LjU2VjEwLjE5OGMwLTEuMTc2Ljk1My0yLjEyOSAyLjEyOS0yLjEyOUgyOS44N2MxLjE3NiAwIDIuMTI5Ljk1MyAyLjEyOSAyLjEyOVYyOC41NmEyLjEyOCAyLjEyOCAwIDAgMS0yLjEyOSAyLjEyOXoiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNDQjgyNTIiIGQ9Ik01LjUxNyA2LjQxNGgzLjMxVjMwLjY5aC0zLjMxek0yMy4xNzIgNi40MTRoMy4zMVYzMC42OWgtMy4zMXoiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNCREMzQzciIGQ9Ik0xNiAyYTUuNTI0IDUuNTI0IDAgMCAwLTUuNTE3IDUuNTE3di41NTJoMi4yMDd2LS41NTJBMy4zMiAzLjMyIDAgMCAxIDE2IDQuMjA3YTMuMzIgMy4zMiAwIDAgMSAzLjMxIDMuMzF2LjU1MmgyLjIwN3YtLjU1MkE1LjUyNCA1LjUyNCAwIDAgMCAxNiAyeiIvPiAgICAgICAgPHBhdGggZmlsbD0iIzcxQzI4NSIgZD0iTTExLjY4MyAxOS42M2w0LjYyOCAxLjk1My0xLjMwMyAzLjA4Ni00LjYyNy0xLjk1M3oiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNFMTcwNUMiIGQ9Ik0xMi42OSAxNi44OTd2My4xNThsMy42MjMgMS41MjktLjM1LjgzaDUuMDAzdi01LjUxN3oiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNGMEM0MTkiIGQ9Ik0xOS42MTcgMTYuODk3bDEuMzQ5LS42My0xLjkxMi00LjA5My02LjE0IDIuODY3Ljg2NyAxLjg1NnoiLz4gICAgICAgIDxwYXRoIGZpbGw9IiNFNEMwNUMiIGQ9Ik0zMiAxMS44NTR2LTEuNjU2YTIuMTI4IDIuMTI4IDAgMCAwLTIuMTI5LTIuMTI5aC0xLjY1NkE0LjY4OSA0LjY4OSAwIDAgMCAzMiAxMS44NTR6TTMyIDI4LjU2MXYtMS42NTZhNC42ODkgNC42ODkgMCAwIDAtMy43ODUgMy43ODVoMS42NTZBMi4xMjggMi4xMjggMCAwIDAgMzIgMjguNTZ6TTAgMTEuODU0YTQuNjg5IDQuNjg5IDAgMCAwIDMuNzg1LTMuNzg1SDIuMTI5QTIuMTI4IDIuMTI4IDAgMCAwIDAgMTAuMTk4djEuNjU2ek0wIDI2LjkwNXYxLjY1NmMwIDEuMTc2Ljk1MyAyLjEyOSAyLjEyOSAyLjEyOWgxLjY1NkE0LjY4OSA0LjY4OSAwIDAgMCAwIDI2LjkwNXoiLz4gICAgPC9nPjwvc3ZnPg==\"\n                  alt=\"\" class=\"search-pik-header-result__icon\" />\n                <span>{{ vacation.text }}</span>\n              </div>\n            </ng-container>\n            <div class=\"search-pik-header-result__user--birthday\" *ngIf=\"e.birthdayToday\">\n              <img src=\"data:image/png;base64,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\" alt=\"\" class=\"search-pik-header-result__icon\">\n              <span>\u0414\u0435\u043D\u044C \u0420\u043E\u0436\u0434\u0435\u043D\u0438\u044F</span>\n            </div>\n          </div>\n        </div>\n      </a>\n    </div>\n  </div>\n\n  <div *ngIf=\"searchResults?.units?.items?.length\" [style.order]=\"categoryOrder['unit']\">\n    <h3 class=\"search-pik-header-result__title\">\n        <a href=\"{{getResultsSectionLink('units')}}\">\u041F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F {{getCountText(searchResults.units)}}</a>\n    </h3>\n    <div class=\"search-pik-header-result__list--departments\">\n      <a class=\"search-pik-header-result__item\" href=\"{{unitService.getUnitUrl(u)}}\" *ngFor=\"let u of searchResults.units.items\">\n        <div class=\"search-pik-header-result__user\">\n          <div class=\"search-pik-header-result__user--info\">\n            <div class=\"search-pik-header-result__user--name\" [innerHTML]=\"u.title | highlight: query\"></div>\n          </div>\n        </div>\n      </a>\n    </div>\n  </div>\n\n  <div *ngIf=\"searchResults?.news?.items?.length\" [style.order]=\"categoryOrder['news']\">\n    <h3 class=\"search-pik-header-result__title\">\n        <a href=\"{{getResultsSectionLink('news')}}\">\u041D\u043E\u0432\u043E\u0441\u0442\u0438 {{getCountText(searchResults.news)}}</a>\n    </h3>\n    <div class=\"search-pik-header-result__list--news\">\n      <a class=\"search-pik-header-result__item\" href=\"{{getNewsUrl(n)}}\" *ngFor=\"let n of searchResults.news.items\">\n        <div class=\"search-pik-header-result__news\">\n          <div class=\"search-pik-header-result__news--info\">\n            <div class=\"search-pik-header-result__news--title\" [innerHTML]=\"n.title | highlight: query\"></div>\n            <div class=\"search-pik-header-result__news--announce\" *ngIf=\"n.announce\" [innerHTML]=\"n.announce | highlight: query\"></div>\n          </div>\n        </div>\n      </a>\n    </div>\n  </div>\n\n  <div *ngIf=\"searchResults?.pages?.items?.length\" [style.order]=\"categoryOrder['pages']\">\n    <h3 class=\"search-pik-header-result__title\">\n        <a href=\"{{getResultsSectionLink('pages')}}\">\u0420\u0430\u0437\u0434\u0435\u043B\u044B \u0431\u0430\u0437\u044B \u0437\u043D\u0430\u043D\u0438\u0439 {{getCountText(searchResults.pages)}}</a>\n    </h3>\n    <div class=\"search-pik-header-result__list--pages\">\n      <a class=\"search-pik-header-result__item\" href=\"{{getPageUrl(p)}}\" *ngFor=\"let p of searchResults.pages.items\">\n        <div class=\"search-pik-header-result__page\">\n          <div class=\"search-pik-header-result__page--info\">\n            <div class=\"search-pik-header-result__page--title\" [innerHTML]=\"p.title | safeHtml\"></div>\n            <div class=\"search-pik-header-result__page--body\" *ngIf=\"p.body\" [innerHTML]=\"p.body | safeHtml\"></div>\n            <div class=\"search-pik-header-result__page--tags\" *ngIf=\"p.tags\">\n              <span>\u0422\u0435\u0433\u0438: </span>\n              <span [innerHTML]=\"p.tags | safeHtml\"></span>\n            </div>\n            <div class=\"search-pik-header-result__space--title\" *ngIf=\"p.spaceTitle\">\n              <span>\u041F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u043E: </span>\n              <span [innerHTML]=\"p.spaceTitle\"></span>\n            </div>\n          </div>\n        </div>\n      </a>\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"searchResults?.message\">\n    <div class=\"search-pik-header-result__message\">\n      <span *ngIf=\"searchResults?.error\">\u041E\u0448\u0438\u0431\u043A\u0430: </span>\n      {{searchResults?.message}}\n    </div>\n  </ng-container>\n\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".search-pik-header-result{max-height:500px;border-top:1px solid #d8d8d8;overflow-y:auto;padding-bottom:5px;display:flex;flex-direction:column}.search-pik-header-result .search-highlight{background-color:rgba(239,78,35,.2)}.search-pik-header-result :host{-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;box-sizing:border-box}.search-pik-header-result *,.search-pik-header-result :after,.search-pik-header-result :before{box-sizing:inherit}.search-pik-header-result highlight{background-color:rgba(239,78,35,.2)}.search-pik-header-result__title{margin:1.5rem;font-weight:500}.search-pik-header-result__title a{text-decoration:none;font-weight:inherit;color:#212121}.search-pik-header-result__message{font-size:16px;padding:1.1rem 1.1rem 1.1rem 1.5rem}.search-pik-header-result__list--departments .search-pik-header-result__item,.search-pik-header-result__list--news .search-pik-header-result__item,.search-pik-header-result__list--pages .search-pik-header-result__item{padding:.5rem 1.5rem}a.search-pik-header-result__item{display:block;padding:.8rem 1.5rem;text-decoration:none;color:inherit;cursor:pointer;transition:.2s;border:1px solid transparent;border-left-width:3px}a.search-pik-header-result__item:focus,a.search-pik-header-result__item:hover{border:1px solid #d6d6d6;border-left:3px solid #ef4e23;outline:none}.search-pik-header-result__news,.search-pik-header-result__page,.search-pik-header-result__space,.search-pik-header-result__user{display:flex;flex-flow:row nowrap}.search-pik-header-result__news--tags,.search-pik-header-result__news--title,.search-pik-header-result__page--tags,.search-pik-header-result__page--title,.search-pik-header-result__space--tags,.search-pik-header-result__space--title,.search-pik-header-result__user--tags,.search-pik-header-result__user--title{color:#6b6e72}.search-pik-header-result__news--tags span:first-child,.search-pik-header-result__news--title span:first-child,.search-pik-header-result__page--tags span:first-child,.search-pik-header-result__page--title span:first-child,.search-pik-header-result__space--tags span:first-child,.search-pik-header-result__space--title span:first-child,.search-pik-header-result__user--tags span:first-child,.search-pik-header-result__user--title span:first-child{font-weight:700}.search-pik-header-result__user-photo{flex:0 0 auto;width:3.5rem;height:3.5rem;margin-right:1.5rem;border:1px solid #d8d8d8;border-radius:10rem;overflow:hidden}.search-pik-header-result__news--info,.search-pik-header-result__page--info,.search-pik-header-result__user--info{font-size:.875rem}.search-pik-header-result__news--title,.search-pik-header-result__page--title,.search-pik-header-result__user--name{font-weight:500;color:#4280cc}.search-pik-header-result__user--birthday,.search-pik-header-result__user--vacation{color:#ef4e23;display:flex}.search-pik-header-result__icon{margin-right:.5rem;height:1rem;width:1rem}@media (max-width:1024px){.search-pik-header-result{max-height:calc(100vh - 4.125rem - 2.875rem)}}"]
            }]
    }], function () { return [{ type: EmployeeService }, { type: UnitService }, { type: ɵngcc2.Router }, { type: PikAuthService }, { type: SearchService }, { type: PikLocatorService }]; }, { setKeyword: [{
            type: Input
        }], searchResults: [{
            type: Input
        }], limit: [{
            type: Input
        }], selectedItemIndex: [{
            type: Input
        }] }); })();

class PikHeaderModule {
    static forRoot() {
        return {
            ngModule: PikHeaderModule,
            providers: [NavigationService],
        };
    }
}
PikHeaderModule.ɵfac = function PikHeaderModule_Factory(t) { return new (t || PikHeaderModule)(); };
PikHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikHeaderModule });
PikHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        DatePipe,
        NavigationService,
        NotificationService,
        PikHeaderService,
    ], imports: [[
            FormsModule,
            ReactiveFormsModule,
            CommonModule,
            PikCommonModule.forChild(),
            PikOrgstructureModule.forRoot(),
            PerfectScrollbarModule,
            RouterModule
        ], CommonModule,
        FormsModule,
        ReactiveFormsModule, PikCommonModule, PikOrgstructureModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    CommonModule,
                    PikCommonModule.forChild(),
                    PikOrgstructureModule.forRoot(),
                    PerfectScrollbarModule,
                    RouterModule
                ],
                declarations: [
                    BaseSearchInputComponent,
                    HeaderComponent,
                    HeaderSearchComponent,
                    StatusBarComponent,
                    SvgComponent,
                    NotificationsComponent,
                    SearchResultComponent
                ],
                exports: [
                    HeaderComponent,
                    HeaderSearchComponent,
                    StatusBarComponent,
                    NotificationsComponent,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    PikCommonModule,
                    PikOrgstructureModule,
                    SearchResultComponent
                ],
                providers: [
                    DatePipe,
                    NavigationService,
                    NotificationService,
                    PikHeaderService,
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikHeaderModule, { declarations: function () { return [BaseSearchInputComponent, HeaderComponent, HeaderSearchComponent, StatusBarComponent, SvgComponent, NotificationsComponent, SearchResultComponent]; }, imports: function () { return [FormsModule,
        ReactiveFormsModule,
        CommonModule, PikCommonModule, PikOrgstructureModule, PerfectScrollbarModule,
        RouterModule]; }, exports: function () { return [HeaderComponent, HeaderSearchComponent, StatusBarComponent, NotificationsComponent, CommonModule,
        FormsModule,
        ReactiveFormsModule, PikCommonModule, PikOrgstructureModule, SearchResultComponent]; } }); })();

/**
 * Элемент навигации
 */
class NavigationNode {
}

class Notification {
}

var PageStatusColor;
(function (PageStatusColor) {
    PageStatusColor[PageStatusColor["Blue"] = 0] = "Blue";
    PageStatusColor[PageStatusColor["Green"] = 1] = "Green";
    PageStatusColor[PageStatusColor["Yellow"] = 2] = "Yellow";
    PageStatusColor[PageStatusColor["Red"] = 3] = "Red";
})(PageStatusColor || (PageStatusColor = {}));

class Employee {
    constructor() {
    }
}

/**
 * Модель новости для отображения в результатах поиска
 *
 * @export
 * @class NewsSearch
 */
class NewsSearch {
}

/**
 * Модель страницы базы знаний для отображения в результатах поиска
 */
class PagesSearch {
}

var SelectedUnit;
(function (SelectedUnit) {
    SelectedUnit[SelectedUnit["unselected"] = 0] = "unselected";
    SelectedUnit[SelectedUnit["selected"] = 1] = "selected";
    SelectedUnit[SelectedUnit["partiallySelected"] = 2] = "partiallySelected";
})(SelectedUnit || (SelectedUnit = {}));

class Unit {
    constructor(title, id, parentId, order, selected, rootId) {
        this.title = title;
        this.id = id;
        this.parentId = parentId;
        this.order = order;
        this.selected = selected;
        this.rootId = rootId;
        this.children = [];
    }
}

class VacationEmployee {
}

class PikAnalyticsModule {
    static forRoot(config) {
        return {
            ngModule: PikAnalyticsModule,
            providers: [
                {
                    provide: GA_CONFIG,
                    useValue: config,
                },
            ],
        };
    }
}
PikAnalyticsModule.ɵfac = function PikAnalyticsModule_Factory(t) { return new (t || PikAnalyticsModule)(); };
PikAnalyticsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PikAnalyticsModule });
PikAnalyticsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [GoogleAnalyticsService], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PikAnalyticsModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [CommonModule],
                providers: [GoogleAnalyticsService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PikAnalyticsModule, { imports: function () { return [CommonModule]; } }); })();

// pik-auth

/**
 * Generated bundle index. Do not edit.
 */

export { AuthCallbackComponent, AutoFocusDirective, BaseSearchComponent, BaseSearchInputComponent, BaseService, ClickOutsideDirective, CommonUserImageComponent, Employee, EmployeeService, ForbiddenComponent, GAConfig, GA_CONFIG, GoogleAnalyticsService, HeaderComponent, HeaderSearchComponent, HeaderUserImageComponent, HighlightPipe, LocalStorageService, MarketService, Meta, NavigationNode, NavigationService, NewsSearch, NotFoundComponent, Notification, NotificationService, NotificationsComponent, PIK_AUTH_CONFIG, PIK_CONFIG, PRODUCTION_SERVICES_LIST, PageStatusColor, PagesSearch, PikAnalyticsModule, PikAnonymousGuard, PikAuthGuard, PikAuthInterceptor, PikAuthModule, PikAuthRedirectService, PikAuthRoutingModule, PikAuthService, PikAuthenticatedGuard, PikAutoLoginGuard, PikCommonModule, PikConfig, PikEnvironment, PikErrorPagesModule, PikErrorPagesRoutingModule, PikGuard, PikHeaderModule, PikLocatorService, PikOrgstructureModule, PikSecurityStorageService, PikStorageModule, PortalService, SafeHtmlPipe, SearchResult, SearchResultComponent, SearchResults, SearchService, SelectedUnit, SessionStorageService, StatusBarComponent, SvgComponent, TESTING_SERVICES_LIST, UnauthorizedComponent, Unit, UnitService, VacationEmployee, WebStorageService, WikiService, createAuthWellKnownEndpoints, createOpenIdConfiguration, pikAuthConfigFactory, ɵ0, PikHeaderService as ɵa };

